var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclesImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 629,
    viewBox: "0 0 629 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 314.5,
    r: 314.5,
    fill: "white",
    fillOpacity: 0.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 314.5,
    r: 313.926,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 1.14701
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 314.5,
    r: 249.5,
    fill: "white",
    fillOpacity: 0.03
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 314.5,
    r: 248.926,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 1.14701
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 314.5,
    r: 184.5,
    fill: "white",
    fillOpacity: 0.03
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 314.5,
    r: 183.926,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 1.14701
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M278.807 375.15L347.394 348.757C351.254 346.522 356.13 345.328 361.005 345.379C363.1 345.404 365.093 345.683 366.934 346.141C368.687 346.572 370.718 347.423 372.14 348.249L422.863 377.97C422.914 377.995 424.336 378.834 424.374 378.872C428.386 381.285 430.215 385.044 429.999 389.096C429.77 393.249 426.647 397.949 422.152 400.553L379.974 441.197C376.19 443.381 371.442 444.588 366.642 444.588C362.465 444.588 358.656 443.686 355.66 441.959L277.512 396.095C273.576 393.821 271.341 390.239 271.354 386.277C271.354 381.945 274.071 377.894 278.807 375.15Z",
    fill: "#9FA5D0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M279.112 375.214L347.699 348.82C351.546 346.598 356.422 345.442 361.246 345.531C363.341 345.582 365.309 345.912 367.125 346.382C368.699 346.788 370.985 347.804 372.267 348.541L422.711 378.109C422.8 378.16 424.133 378.948 424.209 379.011C428.145 381.45 429.44 385.184 429.009 389.185C428.602 392.906 425.136 398.076 421.099 400.413L379.695 440.688C376 442.822 371.366 443.991 366.681 444.004C362.605 444.016 358.885 443.14 355.965 441.451L277.817 395.129C274.033 392.945 271.925 389.541 271.963 385.781C271.976 381.679 274.566 377.83 279.112 375.214Z",
    fill: "#8F95BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M279.404 375.264L347.991 348.871C351.825 346.661 356.714 345.531 361.475 345.683C363.557 345.747 365.512 346.128 367.29 346.623C368.674 347.004 371.239 348.185 372.369 348.846L422.533 378.249C422.673 378.325 423.904 379.075 424.019 379.164C427.866 381.641 428.653 385.311 427.98 389.274C427.421 392.551 423.587 398.19 419.994 400.261L379.365 440.168C375.759 442.251 371.226 443.394 366.681 443.407C362.719 443.419 359.063 442.568 356.231 440.93L278.083 394.139C274.465 392.043 272.471 388.817 272.522 385.273C272.598 381.412 275.061 377.767 279.404 375.264Z",
    fill: "#7F84A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M279.708 375.315L348.296 348.922C352.105 346.725 357.018 345.632 361.716 345.823C363.786 345.912 365.716 346.344 367.48 346.852C368.687 347.207 371.505 348.554 372.496 349.125L422.381 378.363C422.571 378.478 423.701 379.164 423.841 379.291C427.599 381.805 428.729 385.679 426.977 389.337C426.977 392.246 422.076 398.279 418.927 400.095L379.072 439.621C375.555 441.654 371.137 442.759 366.719 442.771C362.859 442.784 359.291 441.971 356.536 440.384L278.388 393.135C274.934 391.141 273.055 388.08 273.131 384.739C273.208 381.145 275.569 377.716 279.708 375.315Z",
    fill: "#6F7492"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M280 375.379L348.588 348.986C352.384 346.788 357.298 345.734 361.945 345.988C364.014 346.103 365.919 346.585 367.658 347.119C368.699 347.436 371.759 348.96 372.61 349.456L422.216 378.529C422.457 378.669 423.485 379.304 423.663 379.456C427.332 382.009 428.158 385.908 425.961 389.452C425.961 391.941 420.54 398.432 417.835 399.981L378.755 439.139C375.327 441.121 371.023 442.187 366.731 442.213C362.973 442.238 359.494 441.451 356.815 439.901L278.667 392.183C275.366 390.277 273.614 387.394 273.715 384.257C273.83 380.879 276.064 377.652 280 375.379Z",
    fill: "#5F637D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M280.305 375.429L348.892 349.036C352.676 346.852 357.602 345.836 362.186 346.128C364.243 346.267 366.122 346.801 367.836 347.347C368.699 347.626 372.026 349.328 372.724 349.748L422.051 378.656C422.33 378.821 423.27 379.405 423.485 379.595C427.066 382.186 427.586 386.111 424.958 389.528C424.958 391.611 419.016 398.533 416.769 399.828L378.463 438.618C375.124 440.549 370.921 441.577 366.769 441.616C363.125 441.641 359.723 440.892 357.12 439.38L278.972 391.204C275.836 389.388 274.198 386.683 274.325 383.749C274.452 380.612 276.559 377.589 280.305 375.429Z",
    fill: "#505368"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M280.597 375.48L349.184 349.087C352.955 346.915 357.894 345.925 362.414 346.267C364.458 346.433 366.325 347.017 368.013 347.576C368.699 347.804 372.279 349.697 372.851 350.027L421.898 378.77C422.228 378.96 423.079 379.494 423.32 379.71C426.812 382.339 427.04 386.289 423.955 389.579C423.955 391.243 417.492 398.622 415.702 399.651L378.171 438.072C374.933 439.939 370.832 440.955 366.807 440.981C363.265 441.006 359.951 440.282 357.424 438.821L279.276 390.188C276.305 388.474 274.794 385.933 274.921 383.215C275.061 380.345 277.054 377.525 280.597 375.48Z",
    fill: "#404253"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M280.902 375.531L349.489 349.138C353.235 346.979 358.186 346.026 362.656 346.42C364.7 346.598 366.528 347.233 368.204 347.817C368.712 347.995 372.546 350.078 372.978 350.332L421.746 378.923C422.127 379.139 422.876 379.621 423.155 379.875C426.571 382.542 426.482 386.518 422.965 389.693C422.965 390.938 415.982 398.762 414.636 399.537L377.892 437.59C374.743 439.406 370.756 440.384 366.858 440.422C363.43 440.46 360.192 439.762 357.742 438.352L279.594 389.249C276.775 387.623 275.391 385.261 275.544 382.746C275.683 380.078 277.55 377.475 280.902 375.531Z",
    fill: "#30323E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M281.194 375.595L349.781 349.201C353.514 347.042 358.478 346.128 362.884 346.572C364.915 346.776 366.718 347.461 368.369 348.071C368.712 348.198 372.787 350.472 373.079 350.637L421.568 379.062C422 379.303 422.647 379.735 422.965 380.015C426.291 382.72 425.898 386.721 421.936 389.769C421.936 390.595 414.432 398.863 413.544 399.384L377.574 437.069C374.514 438.834 370.629 439.774 366.871 439.825C363.544 439.863 360.395 439.202 358.021 437.831L279.873 388.27C277.22 386.734 275.95 384.549 276.128 382.237C276.305 379.811 278.058 377.411 281.194 375.595Z",
    fill: "#20212A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M281.498 375.645L350.086 349.252C353.806 347.105 358.783 346.229 363.138 346.724C365.157 346.953 366.934 347.69 368.572 348.312C368.737 348.376 373.079 350.865 373.219 350.941L421.428 379.202C421.898 379.481 422.457 379.849 422.812 380.167C426.05 382.91 425.352 386.949 420.959 389.858C420.959 390.277 412.947 398.99 412.49 399.244L377.295 436.548C374.324 438.262 370.553 439.177 366.922 439.228C363.709 439.266 360.637 438.643 358.339 437.31L280.191 387.279C277.702 385.844 276.547 383.825 276.737 381.716C276.915 379.544 278.553 377.347 281.498 375.645Z",
    fill: "#101115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.618 436.789L280.47 386.302C275.759 383.584 276.356 378.833 281.79 375.696L350.378 349.303C355.812 346.166 364.027 345.823 368.737 348.541L421.263 379.329C425.974 382.047 425.377 386.797 419.943 389.934L376.99 436.027C371.543 439.164 363.328 439.507 358.618 436.789Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.618 436.688L280.47 391.281C278.375 390.074 277.321 388.461 277.296 386.759C277.296 386.708 277.296 375.823 277.296 375.772C277.334 373.715 278.858 377.284 281.791 375.595L350.378 349.201C355.812 346.064 364.027 345.721 368.737 348.439L421.264 379.227C422.838 380.129 423.968 376.281 424.387 377.513C424.527 377.919 424.438 388.41 424.45 388.829C424.501 390.938 422.978 393.173 419.956 394.913L377.003 435.926C371.543 439.063 363.329 439.406 358.618 436.688Z",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.618 425.802L280.47 380.395C275.76 377.677 276.356 372.927 281.79 369.79L350.378 343.397C355.812 340.26 364.027 339.917 368.737 342.635L421.263 373.422C425.974 376.141 425.377 380.891 419.943 384.028L376.99 425.04C371.543 428.177 363.328 428.52 358.618 425.802Z",
    fill: "url(#paint1_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.264 373.422L368.737 342.635C364.027 339.917 355.812 340.26 350.378 343.397L315.83 356.695C316.161 356.949 316.503 357.203 316.91 357.432L395.058 402.839C396.137 403.461 397.419 403.918 398.79 404.223L419.943 384.028C425.377 380.891 425.961 376.141 421.264 373.422Z",
    fill: "url(#paint2_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.943 383.038L376.99 424.05C371.556 427.187 363.341 427.53 358.631 424.812L280.483 379.405C278.527 378.275 277.499 376.802 277.347 375.227C277.105 377.144 278.134 379.024 280.483 380.383L358.631 426.133C363.341 428.851 371.556 428.508 376.99 425.371L419.943 384.003C423.117 382.161 424.628 379.786 424.399 377.576C424.158 379.507 422.647 381.476 419.943 383.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.725 426.057L268.802 315.124C258.987 309.459 251.039 294.256 251.039 281.161V134.322C251.039 121.24 258.987 115.219 268.802 120.884L460.725 231.817C470.539 237.481 478.487 252.685 478.487 265.78V412.619C478.487 425.701 470.539 431.722 460.725 426.057Z",
    fill: "url(#paint3_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.01 415.832L273.792 306.475C265.894 301.458 261.006 291.424 261.006 281.161V133.357C261.006 130.931 263.647 129.419 265.755 130.639C265.996 130.778 266.199 130.893 266.313 130.969L455.735 240.466C465.13 245.89 468.52 255.517 468.52 265.78V413.114C468.52 415.718 465.702 417.356 463.442 416.061C463.251 415.972 463.099 415.883 463.01 415.832Z",
    fill: "url(#paint4_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.735 240.466L266.301 130.969C266.186 130.906 265.983 130.791 265.742 130.639C263.647 129.407 260.993 130.918 260.993 133.357V281.161C260.993 291.424 265.882 301.458 273.779 306.475L462.997 415.832C463.086 415.883 463.239 415.972 463.416 416.074C465.676 417.369 468.495 415.731 468.495 413.127V265.793C468.508 255.517 465.13 245.89 455.735 240.466ZM466.514 413.114C466.514 413.978 465.778 414.524 465.105 414.524C464.864 414.524 464.635 414.461 464.419 414.334L274.795 304.747C267.659 300.213 263.012 290.941 263.012 281.161V133.357C263.012 132.646 263.609 132.201 264.168 132.201C264.371 132.201 264.561 132.252 264.752 132.366L454.744 242.194C464.483 247.808 466.527 258.121 466.527 265.78V413.114H466.514Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.901 227.066L276.966 116.134C273.081 113.886 269.487 113.479 266.567 114.61C266.199 114.749 258.099 119.462 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.526 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 480.976 421.967 481.192 421.815C484.569 419.452 486.664 414.587 486.664 407.869V261.03C486.664 247.947 478.716 232.744 468.901 227.066Z",
    fill: "url(#paint5_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.749 227.168L276.826 116.235C272.941 113.987 269.348 113.581 266.428 114.711C266.059 114.851 258.111 119.461 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.816C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.785 475.377 426.196 470.666 427.733C471.047 427.758 471.53 427.606 472.228 427.2C472.456 427.073 480.824 422.056 481.039 421.916C484.417 419.553 486.512 414.689 486.512 407.97V261.131C486.512 248.036 478.564 232.833 468.749 227.168Z",
    fill: "url(#paint6_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.597 227.27L276.674 116.325C272.789 114.077 269.195 113.67 266.275 114.801C265.907 114.94 258.111 119.449 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.192 264.612 118.459 268.789 120.884L460.712 231.817C470.527 237.482 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.197 470.666 427.734C471.047 427.759 471.53 427.607 472.228 427.2C472.456 427.073 480.671 422.158 480.887 422.005C484.264 419.643 486.359 414.778 486.359 408.059V261.233C486.372 248.138 478.411 232.935 468.597 227.27Z",
    fill: "url(#paint7_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.444 227.371L276.521 116.426C272.636 114.178 269.043 113.772 266.123 114.902C265.755 115.042 258.099 119.462 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.192 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.482 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.197 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 480.519 422.259 480.735 422.107C484.112 419.744 486.207 414.88 486.207 408.161V261.322C486.22 248.24 478.259 233.036 468.444 227.371Z",
    fill: "url(#paint8_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.305 227.473L276.369 116.527C272.484 114.279 268.891 113.873 265.971 115.003C265.602 115.143 258.099 119.461 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.758 471.53 427.606 472.228 427.2C472.456 427.073 480.366 422.36 480.582 422.208C483.96 419.846 486.055 414.981 486.055 408.262V261.423C486.067 248.341 478.106 233.137 468.305 227.473Z",
    fill: "url(#paint9_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.152 227.562L276.229 116.629C272.344 114.381 268.751 113.975 265.831 115.105C265.463 115.245 258.111 119.462 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.192 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.482 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 480.227 422.462 480.443 422.31C483.82 419.947 485.915 415.083 485.915 408.364V261.525C485.915 248.43 477.967 233.227 468.152 227.562Z",
    fill: "url(#paint10_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 227.663L276.077 116.731C272.192 114.482 268.599 114.076 265.679 115.206C265.31 115.346 258.111 119.461 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.785 475.377 426.196 470.666 427.733C471.047 427.758 471.53 427.606 472.228 427.2C472.456 427.073 480.074 422.551 480.29 422.399C483.668 420.036 485.763 415.172 485.763 408.453V261.626C485.763 248.531 477.814 233.328 468 227.663Z",
    fill: "url(#paint11_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.848 227.765L275.925 116.82C272.04 114.572 268.446 114.165 265.526 115.295C265.158 115.435 258.111 119.449 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 479.922 422.653 480.138 422.5C483.515 420.138 485.61 415.273 485.61 408.554V261.715C485.623 248.633 477.662 233.43 467.848 227.765Z",
    fill: "url(#paint12_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.708 227.867L275.772 116.921C271.887 114.673 268.294 114.267 265.374 115.397C265.006 115.537 258.099 119.462 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.192 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.482 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.197 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 479.77 422.755 479.986 422.602C483.363 420.24 485.458 415.375 485.458 408.656V261.817C485.471 248.735 477.51 233.532 467.708 227.867Z",
    fill: "url(#paint13_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.556 227.955L275.62 117.023C271.735 114.775 268.142 114.368 265.221 115.499C264.853 115.638 258.099 119.461 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 479.63 422.856 479.833 422.703C483.211 420.341 485.305 415.476 485.305 408.757V261.919C485.318 248.836 477.37 233.633 467.556 227.955Z",
    fill: "url(#paint14_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.403 228.057L275.48 117.124C271.595 114.876 268.002 114.47 265.082 115.6C264.714 115.74 258.111 119.461 257.756 119.652C257.756 119.652 257.743 119.664 257.73 119.664C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.816C470.527 237.481 478.475 252.684 478.475 265.779V412.618C478.475 420.785 475.377 426.196 470.666 427.733C471.047 427.758 471.53 427.606 472.228 427.199C472.456 427.072 479.478 422.945 479.694 422.805C483.071 420.442 485.166 415.578 485.166 408.859V262.02C485.166 248.925 477.218 233.722 467.403 228.057Z",
    fill: "url(#paint15_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.251 228.159L275.328 117.214C271.443 114.966 267.85 114.559 264.929 115.69C264.561 115.829 258.111 119.449 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.192 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.482 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.197 470.666 427.734C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 479.325 423.047 479.541 422.894C482.918 420.532 485.013 415.667 485.013 408.948V262.122C485.013 249.027 477.065 233.824 467.251 228.159Z",
    fill: "url(#paint16_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.098 228.26L275.176 117.315C271.29 115.067 267.697 114.661 264.777 115.791C264.409 115.931 258.111 119.462 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 479.173 423.148 479.389 422.996C482.766 420.633 484.861 415.769 484.861 409.05V262.211C484.874 249.128 476.913 233.925 467.098 228.26Z",
    fill: "url(#paint17_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.959 228.349L275.023 117.416C271.138 115.168 267.545 114.762 264.625 115.892C264.256 116.032 258.099 119.461 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.816C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.785 475.377 426.196 470.666 427.733C471.047 427.758 471.53 427.606 472.228 427.2C472.456 427.073 479.021 423.249 479.236 423.097C482.614 420.735 484.709 415.87 484.709 409.151V262.312C484.721 249.23 476.761 234.026 466.959 228.349Z",
    fill: "url(#paint18_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.807 228.451L274.884 117.518C270.999 115.27 267.405 114.864 264.485 115.994C264.117 116.134 258.111 119.462 257.769 119.652C257.769 119.652 257.756 119.665 257.743 119.665C260.778 118.191 264.625 118.458 268.802 120.884L460.725 231.817C470.539 237.481 478.487 252.685 478.487 265.78V412.619C478.487 420.786 475.39 426.196 470.679 427.733C471.06 427.759 471.542 427.606 472.241 427.2C472.469 427.073 478.894 423.339 479.11 423.199C482.487 420.836 484.582 415.972 484.582 409.253V262.414C484.569 249.319 476.621 234.116 466.807 228.451Z",
    fill: "url(#paint19_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.654 228.552L274.731 117.62C270.846 115.371 267.253 114.965 264.333 116.095C263.964 116.235 258.111 119.461 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.816C470.527 237.481 478.475 252.685 478.475 265.779V412.618C478.475 420.785 475.377 426.196 470.666 427.733C471.047 427.758 471.53 427.606 472.228 427.199C472.456 427.072 478.729 423.44 478.944 423.287C482.322 420.925 484.417 416.06 484.417 409.342V262.515C484.417 249.42 476.469 234.217 466.654 228.552Z",
    fill: "url(#paint20_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.502 228.654L274.579 117.709C270.694 115.461 267.101 115.054 264.18 116.184C263.812 116.324 258.111 119.449 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 478.576 423.542 478.792 423.389C482.169 421.027 484.264 416.162 484.264 409.443V262.604C484.277 249.522 476.316 234.319 466.502 228.654Z",
    fill: "url(#paint21_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.349 228.756L274.427 117.81C270.541 115.562 266.948 115.156 264.028 116.286C263.66 116.426 258.099 119.462 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.192 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.482 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 478.424 423.644 478.64 423.491C482.017 421.129 484.112 416.264 484.112 409.545V262.706C484.125 249.624 476.164 234.421 466.349 228.756Z",
    fill: "url(#paint22_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.21 228.844L274.274 117.912C270.389 115.664 266.796 115.257 263.876 116.388C263.507 116.527 258.099 119.461 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.758 471.53 427.606 472.228 427.2C472.456 427.073 478.284 423.745 478.487 423.592C481.865 421.23 483.96 416.366 483.96 409.647V262.808C483.972 249.725 476.011 234.522 466.21 228.844Z",
    fill: "url(#paint23_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.057 228.946L274.134 118.014C270.249 115.766 266.656 115.359 263.736 116.49C263.368 116.629 258.111 119.462 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 478.132 423.834 478.348 423.694C481.725 421.332 483.82 416.467 483.82 409.748V262.909C483.82 249.814 475.872 234.611 466.057 228.946Z",
    fill: "url(#paint24_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.905 229.048L273.982 118.103C270.097 115.855 266.504 115.448 263.584 116.579C263.215 116.718 258.111 119.449 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.192 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.482 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.197 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 477.979 423.936 478.195 423.783C481.573 421.421 483.668 416.556 483.668 409.837V263.011C483.668 249.916 475.719 234.713 465.905 229.048Z",
    fill: "url(#paint25_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.753 229.149L273.83 118.204C269.945 115.956 266.351 115.55 263.431 116.68C263.063 116.82 258.111 119.461 257.756 119.652C257.756 119.652 257.743 119.665 257.73 119.665C260.765 118.191 264.612 118.458 268.789 120.884L460.712 231.817C470.527 237.481 478.475 252.685 478.475 265.78V412.619C478.475 420.786 475.377 426.196 470.666 427.733C471.047 427.759 471.53 427.606 472.228 427.2C472.456 427.073 477.827 424.037 478.043 423.885C481.42 421.522 483.515 416.658 483.515 409.939V263.1C483.528 250.017 475.567 234.814 465.753 229.149Z",
    fill: "url(#paint26_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.576 231.397L269.653 120.452C265.628 118.128 261.933 117.798 258.949 119.08C261.489 118.674 264.409 119.296 267.52 121.087L459.443 232.02C469.257 237.685 477.205 252.888 477.205 265.983V412.822C477.205 420.544 474.425 425.777 470.146 427.632C475.631 426.768 479.338 421.129 479.338 412.187V265.348C479.338 252.266 471.39 237.062 461.576 231.397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.107 144.546C243.879 144.546 243.65 144.483 243.434 144.356L234.547 138.856C233.95 138.488 233.772 137.7 234.14 137.103C234.508 136.506 235.296 136.316 235.892 136.697L244.78 142.197C245.377 142.565 245.555 143.352 245.186 143.949C244.945 144.33 244.526 144.546 244.107 144.546Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.107 161.655C243.993 161.655 243.878 161.629 243.777 161.566L234.889 156.066C234.584 155.876 234.495 155.495 234.686 155.19C234.876 154.898 235.27 154.796 235.562 154.987L244.45 160.486C244.754 160.677 244.843 161.058 244.653 161.363C244.526 161.553 244.323 161.655 244.107 161.655Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.107 180.046C243.878 180.046 243.65 179.982 243.434 179.855L234.546 174.356C233.95 173.987 233.772 173.2 234.14 172.603C234.508 172.006 235.296 171.815 235.892 172.196L244.78 177.696C245.377 178.064 245.554 178.852 245.186 179.449C244.945 179.83 244.526 180.046 244.107 180.046Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.107 197.154C243.993 197.154 243.878 197.129 243.777 197.066L234.889 191.566C234.584 191.375 234.495 190.994 234.686 190.689C234.876 190.385 235.27 190.296 235.562 190.486L244.45 195.986C244.754 196.176 244.843 196.557 244.653 196.862C244.526 197.053 244.323 197.154 244.107 197.154Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.107 214.911C243.993 214.911 243.878 214.885 243.777 214.822L234.889 209.322C234.584 209.132 234.495 208.751 234.686 208.446C234.876 208.141 235.27 208.052 235.562 208.242L244.45 213.742C244.754 213.933 244.843 214.314 244.653 214.619C244.526 214.796 244.323 214.911 244.107 214.911Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.107 232.655C243.993 232.655 243.878 232.629 243.777 232.566L234.889 227.066C234.584 226.875 234.495 226.494 234.686 226.19C234.876 225.885 235.27 225.796 235.562 225.986L244.45 231.486C244.754 231.677 244.843 232.058 244.653 232.362C244.526 232.553 244.323 232.655 244.107 232.655Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.107 250.398C243.993 250.398 243.878 250.373 243.777 250.309L234.889 244.809C234.584 244.619 234.495 244.238 234.686 243.933C234.876 243.628 235.27 243.539 235.562 243.73L244.45 249.229C244.754 249.42 244.843 249.801 244.653 250.106C244.526 250.296 244.323 250.398 244.107 250.398Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.107 268.155C243.993 268.155 243.878 268.129 243.777 268.066L234.889 262.566C234.584 262.376 234.495 261.995 234.686 261.69C234.876 261.398 235.27 261.296 235.562 261.486L244.45 266.986C244.754 267.177 244.843 267.558 244.653 267.862C244.526 268.053 244.323 268.155 244.107 268.155Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.911 147.074H282.959V307.3H283.911V147.074Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.159 160.423H306.207V320.649H307.159V160.423Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.419 173.773H329.467V333.999H330.419V173.773Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.667 187.121H352.715V347.347H353.667V187.121Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.927 200.47H375.975V360.696H376.927V200.47Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.187 213.819H399.235V374.045H400.187V213.819Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.435 227.168H422.482V387.394H423.435V227.168Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.695 240.517H445.743V400.743H446.695V240.517Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.636 155.571L266.16 156.396L462.998 270.12L463.474 269.295L266.636 155.571Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.642 173.323L266.166 174.148L463.003 287.872L463.48 287.048L266.642 173.323Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.637 191.069L266.161 191.894L462.998 305.618L463.474 304.793L266.637 191.069Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.632 208.814L266.155 209.639L462.993 323.363L463.469 322.538L266.632 208.814Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.637 226.566L266.161 227.391L462.999 341.115L463.475 340.291L266.637 226.566Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.632 244.312L266.156 245.137L462.993 358.861L463.469 358.036L266.632 244.312Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.638 262.064L266.162 262.889L462.999 376.613L463.475 375.788L266.638 262.064Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.626 279.821L266.15 280.646L462.987 394.37L463.463 393.545L266.626 279.821Z",
    fill: "#3C0862"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M102.425 351.031C99.8732 352.504 98.413 354.828 98.413 357.419C98.413 360.252 100.165 362.894 103.238 364.672C103.25 364.672 104.38 365.18 104.393 365.193L116.379 370.527C116.455 370.565 127.057 375.265 127.146 375.277C129.571 376.649 132.58 377.386 135.64 377.373C137.366 377.36 138.979 377.106 140.426 376.636C141.201 376.382 141.963 376.039 142.623 375.658L149.644 371.137C152.196 369.663 153.656 367.339 153.656 364.761C153.656 361.928 151.904 359.286 148.832 357.508C148.819 357.496 147.346 356.365 147.333 356.352L136.554 348.097C136.516 348.084 132.339 344.858 132.3 344.845C129.888 343.461 126.866 342.711 123.806 342.699C121.153 342.699 118.728 343.27 116.811 344.363C116.772 344.375 112.532 346.331 112.506 346.344L102.425 351.031Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M103.593 351.551C101.105 352.986 99.6826 355.247 99.6826 357.762C99.6826 360.505 101.397 363.084 104.38 364.824C104.393 364.837 105.485 365.319 105.498 365.332L117.166 370.539C117.306 370.628 127.476 375.112 127.653 375.125C130.028 376.433 132.961 377.131 135.932 377.106C137.608 377.093 139.182 376.826 140.579 376.369C141.315 376.128 142.089 375.785 142.712 375.417L149.542 371.035C152.031 369.599 153.453 367.339 153.453 364.837C153.453 362.093 151.752 359.515 148.768 357.775C148.743 357.762 147.333 356.67 147.308 356.657L136.795 348.681C136.731 348.642 132.719 345.569 132.643 345.543C130.282 344.21 127.361 343.486 124.378 343.473C121.8 343.473 119.439 344.019 117.572 345.073C117.509 345.086 113.433 346.966 113.382 347.004L103.593 351.551Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M104.761 352.072C102.324 353.482 100.952 355.679 100.952 358.105C100.952 360.772 102.616 363.274 105.523 364.976C105.549 364.989 106.59 365.459 106.615 365.471L117.953 370.539C118.169 370.666 127.895 374.947 128.161 374.959C130.485 376.204 133.342 376.864 136.224 376.826C137.849 376.801 139.372 376.534 140.744 376.077C141.429 375.848 142.229 375.493 142.826 375.15L149.479 370.908C151.904 369.51 153.288 367.313 153.288 364.887C153.301 362.22 151.65 359.731 148.743 358.016C148.705 357.99 147.359 356.949 147.321 356.936L137.062 349.239C136.96 349.189 133.126 346.255 133.011 346.216C130.713 344.934 127.869 344.235 124.974 344.222C122.473 344.222 120.188 344.743 118.359 345.759C118.258 345.785 114.373 347.575 114.284 347.626L104.761 352.072Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M105.929 352.593C103.568 353.952 102.222 356.085 102.222 358.448C102.222 361.026 103.834 363.465 106.666 365.129C106.691 365.154 107.694 365.599 107.72 365.611L118.74 370.552C119.032 370.717 128.314 374.782 128.669 374.82C130.942 376.001 133.722 376.623 136.503 376.56C138.077 376.522 139.563 376.255 140.883 375.81C141.531 375.594 142.343 375.226 142.902 374.909L149.377 370.806C151.739 369.447 153.072 367.313 153.085 364.964C153.097 362.385 151.498 359.959 148.679 358.295C148.641 358.27 147.346 357.279 147.295 357.241L137.303 349.824C137.176 349.747 133.506 346.966 133.354 346.915C131.107 345.683 128.352 345.01 125.546 344.997C123.121 344.997 120.899 345.505 119.121 346.471C118.981 346.509 115.274 348.211 115.16 348.274L105.929 352.593Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M107.098 353.113C104.787 354.447 103.492 356.504 103.492 358.791C103.492 361.293 105.053 363.643 107.809 365.281C107.847 365.306 108.786 365.738 108.837 365.764L119.528 370.565C119.883 370.768 128.733 374.629 129.177 374.667C131.399 375.785 134.103 376.369 136.795 376.293C138.331 376.242 139.766 375.975 141.048 375.544C141.658 375.34 142.483 374.959 143.004 374.655L149.301 370.679C151.599 369.345 152.894 367.301 152.907 365.027C152.92 362.538 151.371 360.175 148.641 358.549C148.59 358.511 147.359 357.571 147.295 357.533L137.57 350.395C137.404 350.306 133.913 347.664 133.722 347.601C131.539 346.42 128.86 345.772 126.143 345.759C123.794 345.759 121.635 346.242 119.896 347.156C119.718 347.207 116.201 348.82 116.061 348.896L107.098 353.113Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M108.265 353.621C106.018 354.929 104.761 356.923 104.761 359.133C104.761 361.547 106.272 363.833 108.951 365.42C109.002 365.446 109.891 365.865 109.941 365.89L120.302 370.564C120.734 370.818 129.152 374.464 129.672 374.515C131.843 375.569 134.459 376.115 137.074 376.026C138.56 375.975 139.944 375.696 141.188 375.264C141.759 375.061 142.597 374.692 143.092 374.4L149.212 370.564C151.447 369.269 152.704 367.288 152.717 365.09C152.729 362.677 151.244 360.391 148.59 358.803C148.527 358.752 147.359 357.863 147.282 357.825L137.823 350.966C137.633 350.852 134.306 348.363 134.078 348.287C131.957 347.156 129.355 346.534 126.726 346.521C124.454 346.508 122.359 346.978 120.67 347.855C120.467 347.905 117.115 349.442 116.95 349.544L108.265 353.621Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M109.434 354.142C107.25 355.4 106.031 357.343 106.031 359.477C106.031 361.814 107.491 364.024 110.094 365.573C110.145 365.611 110.995 365.992 111.059 366.031L121.102 370.578C121.61 370.87 129.583 374.312 130.193 374.363C132.313 375.353 134.852 375.849 137.366 375.747C138.801 375.683 140.147 375.404 141.353 374.985C141.886 374.794 142.737 374.413 143.194 374.147L149.136 370.451C151.307 369.193 152.526 367.275 152.539 365.154C152.552 362.83 151.117 360.62 148.539 359.07C148.463 359.019 147.359 358.168 147.27 358.118L138.077 351.526C137.849 351.399 134.687 349.049 134.433 348.96C132.364 347.88 129.85 347.284 127.311 347.271C125.114 347.258 123.083 347.703 121.445 348.541C121.203 348.604 118.029 350.052 117.839 350.167L109.434 354.142Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M110.602 354.663C108.481 355.895 107.301 357.762 107.301 359.82C107.301 362.068 108.71 364.214 111.236 365.726C111.3 365.764 112.1 366.132 112.163 366.17L121.876 370.578C122.448 370.908 129.989 374.147 130.688 374.21C132.757 375.138 135.22 375.595 137.646 375.48C139.029 375.404 140.325 375.125 141.493 374.718C141.988 374.541 142.851 374.147 143.27 373.906L149.034 370.349C151.142 369.13 152.323 367.275 152.336 365.243C152.348 363.008 150.964 360.861 148.476 359.35C148.387 359.286 147.346 358.499 147.244 358.435L138.306 352.123C138.039 351.97 135.055 349.76 134.751 349.672C132.745 348.63 130.307 348.071 127.856 348.058C125.736 348.046 123.768 348.465 122.181 349.265C121.902 349.341 118.918 350.7 118.689 350.827L110.602 354.663Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M111.77 355.184C109.713 356.378 108.57 358.181 108.57 360.163C108.57 362.322 109.929 364.405 112.379 365.878C112.455 365.929 113.205 366.272 113.281 366.323L122.676 370.603C123.324 370.972 130.421 374.007 131.208 374.071C133.227 374.947 135.614 375.353 137.95 375.226C139.296 375.15 140.54 374.858 141.658 374.452C142.115 374.287 142.991 373.88 143.385 373.664L148.971 370.235C151.015 369.054 152.145 367.263 152.171 365.307C152.196 363.148 150.863 361.077 148.451 359.604C148.349 359.54 147.371 358.791 147.257 358.728L138.585 352.694C138.293 352.529 135.475 350.459 135.132 350.357C133.176 349.367 130.828 348.833 128.466 348.821C126.422 348.808 124.517 349.202 122.968 349.964C122.651 350.04 119.845 351.323 119.591 351.462L111.77 355.184Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M112.938 355.704C110.932 356.86 109.84 358.6 109.84 360.505C109.84 362.588 111.148 364.595 113.522 366.03C113.598 366.081 114.309 366.411 114.385 366.462L123.451 370.603C124.162 371.022 130.827 373.829 131.716 373.918C133.684 374.731 135.982 375.099 138.242 374.946C139.537 374.858 140.731 374.565 141.823 374.172C142.242 374.019 143.118 373.613 143.486 373.397L148.882 370.107C150.863 368.964 151.955 367.249 151.98 365.357C152.005 363.287 150.723 361.293 148.4 359.857C148.298 359.781 147.371 359.083 147.244 359.006L138.839 353.253C138.509 353.062 135.868 351.144 135.487 351.03C133.595 350.09 131.323 349.582 129.05 349.569C127.082 349.557 125.254 349.925 123.743 350.649C123.4 350.738 120.759 351.932 120.48 352.097L112.938 355.704Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M114.106 356.225C112.163 357.343 111.11 359.02 111.11 360.849C111.11 362.843 112.379 364.786 114.665 366.17C114.754 366.234 115.401 366.539 115.503 366.59L124.251 370.603C125.038 371.06 131.259 373.664 132.237 373.753C134.167 374.502 136.376 374.833 138.534 374.668C139.779 374.566 140.934 374.274 141.975 373.893C142.356 373.753 143.245 373.334 143.575 373.143L148.793 369.994C150.71 368.889 151.764 367.237 151.79 365.434C151.815 363.452 150.584 361.522 148.349 360.125C148.235 360.036 147.371 359.388 147.232 359.312L139.093 353.838C138.738 353.634 136.262 351.856 135.843 351.729C134.002 350.84 131.831 350.357 129.634 350.345C127.742 350.332 125.977 350.675 124.517 351.348C124.136 351.45 121.686 352.555 121.368 352.733L114.106 356.225Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M115.274 356.746C113.395 357.825 112.379 359.438 112.379 361.191C112.379 363.109 113.598 364.963 115.807 366.322C115.896 366.386 116.506 366.678 116.607 366.729L125.025 370.616C125.888 371.111 131.678 373.511 132.732 373.6C134.611 374.286 136.744 374.578 138.814 374.4C140.007 374.299 141.112 373.994 142.127 373.626C142.47 373.499 143.372 373.067 143.676 372.902L148.717 369.892C150.571 368.825 151.586 367.237 151.612 365.51C151.637 363.604 150.469 361.75 148.311 360.391C148.184 360.302 147.384 359.705 147.231 359.616L139.36 354.421C138.966 354.193 136.668 352.567 136.211 352.427C134.433 351.589 132.338 351.132 130.231 351.119C128.415 351.106 126.714 351.424 125.292 352.059C124.873 352.161 122.6 353.189 122.27 353.38L115.274 356.746Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M116.442 357.267C114.627 358.321 113.649 359.858 113.649 361.534C113.649 363.363 114.817 365.154 116.95 366.475C117.052 366.538 117.61 366.805 117.725 366.881L125.825 370.628C126.752 371.162 132.11 373.359 133.253 373.461C135.081 374.083 137.138 374.324 139.118 374.134C140.274 374.019 141.328 373.715 142.293 373.346C142.597 373.232 143.511 372.8 143.778 372.648L148.641 369.777C150.431 368.748 151.409 367.224 151.434 365.573C151.46 363.757 150.342 361.966 148.273 360.645C148.133 360.543 147.397 359.997 147.232 359.908L139.614 354.993C139.182 354.752 137.062 353.266 136.566 353.113C134.852 352.326 132.834 351.894 130.815 351.881C129.075 351.869 127.437 352.161 126.066 352.758C125.622 352.872 123.514 353.812 123.159 354.028L116.442 357.267Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M117.61 357.787C115.858 358.803 114.918 360.277 114.918 361.877C114.918 363.63 116.036 365.344 118.08 366.627C118.194 366.703 118.702 366.945 118.816 367.021L126.587 370.641C127.59 371.225 132.503 373.206 133.735 373.308C135.512 373.867 137.493 374.07 139.372 373.867C140.477 373.74 141.493 373.435 142.407 373.079C142.673 372.978 143.6 372.533 143.829 372.394L148.514 369.65C150.241 368.659 151.167 367.199 151.206 365.624C151.244 363.884 150.164 362.182 148.184 360.899C148.031 360.797 147.358 360.289 147.181 360.188L139.829 355.552C139.372 355.285 137.417 353.951 136.884 353.786C135.22 353.05 133.291 352.643 131.361 352.618C129.697 352.605 128.123 352.884 126.803 353.431C126.32 353.558 124.403 354.409 124.009 354.637L117.61 357.787Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M118.778 358.308C117.09 359.286 116.188 360.696 116.188 362.233C116.188 363.897 117.255 365.548 119.223 366.793C119.337 366.869 119.807 367.097 119.934 367.174L127.387 370.654C128.466 371.276 132.935 373.054 134.256 373.169C135.982 373.664 137.874 373.829 139.677 373.613C140.731 373.473 141.696 373.169 142.585 372.826C142.813 372.737 143.753 372.28 143.956 372.165L148.463 369.561C150.126 368.596 151.015 367.224 151.053 365.726C151.091 364.075 150.076 362.436 148.158 361.191C147.993 361.077 147.384 360.62 147.193 360.518L140.109 356.162C139.614 355.882 137.836 354.688 137.265 354.51C135.665 353.825 133.811 353.444 131.97 353.418C130.383 353.405 128.872 353.66 127.603 354.168C127.082 354.307 125.343 355.069 124.924 355.311L118.778 358.308Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M119.946 358.829C118.308 359.769 117.458 361.128 117.458 362.576C117.458 364.163 118.473 365.738 120.365 366.945C120.492 367.034 120.899 367.237 121.038 367.313L128.161 370.666C129.304 371.327 133.341 372.889 134.751 373.016C136.427 373.448 138.242 373.575 139.956 373.334C140.959 373.194 141.886 372.876 142.724 372.534C142.915 372.457 143.867 371.987 144.032 371.898L148.361 369.434C149.961 368.507 150.812 367.199 150.837 365.776C150.875 364.214 149.91 362.639 148.082 361.433C147.917 361.306 147.358 360.912 147.168 360.798L140.35 356.72C139.829 356.416 138.217 355.374 137.607 355.184C136.058 354.536 134.294 354.193 132.541 354.168C131.03 354.155 129.583 354.383 128.351 354.853C127.793 354.993 126.231 355.679 125.787 355.933L119.946 358.829Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M121.114 359.35C119.54 360.252 118.728 361.547 118.728 362.919C118.728 364.418 119.692 365.929 121.508 367.085C121.635 367.174 122.003 367.364 122.156 367.453L128.961 370.679C130.18 371.378 133.786 372.737 135.271 372.877C136.896 373.245 138.636 373.334 140.248 373.08C141.213 372.927 142.077 372.61 142.889 372.28C143.042 372.216 144.007 371.746 144.134 371.67L148.285 369.346C149.822 368.457 150.634 367.212 150.66 365.866C150.698 364.38 149.784 362.893 148.044 361.725C147.866 361.598 147.371 361.242 147.168 361.115L140.617 357.318C140.058 357 138.61 356.098 137.976 355.895C136.49 355.298 134.801 354.981 133.138 354.955C131.704 354.943 130.332 355.146 129.139 355.565C128.555 355.717 127.171 356.314 126.688 356.594L121.114 359.35Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M122.282 359.87C120.772 360.747 119.997 361.966 119.997 363.261C119.997 364.671 120.911 366.119 122.651 367.237C122.79 367.326 123.108 367.504 123.26 367.592L129.735 370.679C131.03 371.428 134.192 372.571 135.766 372.711C137.341 373.029 139.004 373.067 140.528 372.8C141.442 372.635 142.267 372.317 143.029 372C143.143 371.949 144.121 371.466 144.222 371.403L148.184 369.218C149.656 368.367 150.418 367.186 150.456 365.929C150.494 364.531 149.644 363.109 147.98 361.979C147.79 361.839 147.358 361.534 147.143 361.407L140.845 357.876C140.261 357.533 138.979 356.771 138.293 356.555C136.858 356.009 135.258 355.717 133.684 355.691C132.326 355.666 131.018 355.857 129.875 356.238C129.253 356.403 128.047 356.911 127.552 357.203L122.282 359.87Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M123.451 360.391C122.003 361.229 121.267 362.385 121.28 363.604C121.28 364.938 122.143 366.297 123.806 367.389C123.959 367.491 124.225 367.643 124.39 367.732L130.535 370.692C131.894 371.479 134.624 372.419 136.287 372.572C137.811 372.826 139.385 372.813 140.832 372.533C141.696 372.368 142.47 372.038 143.194 371.721C143.27 371.695 144.261 371.187 144.324 371.149L148.108 369.091C149.517 368.279 150.241 367.161 150.279 365.98C150.317 364.671 149.517 363.312 147.943 362.22C147.739 362.08 147.371 361.814 147.143 361.687L141.112 358.435C140.49 358.079 139.385 357.457 138.661 357.228C137.29 356.733 135.779 356.466 134.281 356.441C132.999 356.416 131.754 356.581 130.662 356.924C130.002 357.089 128.974 357.521 128.453 357.825L123.451 360.391Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M124.619 360.912C123.235 361.712 122.537 362.805 122.549 363.948C122.549 365.193 123.362 366.488 124.949 367.542C125.101 367.644 125.33 367.771 125.495 367.872L131.323 370.692C132.757 371.518 135.043 372.254 136.808 372.407C138.28 372.597 139.779 372.547 141.137 372.254C141.963 372.077 142.686 371.746 143.372 371.442C143.41 371.429 144.413 370.908 144.438 370.895L148.044 368.977C149.39 368.203 150.076 367.161 150.114 366.043C150.165 364.811 149.403 363.529 147.917 362.487C147.701 362.335 147.397 362.132 147.155 361.979L141.391 359.007C140.731 358.626 139.804 358.156 139.042 357.915C137.735 357.47 136.3 357.229 134.89 357.203C133.684 357.178 132.504 357.318 131.45 357.623C130.751 357.8 129.913 358.143 129.355 358.474L124.619 360.912Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.511 371.175L147.955 368.876C150.875 367.186 150.507 364.24 147.143 362.297L141.645 359.604C138.268 357.661 133.164 357.445 130.243 359.134L125.8 361.433C122.879 363.122 123.248 366.069 126.612 368.012L132.11 370.705C135.487 372.648 140.591 372.864 143.511 371.175Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M105.65 326.593C103.111 328.054 101.65 330.365 101.638 332.944C101.625 335.763 103.352 338.405 106.386 340.183C106.412 340.209 112.658 343.6 112.697 343.625L127.171 351.449L127.653 351.716C127.755 351.78 147.866 362.601 147.993 362.588C150.406 363.947 153.402 364.684 156.437 364.659C156.894 364.659 157.351 364.633 157.795 364.595C159.877 364.43 161.845 363.846 163.382 362.957L170.352 358.461C172.866 357 174.326 354.714 174.339 352.161C174.364 349.354 172.65 346.737 169.641 344.984C169.641 344.921 152.767 332.766 152.678 332.715L141.15 324.485C141.112 324.459 135.5 320.446 135.449 320.433C133.037 319.061 130.028 318.299 126.968 318.299C124.314 318.299 121.902 318.871 119.984 319.963C119.959 319.976 116.175 321.716 116.15 321.729L105.65 326.593Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M107.694 327.698C105.231 329.121 103.822 331.343 103.796 333.82C103.771 336.551 105.421 339.104 108.342 340.844C108.38 340.895 114.36 344.146 114.436 344.197L128.453 351.754L128.923 352.008C129.139 352.135 148.4 362.449 148.654 362.411C151.002 363.693 153.897 364.379 156.83 364.341C157.275 364.328 157.706 364.303 158.138 364.265C160.106 364.1 162.074 363.503 163.534 362.652L170.289 358.308C172.714 356.911 174.11 354.714 174.149 352.262C174.187 349.57 172.574 347.055 169.717 345.353C169.717 345.238 153.643 333.617 153.466 333.515L142.242 325.564C142.166 325.513 136.782 321.678 136.693 321.652C134.332 320.331 131.412 319.607 128.453 319.607C125.876 319.607 123.527 320.166 121.66 321.22C121.597 321.233 117.978 322.91 117.94 322.935L107.694 327.698Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M109.738 328.803C107.351 330.175 105.98 332.321 105.942 334.709C105.891 337.338 107.478 339.815 110.284 341.517C110.348 341.606 116.036 344.705 116.163 344.781L129.723 352.072L130.18 352.313C130.497 352.504 148.907 362.296 149.288 362.246C151.574 363.452 154.367 364.087 157.198 364.024C157.63 364.011 158.049 363.986 158.455 363.948C160.322 363.782 162.277 363.173 163.674 362.373L170.212 358.194C172.536 356.848 173.882 354.739 173.933 352.402C173.983 349.824 172.472 347.411 169.768 345.759C169.755 345.582 154.481 334.506 154.227 334.354L143.308 326.682C143.181 326.606 138.039 322.961 137.899 322.923C135.601 321.652 132.77 320.954 129.888 320.954C127.387 320.954 125.114 321.487 123.298 322.503C123.209 322.529 119.756 324.129 119.68 324.167L109.738 328.803Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M111.782 329.909C109.484 331.242 108.151 333.3 108.1 335.599C108.037 338.139 109.548 340.54 112.24 342.191C112.328 342.305 117.737 345.264 117.902 345.353L131.005 352.39L131.45 352.631C131.881 352.885 149.428 362.157 149.936 362.106C152.158 363.237 154.862 363.821 157.567 363.745C157.973 363.732 158.379 363.694 158.786 363.656C160.55 363.491 162.506 362.868 163.813 362.119L170.136 358.093C172.371 356.81 173.653 354.79 173.73 352.568C173.806 350.104 172.384 347.779 169.832 346.192C169.819 345.95 155.345 335.421 155.002 335.218L144.375 327.826C144.21 327.737 139.296 324.257 139.106 324.206C136.871 322.986 134.116 322.326 131.335 322.326C128.91 322.326 126.701 322.847 124.936 323.812C124.822 323.85 121.521 325.362 121.432 325.425L111.782 329.909Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M113.827 331.014C111.605 332.296 110.322 334.29 110.259 336.488C110.183 338.939 111.618 341.251 114.195 342.864C114.309 343.004 119.439 345.823 119.642 345.938L132.288 352.707L132.719 352.936C133.253 353.241 149.961 362.017 150.584 361.941C152.729 362.995 155.345 363.529 157.948 363.427C158.341 363.414 158.735 363.376 159.116 363.338C160.779 363.173 162.722 362.551 163.953 361.827L170.048 357.953C172.181 356.721 173.425 354.803 173.501 352.682C173.59 350.332 172.282 348.109 169.87 346.573C169.857 346.268 156.17 336.272 155.751 336.031L145.429 328.905C145.226 328.791 140.541 325.501 140.299 325.438C138.115 324.269 135.449 323.634 132.757 323.634C130.409 323.634 128.276 324.129 126.549 325.057C126.409 325.095 123.26 326.543 123.146 326.606L113.827 331.014Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M115.871 332.118C113.725 333.363 112.494 335.268 112.405 337.376C112.316 339.726 113.662 341.974 116.138 343.549C116.264 343.714 121.127 346.394 121.369 346.534L133.557 353.05L133.976 353.266C134.624 353.634 150.469 361.89 151.218 361.801C153.301 362.779 155.815 363.274 158.316 363.147C158.697 363.122 159.065 363.084 159.433 363.046C160.982 362.88 162.925 362.245 164.08 361.572L169.959 357.863C171.99 356.682 173.184 354.866 173.285 352.859C173.4 350.611 172.181 348.503 169.921 347.017C169.908 346.661 157.021 337.199 156.5 336.906L146.483 330.06C146.241 329.921 141.785 326.809 141.493 326.733C139.372 325.615 136.795 325.018 134.192 325.018C131.932 325.018 129.85 325.488 128.187 326.377C128.009 326.428 125.038 327.8 124.898 327.876L115.871 332.118Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M117.915 333.223C115.845 334.417 114.652 336.246 114.563 338.266C114.461 340.527 115.731 342.686 118.093 344.223C118.245 344.413 122.816 346.953 123.108 347.118L134.84 353.368L135.233 353.583C135.982 354.015 150.977 361.75 151.853 361.649C153.872 362.563 156.284 362.995 158.671 362.843C159.039 362.817 159.395 362.766 159.75 362.728C161.198 362.563 163.14 361.915 164.22 361.293L169.882 357.737C171.825 356.619 172.955 354.892 173.082 352.986C173.222 350.853 172.092 348.833 169.984 347.411C169.971 346.991 157.871 338.075 157.275 337.732L147.562 331.166C147.27 331.001 143.054 328.067 142.712 327.978C140.655 326.924 138.153 326.339 135.64 326.352C133.456 326.352 131.45 326.809 129.824 327.648C129.621 327.711 126.803 328.994 126.638 329.095L117.915 333.223Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M119.959 334.341C117.979 335.484 116.823 337.237 116.709 339.167C116.595 341.339 117.788 343.41 120.035 344.908C120.213 345.124 124.505 347.525 124.835 347.715L136.109 353.71L136.49 353.914C137.354 354.409 151.485 361.636 152.488 361.522C154.443 362.36 156.754 362.741 159.04 362.576C159.395 362.55 159.725 362.5 160.068 362.461C161.414 362.309 163.344 361.636 164.347 361.064L169.794 357.673C171.635 356.606 172.714 354.98 172.854 353.177C173.006 351.157 171.978 349.239 170.022 347.868C169.997 347.385 158.709 339.015 158.024 338.621L148.603 332.334C148.273 332.144 144.286 329.4 143.905 329.299C141.912 328.295 139.499 327.749 137.074 327.749C134.967 327.749 133.024 328.181 131.45 328.981C131.221 329.045 128.568 330.264 128.377 330.378L119.959 334.341Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M122.003 335.446C120.099 336.551 118.982 338.215 118.867 340.044C118.728 342.114 119.858 344.121 121.991 345.569C122.194 345.823 126.206 348.071 126.561 348.287L137.366 354.015L137.735 354.205C138.699 354.764 151.993 361.471 153.123 361.344C155.015 362.106 157.224 362.436 159.408 362.258C159.738 362.233 160.068 362.169 160.385 362.131C161.63 361.979 163.547 361.293 164.474 360.759L169.692 357.52C171.431 356.517 172.473 354.98 172.625 353.291C172.803 351.386 171.876 349.557 170.06 348.249C170.035 347.702 159.535 339.878 158.773 339.434L149.657 333.426C149.288 333.21 145.53 330.645 145.099 330.53C143.156 329.578 140.833 329.057 138.496 329.07C136.465 329.07 134.598 329.476 133.075 330.251C132.808 330.327 130.32 331.47 130.104 331.597L122.003 335.446Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M124.048 336.551C122.219 337.605 121.153 339.193 121.026 340.933C120.873 342.914 121.927 344.832 123.946 346.242C124.162 346.521 127.895 348.63 128.301 348.871L138.649 354.345L139.004 354.536C140.083 355.158 152.514 361.343 153.77 361.204C155.599 361.89 157.719 362.169 159.789 361.966C160.106 361.928 160.411 361.877 160.728 361.826C161.858 361.674 163.788 360.988 164.639 360.492L169.641 357.419C171.292 356.466 172.27 355.031 172.435 353.443C172.625 351.64 171.8 349.925 170.137 348.668C170.111 348.071 160.411 340.78 159.56 340.285L150.749 334.544C150.342 334.303 146.813 331.927 146.33 331.8C144.451 330.899 142.217 330.416 139.969 330.416C138.014 330.429 136.211 330.81 134.738 331.534C134.446 331.623 132.11 332.689 131.881 332.816L124.048 336.551Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M126.092 337.656C124.34 338.672 123.324 340.171 123.172 341.822C123.006 343.715 123.984 345.544 125.889 346.928C126.13 347.233 129.583 349.202 130.028 349.456L139.918 354.663L140.261 354.841C141.442 355.527 153.021 361.204 154.405 361.039C156.17 361.649 158.189 361.877 160.144 361.661C160.449 361.623 160.741 361.56 161.033 361.522C162.061 361.382 163.979 360.671 164.753 360.226L169.54 357.305C171.089 356.416 172.016 355.07 172.206 353.583C172.422 351.894 171.686 350.281 170.175 349.075C170.149 348.414 161.236 341.67 160.297 341.124L151.777 335.662C151.32 335.395 148.032 333.198 147.498 333.058C145.683 332.207 143.524 331.75 141.366 331.763C139.487 331.775 137.76 332.131 136.325 332.817C136.008 332.906 133.837 333.897 133.57 334.049L126.092 337.656Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M128.136 338.761C126.46 339.726 125.482 341.149 125.33 342.711C125.152 344.502 126.041 346.267 127.844 347.601C128.111 347.931 131.285 349.76 131.767 350.04L141.201 354.98L141.531 355.145C142.826 355.895 153.542 361.052 155.053 360.874C156.754 361.407 158.671 361.598 160.525 361.344C160.817 361.306 161.084 361.229 161.363 361.191C162.29 361.052 164.194 360.328 164.893 359.921L169.464 357.152C170.911 356.314 171.8 355.069 172.003 353.698C172.231 352.123 171.597 350.598 170.238 349.455C170.213 348.731 162.1 342.533 161.071 341.936L152.856 336.754C152.361 336.475 149.301 334.455 148.717 334.303C146.952 333.503 144.883 333.083 142.826 333.083C141.036 333.096 139.36 333.426 137.976 334.074C137.633 334.176 135.614 335.09 135.335 335.255L128.136 338.761Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M130.18 339.866C128.593 340.78 127.653 342.127 127.475 343.6C127.285 345.302 128.098 346.978 129.786 348.274C130.078 348.63 132.973 350.319 133.494 350.624L142.47 355.31L142.788 355.476C144.184 356.288 154.062 360.924 155.687 360.747C157.325 361.217 159.141 361.344 160.893 361.077C161.16 361.039 161.426 360.963 161.693 360.912C162.518 360.785 164.423 360.035 165.032 359.68L169.374 357.076C170.733 356.288 171.558 355.145 171.774 353.875C172.028 352.415 171.482 350.992 170.276 349.9C170.251 349.112 162.925 343.46 161.82 342.825L153.91 337.922C153.377 337.618 150.545 335.776 149.923 335.611C148.222 334.861 146.241 334.468 144.26 334.48C142.546 334.493 140.947 334.811 139.613 335.408C139.233 335.522 137.379 336.36 137.074 336.538L130.18 339.866Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M132.224 340.984C130.713 341.86 129.812 343.117 129.634 344.502C129.418 346.115 130.167 347.715 131.729 348.96C132.034 349.354 134.649 350.891 135.221 351.221L143.74 355.641L144.032 355.793C145.543 356.67 154.558 360.798 156.31 360.594C157.871 360.988 159.598 361.064 161.236 360.772C161.49 360.721 161.731 360.645 161.985 360.607C162.709 360.48 164.601 359.718 165.147 359.413L169.273 356.962C170.53 356.238 171.317 355.184 171.546 354.015C171.825 352.656 171.381 351.348 170.302 350.306C170.263 349.468 163.75 344.35 162.557 343.664L154.951 339.04C154.38 338.71 151.777 337.059 151.104 336.868C149.466 336.183 147.562 335.814 145.683 335.827C144.045 335.84 142.509 336.132 141.226 336.691C140.82 336.805 139.131 337.567 138.801 337.77L132.224 340.984Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M134.268 342.089C132.834 342.914 131.983 344.096 131.793 345.391C131.564 346.903 132.237 348.427 133.684 349.633C134.014 350.053 136.351 351.45 136.96 351.805L145.022 355.971L145.302 356.111C146.914 357.038 155.078 360.658 156.957 360.442C158.456 360.76 160.093 360.785 161.617 360.48C161.858 360.429 162.087 360.353 162.315 360.302C162.925 360.188 164.817 359.413 165.286 359.134L169.197 356.848C170.352 356.175 171.089 355.222 171.343 354.168C171.635 352.923 171.292 351.704 170.365 350.726C170.327 349.824 164.613 345.252 163.331 344.515L156.018 340.158C155.408 339.803 153.034 338.329 152.31 338.139C150.723 337.504 148.92 337.161 147.13 337.174C145.568 337.186 144.108 337.453 142.864 337.974C142.432 338.101 140.896 338.787 140.541 338.99L134.268 342.089Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M136.313 343.193C134.954 343.981 134.141 345.073 133.938 346.28C133.697 347.702 134.294 349.138 135.627 350.319C135.982 350.763 138.039 352.021 138.687 352.402L146.292 356.301L146.559 356.441C148.286 357.431 155.586 360.531 157.605 360.302C159.04 360.543 160.576 360.518 161.998 360.2C162.226 360.149 162.43 360.061 162.658 360.022C163.166 359.921 165.058 359.121 165.439 358.892L169.133 356.758C170.2 356.149 170.873 355.285 171.14 354.332C171.457 353.202 171.203 352.084 170.429 351.157C170.39 350.192 165.464 346.165 164.093 345.378L157.084 341.301C156.424 340.92 154.291 339.624 153.517 339.421C151.993 338.837 150.266 338.532 148.565 338.545C147.079 338.557 145.683 338.811 144.502 339.294C144.032 339.434 142.674 340.043 142.28 340.259L136.313 343.193Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M138.357 344.298C137.075 345.035 136.313 346.051 136.097 347.156C135.843 348.49 136.364 349.849 137.582 350.979C137.963 351.449 139.741 352.567 140.426 352.973L147.562 356.619L147.816 356.746C149.644 357.8 156.107 360.391 158.24 360.137C159.611 360.302 161.046 360.226 162.366 359.883C162.569 359.832 162.773 359.73 162.976 359.692C163.382 359.603 165.261 358.778 165.566 358.6L169.032 356.619C169.997 356.06 170.632 355.285 170.911 354.459C171.254 353.443 171.089 352.415 170.467 351.551C170.429 350.535 166.302 347.042 164.842 346.204L158.138 342.406C157.44 342 155.535 340.895 154.71 340.679C153.25 340.145 151.612 339.866 150 339.878C148.603 339.891 147.27 340.12 146.127 340.564C145.632 340.704 144.426 341.25 144.02 341.479L138.357 344.298Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M140.401 345.404C139.207 346.09 138.471 347.03 138.242 348.046C137.963 349.278 138.42 350.561 139.525 351.653C139.918 352.148 141.416 353.126 142.153 353.545L148.831 356.924L149.072 357.051C151.015 358.169 156.614 360.239 158.874 359.985C160.182 360.074 161.515 359.959 162.721 359.591C162.912 359.528 163.09 359.439 163.28 359.388C163.585 359.312 165.451 358.461 165.692 358.334L168.943 356.517C169.806 356.009 170.403 355.336 170.682 354.612C171.05 353.698 170.974 352.783 170.504 351.97C170.466 350.891 167.127 347.944 165.591 347.055L159.192 343.537C158.455 343.105 156.779 342.178 155.903 341.949C154.494 341.466 152.945 341.225 151.421 341.238C150.101 341.251 148.831 341.454 147.739 341.86C147.219 342.013 146.165 342.47 145.733 342.724L140.401 345.404Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M142.445 346.509C141.328 347.157 140.642 348.008 140.401 348.935C140.109 350.078 140.477 351.272 141.48 352.326C141.899 352.847 143.118 353.685 143.892 354.13L150.114 357.242L150.342 357.356C152.386 358.537 157.135 360.099 159.522 359.82C160.766 359.845 161.998 359.667 163.102 359.274C163.28 359.21 163.445 359.109 163.623 359.071C163.826 359.02 165.693 358.131 165.845 358.042L168.879 356.378C169.654 355.933 170.187 355.349 170.492 354.727C170.873 353.927 170.911 353.114 170.581 352.352C170.53 351.208 168.003 348.808 166.378 347.868L160.271 344.629C159.497 344.185 158.049 343.435 157.135 343.194C155.789 342.762 154.316 342.546 152.894 342.572C151.65 342.584 150.457 342.775 149.415 343.13C148.87 343.296 147.981 343.677 147.524 343.943L142.445 346.509Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M144.489 347.613C143.448 348.21 142.8 348.985 142.559 349.823C142.242 350.865 142.547 351.995 143.435 352.999C143.88 353.557 144.819 354.243 145.619 354.713L151.383 357.571L151.599 357.673C153.758 358.917 157.643 359.959 160.157 359.667C161.338 359.616 162.48 359.387 163.471 358.981C163.636 358.917 163.788 358.841 163.94 358.765C164.042 358.752 165.896 357.812 165.972 357.774L168.791 356.276C169.463 355.882 169.959 355.399 170.276 354.891C170.695 354.205 170.809 353.481 170.632 352.783C170.581 351.576 168.841 349.722 167.14 348.731L161.338 345.759C160.512 345.289 159.306 344.717 158.341 344.463C157.059 344.082 155.675 343.905 154.329 343.917C153.161 343.93 152.044 344.095 151.041 344.413C150.457 344.578 149.733 344.895 149.25 345.162L144.489 347.613Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.258 358.473L168.702 356.174C171.622 354.485 171.254 351.538 167.889 349.595L162.391 346.902C159.014 344.959 153.91 344.743 150.99 346.432L146.546 348.731C143.626 350.42 143.994 353.367 147.359 355.31L152.856 358.003C156.221 359.946 161.325 360.162 164.258 358.473Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M119.439 311.542C116.899 313.003 115.452 315.315 115.439 317.88C115.427 320.7 117.153 323.329 120.175 325.107C120.2 325.145 128.568 329.502 128.618 329.54L145.314 338.202C145.429 338.266 170.365 351.158 170.505 351.132C172.904 352.478 175.901 353.215 178.935 353.202C181.538 353.202 184.001 352.58 185.868 351.501L192.825 347.004C195.339 345.556 196.787 343.257 196.799 340.704C196.825 337.91 195.111 335.294 192.114 333.528C192.127 333.465 170.936 319.481 170.835 319.43L157.986 311.022C157.935 310.996 149.301 305.344 149.238 305.332C146.825 303.96 143.816 303.21 140.769 303.21C138.115 303.21 135.703 303.795 133.799 304.887C133.773 304.9 130.866 306.246 130.853 306.246L119.439 311.542Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M121.914 312.826C119.464 314.235 118.055 316.458 118.029 318.935C117.991 321.653 119.642 324.206 122.549 325.933C122.587 325.997 130.586 330.188 130.688 330.239L146.813 338.609C147.054 338.749 170.911 351.018 171.178 350.967C173.514 352.237 176.396 352.923 179.316 352.885C181.792 352.885 184.242 352.237 186.007 351.221L192.736 346.89C195.149 345.493 196.545 343.296 196.584 340.857C196.622 338.177 195.009 335.662 192.165 333.96C192.178 333.833 172.003 320.472 171.812 320.37L159.332 312.254C159.217 312.19 150.964 306.792 150.825 306.78C148.476 305.472 145.556 304.748 142.61 304.76C140.045 304.773 137.696 305.332 135.843 306.386C135.805 306.399 133.024 307.682 132.986 307.707L121.914 312.826Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M124.39 314.108C122.029 315.48 120.658 317.614 120.607 319.989C120.556 322.618 122.118 325.082 124.898 326.771C124.962 326.873 132.58 330.874 132.732 330.963L148.298 339.028C148.654 339.231 171.444 350.891 171.851 350.815C174.111 352.009 176.891 352.644 179.697 352.58C182.046 352.58 184.471 351.907 186.147 350.942L192.648 346.776C194.958 345.442 196.304 343.347 196.355 341.009C196.406 338.444 194.895 336.043 192.203 334.392C192.229 334.189 173.057 321.462 172.777 321.297L160.665 313.46C160.5 313.372 152.602 308.228 152.399 308.202C150.114 306.945 147.282 306.259 144.426 306.272C141.937 306.284 139.677 306.818 137.874 307.834C137.811 307.859 135.157 309.079 135.106 309.117L124.39 314.108Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M126.866 315.404C124.581 316.725 123.26 318.782 123.197 321.056C123.133 323.583 124.606 325.971 127.272 327.61C127.361 327.749 134.586 331.56 134.789 331.674L149.796 339.447C150.279 339.727 171.99 350.751 172.523 350.65C174.707 351.768 177.386 352.352 180.078 352.263C182.287 352.263 184.699 351.577 186.287 350.65L192.559 346.649C194.768 345.366 196.063 343.372 196.126 341.149C196.203 338.698 194.793 336.399 192.254 334.811C192.279 334.545 174.136 322.44 173.755 322.224L162.011 314.68C161.795 314.553 154.253 309.676 153.999 309.638C151.777 308.444 149.035 307.796 146.279 307.809C143.88 307.821 141.683 308.342 139.931 309.32C139.855 309.345 137.315 310.514 137.252 310.565L126.866 315.404Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M129.342 316.686C127.145 317.956 125.863 319.925 125.787 322.11C125.698 324.536 127.095 326.835 129.634 328.448C129.748 328.625 136.592 332.258 136.846 332.398L151.294 339.866C151.891 340.209 172.536 350.624 173.209 350.497C175.329 351.538 177.894 352.072 180.471 351.97C182.554 351.97 184.941 351.259 186.439 350.395L192.482 346.56C194.603 345.34 195.834 343.435 195.911 341.327C195.999 338.99 194.692 336.792 192.305 335.268C192.343 334.938 175.202 323.456 174.732 323.189L163.356 315.924C163.077 315.772 155.916 311.149 155.586 311.085C153.427 309.942 150.774 309.332 148.108 309.345C145.784 309.358 143.664 309.866 141.962 310.793C141.861 310.831 139.461 311.936 139.372 311.987L129.342 316.686Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M131.818 317.982C129.697 319.201 128.466 321.094 128.377 323.177C128.275 325.514 129.583 327.724 132.008 329.286C132.135 329.489 138.61 332.944 138.915 333.122L152.805 340.298C153.529 340.717 173.095 350.497 173.894 350.345C175.939 351.31 178.402 351.793 180.865 351.666C182.82 351.666 185.194 350.929 186.591 350.116L192.393 346.445C194.412 345.277 195.58 343.473 195.682 341.479C195.796 339.257 194.577 337.161 192.343 335.7C192.381 335.306 176.256 324.447 175.685 324.117L164.677 317.144C164.347 316.953 157.541 312.597 157.148 312.52C155.053 311.441 152.488 310.857 149.923 310.882C147.676 310.907 145.632 311.39 143.994 312.279C143.879 312.317 141.594 313.371 141.493 313.435L131.818 317.982Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M134.294 319.265C132.262 320.446 131.081 322.237 130.967 324.231C130.853 326.466 132.072 328.6 134.37 330.124C134.522 330.366 140.616 333.63 140.959 333.833L154.291 340.705C155.129 341.187 173.628 350.357 174.567 350.18C176.535 351.069 178.897 351.488 181.246 351.348C183.074 351.348 185.423 350.586 186.731 349.837L192.305 346.331C194.222 345.226 195.339 343.524 195.453 341.632C195.58 339.523 194.476 337.542 192.393 336.132C192.444 335.675 177.323 325.438 176.662 325.057L166.022 318.363C165.642 318.147 159.192 314.045 158.735 313.956C156.69 312.927 154.227 312.381 151.751 312.406C149.593 312.432 147.612 312.889 146.025 313.753C145.886 313.803 143.727 314.794 143.613 314.87L134.294 319.265Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M136.769 320.548C134.814 321.678 133.684 323.393 133.557 325.285C133.418 327.419 134.573 329.477 136.744 330.95C136.922 331.23 142.623 334.316 143.029 334.545L155.802 341.124C156.754 341.683 174.187 350.231 175.253 350.015C177.158 350.828 179.405 351.196 181.64 351.031C183.328 351.031 185.664 350.243 186.883 349.545L192.229 346.204C194.044 345.163 195.111 343.55 195.25 341.772C195.403 339.777 194.387 337.898 192.457 336.551C192.521 336.031 178.415 326.416 177.653 325.984L167.381 319.583C166.949 319.328 160.868 315.493 160.335 315.391C158.354 314.426 155.98 313.918 153.605 313.943C151.523 313.969 149.631 314.413 148.082 315.226C147.917 315.289 145.898 316.217 145.759 316.306L136.769 320.548Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M139.246 321.843C137.379 322.923 136.287 324.548 136.148 326.352C135.995 328.397 137.062 330.366 139.106 331.801C139.309 332.118 144.629 335.014 145.073 335.268L157.287 341.543C158.367 342.165 174.707 350.091 175.926 349.862C177.755 350.599 179.9 350.916 182.021 350.738C183.582 350.738 185.906 349.926 187.023 349.278L192.14 346.102C193.854 345.112 194.87 343.6 195.022 341.936C195.187 340.057 194.273 338.279 192.495 336.996C192.559 336.399 179.469 327.419 178.618 326.924L168.702 320.802C168.207 320.522 162.493 316.94 161.896 316.826C159.979 315.924 157.694 315.442 155.408 315.48C153.415 315.505 151.587 315.937 150.101 316.712C149.923 316.775 148.019 317.652 147.867 317.741L139.246 321.843Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M141.721 323.126C139.931 324.155 138.89 325.705 138.737 327.406C138.56 329.35 139.55 331.23 141.48 332.627C141.696 332.97 146.647 335.688 147.143 335.98L158.798 341.962C159.992 342.648 175.266 349.964 176.612 349.71C178.364 350.37 180.408 350.637 182.414 350.434C183.849 350.434 186.147 349.596 187.175 349.011L192.063 345.988C193.676 345.061 194.641 343.639 194.806 342.089C194.996 340.324 194.171 338.647 192.559 337.428C192.635 336.767 180.548 328.41 179.608 327.864L170.06 322.034C169.514 321.716 164.156 318.401 163.496 318.274C161.642 317.423 159.446 316.979 157.262 317.017C155.345 317.055 153.593 317.449 152.158 318.198C151.955 318.274 150.177 319.087 150.012 319.189L141.721 323.126Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M144.197 324.422C142.496 325.4 141.493 326.86 141.328 328.473C141.137 330.328 142.039 332.119 143.842 333.478C144.083 333.859 148.654 336.399 149.2 336.716L160.296 342.394C161.617 343.156 175.812 349.849 177.297 349.557C178.986 350.142 180.916 350.358 182.808 350.129C184.115 350.129 186.388 349.278 187.328 348.732L191.975 345.874C193.486 344.998 194.4 343.689 194.577 342.229C194.781 340.578 194.07 339.015 192.597 337.847C192.673 337.123 181.614 329.388 180.573 328.791L171.393 323.24C170.797 322.897 165.807 319.836 165.07 319.697C163.28 318.909 161.172 318.49 159.078 318.541C157.249 318.579 155.561 318.96 154.177 319.659C153.961 319.735 152.31 320.497 152.12 320.611L144.197 324.422Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M146.673 325.704C145.06 326.644 144.095 328.016 143.918 329.527C143.715 331.28 144.527 332.995 146.216 334.303C146.482 334.722 150.66 337.072 151.256 337.415L161.795 342.787C163.229 343.613 176.358 349.684 177.97 349.379C179.583 349.887 181.411 350.053 183.189 349.799C184.357 349.799 186.629 348.922 187.467 348.44L191.886 345.747C193.295 344.934 194.158 343.715 194.349 342.368C194.577 340.831 193.955 339.371 192.635 338.266C192.724 337.478 182.668 330.366 181.538 329.705L172.726 324.447C172.066 324.066 167.445 321.272 166.645 321.119C164.918 320.383 162.912 320.014 160.906 320.052C159.154 320.09 157.541 320.459 156.221 321.119C155.98 321.208 154.456 321.907 154.253 322.034L146.673 325.704Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M149.149 326.987C147.612 327.876 146.698 329.159 146.508 330.581C146.279 332.233 147.016 333.871 148.577 335.128C148.857 335.586 152.666 337.745 153.313 338.126L163.293 343.206C164.855 344.108 176.904 349.557 178.656 349.214C180.192 349.646 181.919 349.748 183.582 349.481C184.623 349.481 186.871 348.579 187.62 348.147L191.81 345.62C193.117 344.858 193.93 343.74 194.133 342.508C194.374 341.085 193.854 339.726 192.698 338.685C192.8 337.834 183.747 331.343 182.528 330.632L174.085 325.653C173.374 325.247 169.108 322.707 168.245 322.541C166.581 321.868 164.664 321.525 162.76 321.576C161.096 321.627 159.547 321.97 158.278 322.592C158.024 322.681 156.614 323.329 156.399 323.456L149.149 326.987Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M151.625 328.283C150.177 329.121 149.301 330.328 149.085 331.661C148.844 333.223 149.491 334.773 150.939 335.992C151.244 336.475 154.672 338.469 155.37 338.863L164.791 343.639C166.467 344.604 177.45 349.43 179.329 349.075C180.801 349.43 182.414 349.481 183.963 349.202C184.877 349.202 187.099 348.274 187.759 347.893L191.721 345.531C192.927 344.832 193.689 343.804 193.917 342.686C194.184 341.378 193.765 340.12 192.749 339.142C192.851 338.228 184.826 332.36 183.493 331.598L175.418 326.911C174.656 326.466 170.758 324.193 169.819 324.015C168.219 323.393 166.391 323.088 164.575 323.139C162.988 323.19 161.528 323.507 160.296 324.091C160.017 324.193 158.747 324.777 158.506 324.917L151.625 328.283Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M154.101 329.565C152.729 330.353 151.904 331.483 151.675 332.715C151.409 334.176 151.993 335.649 153.301 336.818C153.631 337.339 156.665 339.142 157.414 339.574L166.277 344.058C168.067 345.099 177.983 349.303 180.002 348.909C181.398 349.189 182.922 349.189 184.344 348.884C185.131 348.884 187.34 347.931 187.899 347.614L191.619 345.417C192.724 344.782 193.435 343.854 193.676 342.838C193.955 341.644 193.638 340.501 192.775 339.574C192.889 338.583 185.868 333.35 184.446 332.525L176.739 328.118C175.913 327.648 172.384 325.628 171.393 325.438C169.857 324.879 168.118 324.599 166.404 324.663C164.905 324.714 163.509 325.018 162.341 325.565C162.036 325.666 160.893 326.2 160.639 326.352L154.101 329.565Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M156.576 330.861C155.294 331.597 154.507 332.639 154.266 333.782C153.986 335.154 154.481 336.525 155.675 337.669C156.03 338.227 158.684 339.84 159.484 340.298L167.787 344.476C169.705 345.581 178.542 349.176 180.687 348.757C182.008 348.96 183.43 348.909 184.738 348.579C185.385 348.579 187.582 347.601 188.051 347.334L191.543 345.302C192.559 344.718 193.206 343.892 193.46 342.99C193.765 341.923 193.536 340.869 192.838 340.006C192.952 338.951 186.947 334.341 185.436 333.464L178.097 329.349C177.221 328.841 174.047 327.088 172.993 326.885C171.52 326.377 169.87 326.149 168.245 326.212C166.823 326.263 165.502 326.555 164.385 327.05C164.067 327.165 163.039 327.635 162.772 327.8L156.576 330.861Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M159.052 332.144C157.846 332.843 157.109 333.795 156.856 334.837C156.551 336.107 156.97 337.402 158.036 338.495C158.405 339.092 160.69 340.514 161.541 341.01L169.286 344.896C171.317 346.077 179.087 349.037 181.36 348.605C182.617 348.732 183.925 348.63 185.118 348.275C185.639 348.275 187.81 347.284 188.191 347.068L191.454 345.201C192.368 344.68 192.965 343.944 193.231 343.156C193.562 342.204 193.422 341.251 192.876 340.451C193.003 339.333 188.013 335.345 186.401 334.418L179.43 330.582C178.503 330.048 175.697 328.55 174.567 328.334C173.145 327.889 171.596 327.686 170.073 327.749C168.74 327.813 167.483 328.08 166.416 328.537C166.073 328.664 165.185 329.07 164.893 329.236L159.052 332.144Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M161.528 333.427C160.411 334.074 159.712 334.938 159.446 335.891C159.116 337.059 159.458 338.279 160.411 339.333C160.804 339.955 162.709 341.213 163.597 341.733L170.784 345.315C172.942 346.56 179.633 348.909 182.046 348.44C183.226 348.49 184.433 348.338 185.512 347.97C185.905 347.97 188.064 346.953 188.343 346.788L191.378 345.086C192.19 344.616 192.736 343.994 193.016 343.308C193.358 342.47 193.333 341.619 192.927 340.882C193.054 339.701 189.08 336.335 187.378 335.357L180.776 331.814C179.786 331.242 177.348 329.997 176.154 329.781C174.796 329.4 173.336 329.223 171.901 329.299C170.644 329.362 169.463 329.604 168.46 330.035C168.105 330.162 167.33 330.518 167.026 330.696L161.528 333.427Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M164.004 334.722C162.975 335.319 162.315 336.107 162.036 336.958C161.693 338.037 161.947 339.168 162.772 340.171C163.191 340.831 164.702 341.898 165.654 342.444L172.269 345.734C174.542 347.042 180.167 348.77 182.706 348.287C183.81 348.249 184.915 348.046 185.88 347.665C186.147 347.665 188.28 346.623 188.47 346.509L191.276 344.972C191.987 344.566 192.482 344.032 192.774 343.461C193.143 342.737 193.206 342 192.965 341.314C193.104 340.069 190.133 337.326 188.343 336.284L182.109 333.02C181.068 332.423 178.986 331.432 177.729 331.204C176.434 330.874 175.062 330.734 173.729 330.81C172.561 330.874 171.457 331.102 170.492 331.483C170.111 331.623 169.463 331.915 169.146 332.106L164.004 334.722Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M166.48 336.005C165.527 336.552 164.905 337.25 164.626 338.012C164.258 338.99 164.436 340.044 165.147 341.01C165.578 341.708 166.721 342.585 167.724 343.169L173.78 346.154C176.18 347.538 180.725 348.643 183.404 348.122C184.445 348.008 185.436 347.754 186.299 347.348C186.426 347.348 188.546 346.281 188.648 346.23L191.213 344.858C191.822 344.503 192.279 344.071 192.571 343.613C192.965 343.004 193.117 342.369 193.028 341.746C193.181 340.438 191.225 338.317 189.334 337.225L183.468 334.253C182.376 333.618 180.662 332.894 179.329 332.652C178.097 332.386 176.815 332.284 175.57 332.36C174.479 332.424 173.45 332.64 172.536 332.983C172.142 333.122 171.622 333.364 171.279 333.567L166.48 336.005Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.68 347.042L191.124 344.743C194.044 343.054 193.676 340.107 190.311 338.164L184.814 335.471C181.436 333.528 176.332 333.312 173.412 335.002L168.968 337.3C166.048 338.99 166.416 341.936 169.781 343.88L175.279 346.572C178.656 348.516 183.76 348.732 186.68 347.042Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M131.348 293.672C128.822 295.132 127.362 297.431 127.349 299.997C127.323 302.804 129.05 305.433 132.072 307.211C132.085 307.249 143.258 313.181 143.321 313.219L162.481 323.342C162.608 323.418 192.826 339.307 192.965 339.269C194.844 340.323 197.079 340.997 199.415 341.238C200.05 341.301 200.723 341.327 201.37 341.327C203.973 341.327 206.424 340.704 208.29 339.638L215.235 335.154C217.762 333.693 219.222 331.394 219.235 328.829C219.26 326.022 217.533 323.393 214.524 321.614C214.511 321.564 203.351 314.4 203.288 314.362L187.785 304.468L184.916 302.639C184.814 302.575 161.097 287.448 160.97 287.461C158.57 286.102 155.586 285.365 152.552 285.378C150.736 285.391 149.035 285.67 147.537 286.191C146.864 286.432 146.203 286.724 145.619 287.067L131.348 293.672Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M134.357 295.26C131.919 296.67 130.51 298.88 130.472 301.344C130.434 304.049 132.059 306.589 134.954 308.317C134.992 308.406 145.645 314.07 145.759 314.147L164.232 323.901C164.499 324.053 193.397 339.181 193.676 339.092C195.492 340.082 197.65 340.705 199.897 340.933C200.507 340.997 201.167 341.01 201.789 341.01C204.265 341.01 206.69 340.375 208.468 339.346L215.172 335.027C217.609 333.618 219.019 331.407 219.057 328.943C219.095 326.238 217.47 323.698 214.587 321.97C214.549 321.882 203.91 315.023 203.783 314.959L188.826 305.446L186.058 303.681C185.855 303.566 163.179 289.163 162.925 289.189C160.601 287.906 157.732 287.207 154.812 287.233C153.072 287.245 151.434 287.525 149.987 288.033C149.352 288.261 148.704 288.554 148.146 288.871L134.357 295.26Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M137.354 296.847C135.005 298.206 133.646 300.327 133.595 302.69C133.545 305.294 135.081 307.745 137.836 309.434C137.887 309.561 148.031 314.985 148.209 315.086L166.01 324.46C166.404 324.688 193.981 339.041 194.4 338.914C196.152 339.841 198.234 340.412 200.38 340.616C200.951 340.666 201.611 340.679 202.195 340.679C204.544 340.679 206.931 340.031 208.62 339.053L215.083 334.913C217.431 333.554 218.79 331.433 218.841 329.07C218.892 326.467 217.355 324.015 214.613 322.339C214.562 322.199 204.43 315.658 204.24 315.556L189.816 306.424L187.15 304.735C186.833 304.557 165.197 290.878 164.829 290.916C162.582 289.696 159.814 289.049 157.008 289.087C155.332 289.112 153.758 289.392 152.374 289.874C151.764 290.09 151.129 290.382 150.596 290.687L137.354 296.847Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M140.35 298.435C138.09 299.743 136.77 301.775 136.706 304.049C136.63 306.551 138.078 308.913 140.706 310.552C140.782 310.729 150.393 315.899 150.647 316.039L167.762 325.044C168.283 325.349 194.552 338.926 195.111 338.774C196.8 339.65 198.806 340.146 200.863 340.336C201.409 340.387 202.043 340.374 202.602 340.374C204.811 340.374 207.185 339.701 208.773 338.787L214.994 334.811C217.254 333.503 218.562 331.471 218.638 329.21C218.714 326.708 217.267 324.345 214.651 322.719C214.575 322.542 204.964 316.305 204.71 316.166L190.832 307.414L188.267 305.789C187.848 305.547 167.254 292.605 166.759 292.656C164.588 291.513 161.935 290.903 159.243 290.954C157.63 290.979 156.119 291.258 154.786 291.728C154.215 291.932 153.58 292.224 153.085 292.516L140.35 298.435Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M143.359 300.023C141.175 301.28 139.918 303.236 139.83 305.395C139.741 307.796 141.099 310.069 143.588 311.657C143.677 311.873 152.78 316.788 153.085 316.966L169.514 325.603C170.175 325.984 195.124 338.787 195.822 338.596C197.46 339.409 199.364 339.854 201.345 340.031C201.853 340.07 202.488 340.057 203.008 340.057C205.09 340.057 207.427 339.371 208.925 338.507L214.905 334.697C217.076 333.44 218.346 331.496 218.422 329.337C218.511 326.936 217.152 324.663 214.676 323.088C214.588 322.859 205.484 316.941 205.167 316.763L191.835 308.393L189.372 306.843C188.851 306.538 169.299 294.332 168.676 294.396C166.581 293.329 164.029 292.77 161.465 292.821C159.916 292.859 158.481 293.126 157.199 293.596C156.665 293.786 156.031 294.078 155.561 294.345L143.359 300.023Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M146.356 301.61C144.261 302.817 143.054 304.684 142.953 306.741C142.839 309.04 144.121 311.225 146.47 312.774C146.584 313.029 155.167 317.703 155.535 317.919L171.279 326.187C172.066 326.644 195.707 338.672 196.545 338.444C198.12 339.193 199.948 339.587 201.827 339.739C202.31 339.777 202.932 339.752 203.414 339.752C205.37 339.752 207.68 339.053 209.077 338.24L214.816 334.608C216.898 333.401 218.117 331.547 218.219 329.489C218.333 327.19 217.063 325.006 214.714 323.469C214.6 323.202 206.017 317.601 205.636 317.372L192.851 309.383L190.489 307.91C189.867 307.554 171.343 296.072 170.606 296.136C168.6 295.132 166.15 294.624 163.686 294.701C162.214 294.751 160.83 295.018 159.598 295.463C159.09 295.641 158.468 295.933 158.036 296.187L146.356 301.61Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M149.365 303.198C147.358 304.354 146.19 306.132 146.076 308.088C145.949 310.285 147.13 312.381 149.352 313.88C149.479 314.185 157.554 318.592 157.986 318.846L173.044 326.733C173.958 327.267 196.279 338.52 197.256 338.253C198.767 338.939 200.519 339.282 202.31 339.409C202.754 339.447 203.376 339.397 203.833 339.397C205.662 339.397 207.934 338.673 209.242 337.923L214.727 334.456C216.72 333.3 217.888 331.535 218.015 329.579C218.142 327.381 216.974 325.286 214.752 323.799C214.625 323.482 206.55 318.198 206.119 317.932L193.866 310.323L191.594 308.914C190.857 308.495 173.387 297.737 172.523 297.825C170.593 296.898 168.257 296.428 165.908 296.517C164.499 296.568 163.179 296.835 162.01 297.267C161.541 297.432 160.931 297.724 160.525 297.952L149.365 303.198Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M152.361 304.785C150.444 305.89 149.326 307.58 149.187 309.447C149.034 311.542 150.139 313.562 152.221 315.01C152.374 315.353 159.928 319.519 160.423 319.798L174.809 327.317C175.863 327.927 196.863 338.406 197.98 338.101C199.428 338.723 201.104 339.015 202.805 339.13C203.224 339.155 203.821 339.104 204.252 339.104C205.941 339.104 208.201 338.367 209.407 337.669L214.651 334.379C216.555 333.274 217.685 331.598 217.812 329.731C217.965 327.635 216.873 325.641 214.791 324.193C214.651 323.837 207.096 318.858 206.588 318.566L194.882 311.339L192.711 310.006C191.873 309.523 175.444 299.502 174.453 299.591C172.599 298.74 170.365 298.308 168.143 298.409C166.797 298.473 165.553 298.74 164.436 299.146C164.004 299.311 163.394 299.591 163.013 299.806L152.361 304.785Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M155.37 306.373C153.542 307.427 152.463 309.028 152.323 310.793C152.158 312.787 153.161 314.718 155.116 316.115C155.281 316.509 162.328 320.421 162.874 320.738L176.574 327.889C177.755 328.575 197.447 338.279 198.704 337.936C200.088 338.495 201.688 338.723 203.3 338.825C203.681 338.85 204.278 338.774 204.671 338.774C206.233 338.774 208.455 338.012 209.572 337.364L214.575 334.24C216.39 333.185 217.47 331.598 217.622 329.832C217.787 327.838 216.797 325.933 214.842 324.536C214.676 324.129 207.642 319.468 207.071 319.138L195.911 312.292L193.841 311.022C192.902 310.476 177.501 301.191 176.396 301.293C174.618 300.505 172.498 300.137 170.378 300.238C169.108 300.302 167.915 300.569 166.848 300.962C166.442 301.115 165.845 301.394 165.502 301.597L155.37 306.373Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M158.367 307.974C156.627 308.977 155.599 310.489 155.434 312.152C155.243 314.045 156.17 315.887 157.986 317.233C158.176 317.665 164.702 321.323 165.312 321.678L178.326 328.461C179.634 329.223 198.019 338.152 199.415 337.771C200.748 338.266 202.272 338.279 203.77 338.52C204.126 338.584 204.71 338.457 205.065 338.457C206.5 338.457 208.684 337.682 209.712 337.085L214.473 334.126C216.2 333.122 217.229 331.623 217.394 329.96C217.584 328.067 216.67 326.251 214.867 324.904C214.689 324.46 208.163 320.103 207.528 319.735L196.914 313.27L194.946 312.076C193.905 311.479 179.545 302.906 178.313 303.033C176.612 302.322 174.606 301.991 172.6 302.106C171.394 302.182 170.264 302.436 169.261 302.817C168.892 302.957 168.296 303.236 167.978 303.414L158.367 307.974Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M161.376 309.561C159.725 310.514 158.747 311.936 158.557 313.499C158.354 315.29 159.179 317.042 160.868 318.351C161.071 318.833 167.076 322.237 167.762 322.631L180.091 329.032C181.538 329.871 198.59 338.025 200.126 337.606C201.396 338.037 202.843 337.974 204.252 338.228C204.57 338.279 205.154 338.152 205.471 338.152C206.779 338.152 208.937 337.364 209.864 336.818L214.384 334.037C216.022 333.084 217.012 331.674 217.19 330.112C217.393 328.321 216.581 326.594 214.905 325.285C214.702 324.79 208.696 320.751 207.998 320.345L197.929 314.261L196.063 313.13C194.92 312.47 181.601 304.633 180.243 304.76C178.618 304.125 176.713 303.833 174.834 303.96C173.691 304.049 172.638 304.303 171.685 304.659C171.355 304.786 170.771 305.065 170.479 305.23L161.376 309.561Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M164.372 311.149C162.811 312.051 161.871 313.385 161.681 314.858C161.452 316.547 162.201 318.211 163.763 319.469C163.991 319.989 169.476 323.139 170.213 323.571L181.856 329.604C183.43 330.519 199.174 337.911 200.85 337.441C202.056 337.822 203.414 337.669 204.748 337.923C205.027 337.974 205.598 337.822 205.89 337.822C207.058 337.822 209.191 337.009 210.042 336.526L214.321 333.91C215.87 333.008 216.809 331.687 217.013 330.226C217.241 328.537 216.505 326.899 214.968 325.641C214.753 325.108 209.255 321.374 208.493 320.929L198.958 315.226L197.193 314.172C195.936 313.448 183.658 306.348 182.186 306.488C180.637 305.916 178.846 305.675 177.069 305.827C176.002 305.916 174.999 306.17 174.098 306.513C173.793 306.628 173.222 306.894 172.955 307.047L164.372 311.149Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M167.381 312.736C165.909 313.587 165.02 314.832 164.804 316.204C164.563 317.804 165.21 319.366 166.645 320.573C166.886 321.132 171.863 324.041 172.663 324.498L183.633 330.163C185.335 331.153 199.771 337.771 201.586 337.263C202.729 337.58 204.011 337.364 205.243 337.605C205.497 337.656 206.055 337.491 206.322 337.491C207.363 337.491 209.471 336.666 210.22 336.234L214.245 333.795C215.705 332.944 216.594 331.712 216.81 330.353C217.063 328.765 216.416 327.216 215.007 326.009C214.778 325.425 209.788 322.008 208.963 321.538L199.974 316.217L198.31 315.226C196.952 314.438 185.715 308.075 184.116 308.228C182.643 307.732 180.967 307.542 179.304 307.694C178.301 307.796 177.361 308.05 176.523 308.367C176.256 308.469 175.685 308.736 175.456 308.875L167.381 312.736Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M170.378 314.324C168.994 315.124 168.143 316.28 167.915 317.55C167.648 319.049 168.219 320.522 169.514 321.691C169.781 322.3 174.238 324.955 175.101 325.45L185.385 330.747C187.226 331.814 200.342 337.656 202.297 337.11C203.376 337.364 204.583 337.072 205.725 337.326C205.941 337.377 206.5 337.199 206.728 337.199C207.643 337.199 209.712 336.348 210.372 335.98L214.156 333.706C215.527 332.906 216.378 331.763 216.606 330.505C216.873 329.019 216.314 327.559 215.045 326.403C214.791 325.78 210.322 322.669 209.445 322.161L201.002 317.22L199.441 316.305C197.98 315.467 187.785 309.815 186.058 309.98C184.662 309.561 183.087 309.409 181.551 309.574C180.611 309.675 179.748 309.929 178.948 310.234C178.72 310.323 178.148 310.59 177.945 310.717L170.378 314.324Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M173.374 315.912C172.079 316.661 171.279 317.728 171.038 318.897C170.746 320.294 171.228 321.678 172.396 322.796C172.676 323.444 176.624 325.844 177.539 326.378L187.137 331.293C189.105 332.436 200.9 337.504 202.995 336.92C204.024 337.11 205.128 336.755 206.195 336.996C206.385 337.034 206.931 336.843 207.122 336.843C207.909 336.843 209.953 335.98 210.512 335.65L214.054 333.541C215.337 332.792 216.136 331.738 216.378 330.582C216.67 329.197 216.2 327.826 215.057 326.721C214.791 326.047 210.829 323.253 209.89 322.707L201.992 318.147L200.532 317.296C198.971 316.394 189.804 311.479 187.963 311.657C186.642 311.301 185.182 311.2 183.747 311.377C182.871 311.492 182.071 311.733 181.335 312.025C181.132 312.101 180.573 312.368 180.408 312.47L173.374 315.912Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M176.383 317.499C175.177 318.198 174.415 319.176 174.161 320.243C173.856 321.538 174.25 322.834 175.278 323.913C175.583 324.612 179.011 326.758 179.989 327.317L188.902 331.864C190.997 333.084 201.484 337.377 203.719 336.754C204.684 336.881 205.712 336.45 206.677 336.691C206.83 336.729 207.363 336.526 207.528 336.526C208.176 336.526 210.194 335.649 210.664 335.37L213.965 333.439C215.159 332.741 215.92 331.775 216.174 330.721C216.492 329.438 216.098 328.156 215.095 327.089C214.803 326.377 211.375 323.888 210.359 323.304L203.008 319.125L201.649 318.35C199.973 317.385 191.86 313.206 189.892 313.384C188.648 313.105 187.289 313.041 185.982 313.232C185.182 313.346 184.433 313.6 183.76 313.867C183.595 313.93 183.049 314.197 182.896 314.286L176.383 317.499Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M179.38 319.087C178.262 319.735 177.539 320.624 177.272 321.602C176.942 322.796 177.247 324.002 178.148 325.031C178.466 325.768 181.386 327.66 182.427 328.27L190.667 332.449C192.902 333.732 202.069 337.263 204.443 336.602C205.344 336.666 206.297 336.158 207.173 336.412C207.3 336.45 207.82 336.234 207.947 336.234C208.468 336.234 210.461 335.332 210.829 335.116L213.889 333.351C214.994 332.703 215.705 331.826 215.984 330.861C216.314 329.68 216.022 328.486 215.146 327.47C214.842 326.708 211.921 324.536 210.842 323.914L204.024 320.116L202.754 319.417C200.977 318.389 193.905 314.947 191.81 315.137C190.642 314.934 189.397 314.908 188.204 315.124C187.468 315.251 186.795 315.493 186.16 315.759C186.033 315.81 185.487 316.077 185.373 316.14L179.38 319.087Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M182.389 320.675C181.36 321.272 180.687 322.072 180.408 322.948C180.053 324.041 180.281 325.158 181.043 326.136C181.386 326.911 183.785 328.562 184.89 329.197L192.445 333.008C194.806 334.367 202.665 337.123 205.179 336.424C206.017 336.424 206.868 336.323 207.681 336.094C207.782 336.107 208.29 335.891 208.392 335.891C208.785 335.891 210.74 334.976 211.02 334.811L213.838 333.224C214.854 332.639 215.527 331.839 215.806 330.976C216.162 329.909 215.959 328.791 215.222 327.826C214.892 327.026 212.493 325.158 211.35 324.511L205.078 321.094L203.91 320.459C202.031 319.379 195.987 316.649 193.778 316.865C192.698 316.725 191.556 316.763 190.464 316.979C189.791 317.119 189.181 317.36 188.61 317.601C188.509 317.639 187.975 317.906 187.886 317.957L182.389 320.675Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M185.385 322.262C184.433 322.808 183.811 323.52 183.519 324.294C183.138 325.285 183.277 326.314 183.912 327.254C184.268 328.079 186.147 329.476 187.315 330.15L194.184 333.579C196.672 335.014 203.224 336.996 205.877 336.259C206.652 336.195 207.426 336.043 208.15 335.789C208.214 335.802 208.721 335.573 208.785 335.573C209.052 335.573 210.982 334.633 211.159 334.532L213.724 333.109C214.664 332.576 215.273 331.864 215.578 331.102C215.959 330.137 215.832 329.121 215.235 328.194C214.892 327.343 213 325.793 211.794 325.107L206.068 322.072L205.001 321.513C203.021 320.37 198.018 318.376 195.682 318.591C194.679 318.528 193.638 318.604 192.673 318.833C192.076 318.973 191.53 319.214 190.997 319.442C190.933 319.468 190.4 319.735 190.349 319.773L185.385 322.262Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M188.394 323.85C187.531 324.345 186.947 324.968 186.642 325.641C186.236 326.517 186.299 327.47 186.794 328.359C187.175 329.223 188.534 330.366 189.765 331.077L195.949 334.138C198.577 335.65 203.795 336.856 206.588 336.081C207.312 335.954 207.998 335.764 208.62 335.484C208.658 335.484 209.14 335.256 209.179 335.256C209.306 335.256 211.21 334.303 211.299 334.252L213.622 333.008C214.473 332.525 215.044 331.903 215.349 331.242C215.755 330.378 215.717 329.451 215.248 328.575C214.892 327.686 213.508 326.441 212.238 325.717L207.058 323.063L206.093 322.567C204.011 321.361 200.05 320.103 197.587 320.332C196.66 320.345 195.733 320.459 194.882 320.7C194.349 320.853 193.866 321.081 193.397 321.297C193.359 321.31 192.851 321.577 192.813 321.589L188.394 323.85Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.115 335.192L213.559 332.893C216.479 331.204 216.111 328.257 212.746 326.314L207.249 323.621C203.871 321.678 198.767 321.462 195.847 323.151L191.403 325.45C188.483 327.139 188.851 330.086 192.216 332.029L197.713 334.722C201.091 336.665 206.195 336.881 209.115 335.192Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.056 198.971L217.47 207.888L202.056 216.791L186.655 207.875L202.056 198.971Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.482 330.137L202.068 339.041V216.791L217.482 207.875V330.137Z",
    fill: "url(#paint27_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.068 339.041L186.655 330.137V207.875L202.068 216.791V339.041Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.655 207.875L201.992 216.144L217.482 207.875L202.526 217.122L202.068 339.041L201.332 217.02L186.655 207.875Z",
    fill: "url(#paint28_radial_1_2)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.964 239.12L195.365 248.036L179.964 256.939L164.55 248.023L179.964 239.12Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.377 342.444L179.964 351.36V256.927L195.377 248.023V342.444Z",
    fill: "url(#paint29_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.964 351.361L164.55 342.444V248.023L179.964 256.927V351.361Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.55 248.023L179.888 256.292L195.377 248.023L180.433 257.27L179.964 351.361L179.24 257.156L164.55 248.023Z",
    fill: "url(#paint30_radial_1_2)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.351 278.405L172.752 287.321L157.351 296.225L141.937 287.309L157.351 278.405Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.764 354.384L157.351 363.288V296.212L172.764 287.309V354.384Z",
    fill: "url(#paint31_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.351 363.288L141.937 354.384V287.309L157.351 296.212V363.288Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.937 287.309L157.275 295.577L172.765 287.309L157.821 296.555L157.351 363.287L156.627 296.441L141.937 287.309Z",
    fill: "url(#paint32_radial_1_2)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.017 319.151L150.419 328.054L135.017 336.958L119.604 328.054L135.017 319.151Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.017 359.071L150.419 367.974L135.017 376.878L119.604 367.974L135.017 359.071Z",
    fill: "url(#paint33_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.431 368.317L135.017 377.221V336.958L150.431 328.054V368.317Z",
    fill: "url(#paint34_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.017 377.221L119.604 368.317V328.054L135.017 336.958V377.221Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.604 328.054L134.941 336.323L150.431 328.054L135.487 337.301L135.017 377.221L134.294 337.186L119.604 328.054Z",
    fill: "url(#paint35_radial_1_2)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M236.337 465.253L241.263 462.294C241.276 462.281 242.406 461.608 242.419 461.595C244.222 460.566 246.482 460.007 248.754 460.02C249.846 460.02 250.887 460.172 251.84 460.426C252.589 460.63 253.338 460.947 253.96 461.303L285.626 479.339L286.578 479.872L317.304 497.374C318.751 498.213 319.83 499.521 320.199 500.905C320.3 501.286 320.364 501.68 320.376 502.087C320.427 504.182 319.145 506.164 316.834 507.497L311.908 510.457C311.895 510.469 310.765 511.143 310.752 511.155C308.949 512.184 306.689 512.743 304.417 512.73C303.325 512.73 302.284 512.578 301.331 512.324C300.582 512.12 299.833 511.803 299.211 511.447L267.546 493.412L266.593 492.878L235.867 475.376C234.42 474.538 233.341 473.229 232.972 471.845C232.871 471.464 232.807 471.07 232.795 470.664C232.744 468.555 234.039 466.574 236.337 465.253Z",
    fill: "#A9B0DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M238.825 466.854L243.472 464.085C243.498 464.072 244.526 463.45 244.564 463.437C246.266 462.472 248.399 461.964 250.532 461.977C251.56 461.989 252.538 462.129 253.427 462.383C254.1 462.574 254.861 462.891 255.407 463.221L285.168 480.19L286.057 480.698L314.929 497.146C316.224 497.896 317.342 499.166 317.684 500.411C317.786 500.766 317.862 501.135 317.888 501.503C317.989 503.459 316.808 505.326 314.637 506.583L309.99 509.352C309.965 509.365 308.924 509.987 308.898 510C307.197 510.965 305.064 511.473 302.931 511.461C301.903 511.448 300.925 511.308 300.036 511.054C299.363 510.864 298.601 510.546 298.055 510.216L268.294 493.247L267.406 492.739L238.533 476.291C237.238 475.542 236.121 474.271 235.778 473.027C235.677 472.671 235.6 472.303 235.575 471.934C235.461 469.978 236.642 468.111 238.825 466.854Z",
    fill: "#A2A9D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M241.314 468.454L245.669 465.888C245.707 465.863 246.647 465.304 246.697 465.278C248.297 464.389 250.291 463.919 252.284 463.945C253.249 463.957 254.163 464.11 254.988 464.351C255.585 464.516 256.347 464.859 256.842 465.139L284.699 481.028L285.537 481.511L312.555 496.917C313.71 497.59 314.853 498.822 315.183 499.927C315.285 500.258 315.374 500.588 315.399 500.931C315.564 502.734 314.485 504.5 312.428 505.694L308.073 508.259C308.035 508.285 307.095 508.844 307.045 508.869C305.445 509.758 303.452 510.228 301.458 510.203C300.493 510.19 299.579 510.038 298.754 509.796C298.157 509.631 297.395 509.288 296.9 509.009L269.044 493.12L268.206 492.637L241.187 477.23C240.032 476.557 238.889 475.325 238.559 474.22C238.457 473.89 238.368 473.56 238.343 473.217C238.178 471.4 239.257 469.635 241.314 468.454Z",
    fill: "#9CA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M243.79 470.055L247.853 467.679C247.903 467.641 248.741 467.146 248.805 467.121C250.303 466.308 252.17 465.876 254.023 465.914C254.925 465.939 255.763 466.092 256.537 466.32C257.058 466.473 257.82 466.816 258.251 467.07L284.203 481.879L284.978 482.324L310.143 496.689C311.158 497.273 312.326 498.48 312.644 499.433C312.745 499.737 312.847 500.042 312.885 500.347C313.101 502.011 312.123 503.662 310.193 504.78L306.13 507.155C306.08 507.193 305.242 507.688 305.178 507.714C303.68 508.527 301.814 508.958 299.96 508.92C299.058 508.895 298.22 508.743 297.446 508.514C296.925 508.361 296.164 508.019 295.732 507.765L269.78 492.955L269.005 492.51L243.841 478.145C242.825 477.561 241.657 476.354 241.339 475.402C241.238 475.097 241.136 474.792 241.098 474.487C240.895 472.823 241.86 471.172 243.79 470.055Z",
    fill: "#969CC8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M246.278 471.654L250.062 469.483C250.126 469.444 250.875 469 250.951 468.974C252.36 468.225 254.087 467.844 255.788 467.895C256.626 467.92 257.401 468.073 258.112 468.289C258.556 468.428 259.318 468.784 259.686 468.987L283.734 482.73L284.457 483.149L307.768 496.46C308.632 496.955 309.838 498.137 310.13 498.937C310.232 499.216 310.346 499.483 310.397 499.775C310.663 501.286 309.8 502.836 307.984 503.877L304.201 506.049C304.137 506.088 303.388 506.532 303.312 506.557C301.903 507.307 300.176 507.688 298.474 507.637C297.637 507.612 296.862 507.459 296.151 507.243C295.707 507.104 294.945 506.748 294.577 506.545L270.529 492.802L269.805 492.383L246.494 479.072C245.631 478.577 244.425 477.395 244.133 476.595C244.031 476.316 243.917 476.049 243.866 475.757C243.599 474.245 244.476 472.709 246.278 471.654Z",
    fill: "#8F96C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M248.767 473.268L252.259 471.286C252.348 471.235 252.982 470.854 253.084 470.816C254.392 470.143 255.992 469.8 257.541 469.864C258.302 469.902 259.026 470.054 259.674 470.258C260.042 470.372 260.816 470.74 261.121 470.918L283.264 483.581L283.937 483.962L305.394 496.232C306.118 496.651 307.362 497.781 307.629 498.454C307.731 498.708 307.857 498.937 307.921 499.204C308.251 500.575 307.477 502.011 305.801 502.976L302.309 504.957C302.22 505.008 301.585 505.389 301.484 505.427C300.176 506.1 298.576 506.443 297.027 506.38C296.265 506.342 295.542 506.189 294.894 505.986C294.526 505.872 293.752 505.503 293.447 505.326L271.304 492.663L270.631 492.281L249.173 480.012C248.45 479.593 247.206 478.463 246.939 477.789C246.837 477.535 246.71 477.307 246.647 477.04C246.317 475.668 247.079 474.233 248.767 473.268Z",
    fill: "#898FBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M251.255 474.868L254.455 473.077C254.557 473.027 255.102 472.696 255.204 472.658C256.41 472.049 257.883 471.756 259.292 471.833C259.991 471.871 260.638 472.036 261.235 472.226C261.527 472.328 262.302 472.709 262.543 472.849L282.781 484.432L283.391 484.788L302.994 496.016C303.578 496.346 304.962 497.413 305.102 497.972C305.242 498.175 305.343 498.404 305.419 498.632C305.8 499.852 305.14 501.172 303.578 502.074L300.379 503.865C300.277 503.916 299.731 504.246 299.63 504.284C298.424 504.894 296.951 505.186 295.541 505.11C294.843 505.072 294.196 504.907 293.599 504.716C293.307 504.614 292.532 504.233 292.291 504.094L272.053 492.51L271.443 492.155L251.839 480.927C251.255 480.596 249.871 479.53 249.732 478.971C249.592 478.767 249.491 478.539 249.414 478.31C249.033 477.091 249.694 475.77 251.255 474.868Z",
    fill: "#8289B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M253.731 476.468L256.639 474.881C256.753 474.817 257.198 474.563 257.325 474.512C258.429 473.979 259.775 473.725 261.032 473.814C261.667 473.865 262.251 474.017 262.784 474.208C263 474.284 263.774 474.678 263.965 474.779L282.299 485.296L282.858 485.613L300.608 495.787C301.039 496.041 302.474 497.07 302.588 497.489C302.741 497.667 302.842 497.857 302.931 498.061C303.363 499.14 302.804 500.347 301.369 501.185L298.462 502.773C298.348 502.836 297.903 503.09 297.776 503.141C296.672 503.675 295.326 503.929 294.069 503.84C293.434 503.789 292.85 503.636 292.317 503.446C292.101 503.37 291.326 502.976 291.136 502.874L272.802 492.358L272.243 492.04L254.493 481.867C254.062 481.612 252.614 480.584 252.513 480.165C252.36 479.987 252.259 479.796 252.17 479.593C251.738 478.513 252.297 477.294 253.731 476.468Z",
    fill: "#7C82AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M256.22 478.069L258.848 476.672C258.975 476.596 259.331 476.405 259.471 476.342C260.474 475.872 261.68 475.669 262.81 475.77C263.381 475.821 263.902 475.986 264.371 476.151C264.511 476.202 265.286 476.609 265.413 476.685L281.842 486.122L282.337 486.414L298.233 495.546C298.525 495.711 300.011 496.702 300.074 496.981C300.227 497.134 300.341 497.299 300.43 497.464C300.925 498.404 300.468 499.496 299.148 500.258L296.519 501.655C296.392 501.732 296.037 501.922 295.897 501.986C294.894 502.456 293.688 502.659 292.558 502.557C291.987 502.506 291.466 502.341 290.996 502.176C290.857 502.125 290.082 501.719 289.955 501.643L273.526 492.206L273.031 491.914L257.134 482.781C256.842 482.616 255.357 481.626 255.293 481.346C255.141 481.194 255.027 481.029 254.938 480.863C254.455 479.936 254.912 478.831 256.22 478.069Z",
    fill: "#767CA4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M258.709 479.669L261.045 478.475C261.184 478.399 261.438 478.26 261.591 478.196C262.492 477.802 263.571 477.65 264.549 477.752C265.057 477.802 265.501 477.98 265.908 478.133C265.984 478.158 266.758 478.59 266.809 478.628L281.321 486.985L281.766 487.239L295.808 495.33C295.948 495.419 297.484 496.372 297.522 496.511C297.675 496.638 297.802 496.765 297.903 496.905C298.462 497.692 298.094 498.683 296.913 499.369L294.577 500.563C294.437 500.639 294.183 500.779 294.031 500.842C293.129 501.236 292.05 501.389 291.072 501.287C290.565 501.236 290.12 501.058 289.714 500.906C289.638 500.88 288.863 500.449 288.812 500.411L274.3 492.053L273.856 491.799L259.813 483.708C259.674 483.619 258.137 482.667 258.099 482.527C257.947 482.4 257.82 482.273 257.718 482.133C257.16 481.359 257.515 480.368 258.709 479.669Z",
    fill: "#6F759D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.431 499.635L274.655 491.684L260.88 483.733C259.788 483.111 259.927 482.006 261.184 481.282L263.228 480.279C264.485 479.555 266.39 479.479 267.469 480.101L281.245 488.052L295.021 496.003C296.113 496.625 295.973 497.73 294.716 498.454L292.672 499.458C291.415 500.182 289.511 500.27 288.431 499.635Z",
    fill: "#696F96"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M194.286 493.882C240.889 493.882 278.668 469.06 278.668 438.441C278.668 407.822 240.889 383 194.286 383C147.683 383 109.904 407.822 109.904 438.441C109.904 469.06 147.683 493.882 194.286 493.882Z",
    fill: "url(#paint36_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.648 397.136C226.51 390.125 210.347 386.264 193.117 386.264C176.053 386.264 160.081 390.061 148.133 396.958C136.693 403.563 130.396 412.187 130.396 421.243C130.396 422.272 130.485 426.933 130.637 427.949C131.894 420.024 137.988 412.581 148.133 406.726C160.081 399.829 176.053 396.031 193.117 396.031C210.334 396.031 226.51 399.892 238.648 406.903C248.97 412.86 255.166 420.417 256.436 428.432C256.601 427.416 256.677 422.754 256.677 421.726C256.677 412.581 250.265 403.855 238.648 397.136Z",
    fill: "url(#paint37_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M193.117 388.258C176.053 388.258 160.081 392.055 148.133 398.952C136.693 405.557 130.396 414.181 130.396 423.237C130.396 432.382 136.795 441.12 148.425 447.827C160.563 454.838 176.726 458.699 193.955 458.699C211.02 458.699 226.992 454.901 238.94 448.004C250.379 441.4 256.677 432.776 256.677 423.72C256.677 414.575 250.278 405.836 238.648 399.13C226.51 392.119 210.334 388.258 193.117 388.258Z",
    fill: "url(#paint38_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.117 388.258C176.053 388.258 160.081 392.055 148.133 398.952C136.693 405.557 130.396 414.181 130.396 423.237C130.396 432.382 136.795 441.12 148.425 447.827C160.563 454.838 176.726 458.699 193.955 458.699C211.02 458.699 226.992 454.901 238.94 448.004C250.379 441.4 256.677 432.776 256.677 423.72C256.677 414.575 250.278 405.836 238.648 399.13C226.51 392.119 210.334 388.258 193.117 388.258Z",
    fill: "url(#paint39_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.943 462.598C175.698 462.598 158.494 458.458 145.479 450.939C131.957 443.127 124.505 432.585 124.505 421.243C124.505 410.002 131.843 399.562 145.187 391.865C158.011 384.46 175.037 380.37 193.117 380.37C211.362 380.37 228.566 384.511 241.581 392.03C255.102 399.841 262.555 410.384 262.555 421.726C262.555 432.966 255.217 443.407 241.873 451.104C229.049 458.521 212.023 462.598 193.943 462.598ZM193.117 386.264C176.053 386.264 160.081 390.062 148.133 396.958C136.693 403.563 130.396 412.187 130.396 421.243C130.396 430.388 136.795 439.126 148.425 445.833C160.563 452.844 176.726 456.705 193.955 456.705C211.02 456.705 226.992 452.907 238.94 446.01C250.379 439.406 256.677 430.782 256.677 421.726C256.677 412.581 250.278 403.842 238.648 397.136C226.51 390.125 210.334 386.264 193.117 386.264Z",
    fill: "url(#paint40_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.133 436.548C155.357 428.597 155.294 415.693 168.981 407.792C170.314 407.03 171.723 406.332 173.209 405.709L164.689 398.698C157.211 401.721 152.031 405.278 148.197 410.066C136.655 424.431 147.524 441.552 172.473 448.309L178.745 440.498C175.266 439.533 172.003 438.212 169.133 436.548Z",
    fill: "url(#paint41_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.901 419.884L228.985 420.557C229.862 426.323 226.51 432.255 218.904 436.637C214.232 439.329 208.557 441.107 202.551 441.958L206.36 450.087C229.925 446.48 245.11 433.931 242.901 419.884Z",
    fill: "url(#paint42_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.765 407.881C224.884 411.425 228.3 415.933 228.998 420.557L242.914 419.884C241.809 412.86 237.086 407.043 228.427 402.038L218.536 407.754C218.6 407.805 218.688 407.843 218.765 407.881Z",
    fill: "url(#paint43_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.523 407.754L228.414 402.039C211.108 392.043 184.611 390.658 164.664 398.698L173.184 405.709C186.832 400.019 206.081 400.705 218.523 407.754Z",
    fill: "url(#paint44_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.492 405.976L192.965 415.375C196.317 415.223 199.758 415.896 202.335 417.382C204.024 418.36 205.103 419.554 205.573 420.811L221.355 418.398C220.161 415.591 217.66 412.924 213.851 410.727C207.731 407.183 199.491 405.595 191.492 405.976Z",
    fill: "url(#paint45_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.386 427.098C197.752 429.778 190.222 429.765 185.563 427.073C185.207 426.87 184.877 426.641 184.572 426.412L171.203 431.81C172.054 432.484 172.993 433.119 174.047 433.728C185.093 440.104 203.008 440.142 213.991 433.804C216.263 432.496 218.054 431.01 219.374 429.423L204.532 425.409C203.986 426.006 203.275 426.577 202.386 427.098Z",
    fill: "url(#paint46_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.283 417.483L173.679 410.79C163.953 416.53 163.128 425.472 171.19 431.81L184.56 426.412C181.005 423.757 181.233 419.96 185.283 417.483Z",
    fill: "url(#paint47_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.512 417.344C187.582 416.15 190.248 415.489 192.965 415.375L191.492 405.976C185.068 406.268 178.808 407.83 173.92 410.65C173.844 410.701 173.768 410.739 173.691 410.79L185.296 417.483C185.36 417.445 185.436 417.394 185.512 417.344Z",
    fill: "url(#paint48_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.53 422.971C262.01 433.741 254.722 443.686 241.885 451.104C229.062 458.509 212.035 462.599 193.955 462.599C175.71 462.599 158.506 458.458 145.492 450.939C132.237 443.28 124.822 432.992 124.53 421.916V431.125L124.517 431.277C124.632 442.518 132.059 452.958 145.48 460.706C158.494 468.225 175.71 472.366 193.943 472.366C212.023 472.366 229.049 468.289 241.873 460.871C254.887 453.352 262.187 443.242 262.53 432.319L262.517 432.141V422.971H262.53Z",
    fill: "url(#paint49_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.648 396.438C226.51 389.426 210.347 385.565 193.118 385.565C176.053 385.565 160.081 389.363 148.133 396.26C136.694 402.864 130.396 411.489 130.396 420.545C130.396 420.71 130.409 420.875 130.409 421.027C130.637 412.149 136.909 403.715 148.133 397.238C160.081 390.341 176.053 386.543 193.118 386.543C210.334 386.543 226.51 390.404 238.648 397.416C250.075 404.008 256.449 412.555 256.664 421.523C256.664 421.357 256.677 421.192 256.677 421.027C256.677 411.882 250.265 403.157 238.648 396.438Z",
    fill: "url(#paint50_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.873 450.418C229.049 457.823 212.023 461.913 193.943 461.913C175.698 461.913 158.494 457.772 145.48 450.253C132.148 442.556 124.72 432.192 124.517 421.053C124.517 421.218 124.505 421.383 124.505 421.548C124.505 432.89 131.958 443.432 145.48 451.243C158.494 458.763 175.71 462.903 193.943 462.903C212.023 462.903 229.049 458.826 241.873 451.409C255.204 443.712 262.556 433.271 262.556 422.031C262.556 421.866 262.543 421.7 262.543 421.548C262.34 432.585 255.014 442.823 241.873 450.418Z",
    fill: "url(#paint51_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.458 460.744C234.458 461.912 234.864 462.725 235.512 463.132C235.537 463.144 244.73 468.428 244.755 468.428C245.428 468.809 244.996 467.945 246.025 467.348C248.094 466.155 249.783 463.246 249.783 460.871C249.783 459.69 250.875 459.69 250.202 459.296C250.189 459.283 240.857 453.987 240.832 453.974C240.159 453.606 239.232 453.669 238.216 454.266C236.134 455.46 234.458 458.356 234.458 460.744Z",
    fill: "url(#paint52_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79 466.079C243.79 468.454 245.466 469.419 247.548 468.225C249.618 467.031 251.306 464.123 251.306 461.748C251.306 459.372 249.63 458.407 247.548 459.601C245.466 460.795 243.79 463.691 243.79 466.079Z",
    fill: "url(#paint53_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.37 459.5C248.361 458.928 249.262 458.852 249.935 459.182C249.313 459.004 248.526 459.144 247.688 459.627C245.618 460.821 243.93 463.729 243.93 466.104C243.93 467.349 244.387 468.2 245.11 468.556C244.196 468.302 243.6 467.387 243.6 465.977C243.612 463.602 245.288 460.706 247.37 459.5Z",
    fill: "url(#paint54_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.495 468.733C242.495 470.829 243.219 472.315 244.387 473.026C244.425 473.052 305.128 509.542 305.153 509.568C306.372 510.254 305.597 508.704 307.451 507.625C311.184 505.465 314.206 500.245 314.206 495.965C314.206 493.844 316.161 493.831 314.968 493.12C314.929 493.094 253.998 456.566 253.96 456.54C252.741 455.88 251.078 456.007 249.237 457.061C245.517 459.22 242.495 464.453 242.495 468.733Z",
    fill: "url(#paint55_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.426 505.325C303.426 509.606 306.448 511.333 310.181 509.186C313.914 507.027 316.935 501.807 316.935 497.527C316.935 493.246 313.914 491.519 310.181 493.665C306.461 495.825 303.426 501.045 303.426 505.325Z",
    fill: "url(#paint56_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.863 493.501C311.654 492.472 313.279 492.332 314.485 492.929C313.355 492.612 311.958 492.853 310.447 493.729C306.715 495.889 303.693 501.109 303.693 505.389C303.693 507.624 304.518 509.161 305.826 509.809C304.175 509.352 303.109 507.701 303.109 505.16C303.109 500.88 306.131 495.66 309.863 493.501Z",
    fill: "url(#paint57_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M104.165 420.011C107.77 436.243 132.262 444.613 158.887 438.707C185.499 432.801 204.164 414.842 200.558 398.61C196.952 382.377 172.46 374.007 145.835 379.913C119.223 385.819 100.571 403.779 104.165 420.011Z",
    fill: "url(#paint58_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M238.648 399.118C226.51 392.107 210.347 388.245 193.118 388.245C182.198 388.245 171.724 389.808 162.455 392.742C196.317 402.801 222.752 424.139 233.747 450.672C235.55 449.834 237.277 448.945 238.927 447.992C250.367 441.387 256.664 432.763 256.664 423.707C256.677 414.575 250.265 405.837 238.648 399.118Z",
    fill: "url(#paint59_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.868 484.749C457.802 484.749 471.53 478.352 471.53 470.46C471.53 462.569 457.802 456.171 440.868 456.171C423.933 456.171 410.205 462.569 410.205 470.46C410.205 478.352 423.933 484.749 440.868 484.749Z",
    fill: "url(#paint60_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.625 466.078C490.559 466.078 504.287 459.681 504.287 451.789C504.287 443.898 490.559 437.501 473.625 437.501C456.691 437.501 442.963 443.898 442.963 451.789C442.963 459.681 456.691 466.078 473.625 466.078Z",
    fill: "url(#paint61_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.002 459.855C426.936 459.855 440.665 453.458 440.665 445.566C440.665 437.674 426.936 431.277 410.002 431.277C393.068 431.277 379.34 437.674 379.34 445.566C379.34 453.458 393.068 459.855 410.002 459.855Z",
    fill: "url(#paint62_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 443.382H446.543V449.974H446.556C446.556 450.037 446.543 450.101 446.543 450.164C446.543 457.671 456.992 463.767 469.892 463.767C482.792 463.767 493.241 457.683 493.241 450.164C493.241 450.101 493.229 450.037 493.229 449.974H493.241V443.382H493.229Z",
    fill: "url(#paint63_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 462.307C456.98 462.307 446.53 456.223 446.53 448.704V449.974H446.543C446.543 450.037 446.53 450.101 446.53 450.164C446.53 457.671 456.98 463.767 469.88 463.767C482.767 463.767 493.229 457.684 493.229 450.164C493.229 450.101 493.216 450.037 493.216 449.974H493.229V448.704C493.229 456.223 482.779 462.307 469.88 462.307Z",
    fill: "url(#paint64_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 449.288V449.097H493.216C493.216 449.161 493.229 449.224 493.229 449.288Z",
    fill: "url(#paint65_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.028 463.106C477.244 463.068 477.459 463.017 477.688 462.967V445.693H477.028V463.106Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.961 462.421C480.177 462.357 480.405 462.307 480.621 462.243V445.706H479.961V462.421Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.893 461.456C483.122 461.367 483.325 461.265 483.554 461.176V445.706H482.893V461.456Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.095 463.526C474.311 463.501 474.539 463.488 474.755 463.462V445.706H474.095V463.526Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.759 458.14C488.988 457.962 489.204 457.784 489.42 457.594V445.693H488.759V458.14Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.692 454.978C491.934 454.597 492.162 454.216 492.353 453.822V445.706H491.692V454.978Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.827 460.071C486.042 459.956 486.271 459.842 486.487 459.715V445.693H485.827V460.071Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.162 463.729C471.378 463.716 471.606 463.716 471.822 463.703V445.693H471.162V463.729Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.229 463.716C468.445 463.729 468.661 463.729 468.889 463.742V445.706H468.229V463.716Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.376 463.031C462.592 463.069 462.807 463.12 463.036 463.17V445.706H462.376V463.031Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.296 463.501C465.512 463.526 465.728 463.539 465.956 463.564V445.706H465.296V463.501Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.443 462.319C459.659 462.382 459.875 462.446 460.103 462.497V445.693H459.443V462.319Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.711 454.393C447.914 454.749 448.117 455.092 448.371 455.435V445.693H447.711V454.393Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.644 457.861C450.847 458.039 451.076 458.204 451.304 458.369V445.706H450.644V457.861Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.51 461.303C456.726 461.392 456.942 461.481 457.17 461.557V445.706H456.51V461.303Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.577 459.88C453.793 459.994 454.009 460.109 454.237 460.223V445.693H453.577V459.88Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 457.086C482.775 457.086 493.229 450.996 493.229 443.483C493.229 435.97 482.775 429.88 469.88 429.88C456.984 429.88 446.53 435.97 446.53 443.483C446.53 450.996 456.984 457.086 469.88 457.086Z",
    fill: "url(#paint66_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 456.718C457.259 456.718 447 450.875 446.581 443.585C446.569 443.737 446.543 443.902 446.543 444.055C446.543 451.561 456.992 457.658 469.892 457.658C482.792 457.658 493.241 451.574 493.241 444.055C493.241 443.89 493.216 443.737 493.203 443.585C492.759 450.875 482.5 456.718 469.88 456.718Z",
    fill: "url(#paint67_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.879 453.644C479.514 453.644 487.325 449.095 487.325 443.483C487.325 437.872 479.514 433.322 469.879 433.322C460.245 433.322 452.434 437.872 452.434 443.483C452.434 449.095 460.245 453.644 469.879 453.644Z",
    fill: "url(#paint68_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.464 433.817C479.783 433.817 487.376 438.072 487.871 443.432C487.883 443.254 487.922 443.077 487.922 442.886C487.922 437.272 480.113 432.725 470.464 432.725C460.827 432.725 453.018 437.272 453.018 442.886C453.018 443.077 453.044 443.254 453.069 443.432C453.552 438.085 461.144 433.817 470.464 433.817Z",
    fill: "url(#paint69_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 434.402C479.199 434.402 486.792 438.669 487.287 444.017C487.299 443.839 487.337 443.661 487.337 443.471C487.337 437.857 479.529 433.31 469.892 433.31C460.255 433.31 452.447 437.857 452.447 443.471C452.447 443.661 452.472 443.839 452.498 444.017C452.968 438.669 460.56 434.402 469.88 434.402Z",
    fill: "url(#paint70_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.144 430.376C487.388 432.167 490.931 435.723 490.042 438.314C489.153 440.918 484.189 441.566 478.945 439.787C473.701 437.997 470.159 434.44 471.048 431.849C471.924 429.258 476.901 428.598 482.144 430.376Z",
    fill: "url(#paint71_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 440.283C470.794 440.359 470.349 440.473 469.88 440.588C469.473 440.689 469.054 440.816 468.585 440.969C468.127 441.121 467.683 441.286 467.277 441.464L468.673 442.277C468.813 442.226 468.965 442.163 469.131 442.112C469.296 442.061 469.473 441.998 469.638 441.934C470.438 441.655 471.187 441.413 471.886 441.236C472.584 441.045 473.244 440.918 473.866 440.855C474.488 440.791 475.073 440.804 475.631 440.905C476.19 441.007 476.736 441.197 477.244 441.502C477.853 441.858 478.247 442.239 478.412 442.633C478.577 443.039 478.577 443.446 478.412 443.852C478.247 444.258 477.955 444.678 477.536 445.084C477.117 445.49 476.622 445.871 476.05 446.24L477.942 447.332L476.368 448.234L474.45 447.129C473.485 447.612 472.457 448.043 471.34 448.437C470.235 448.818 469.156 449.123 468.127 449.339L467.112 446.849C467.645 446.748 468.191 446.621 468.75 446.481C469.219 446.367 469.753 446.214 470.337 446.024C470.921 445.833 471.467 445.63 471.987 445.389L470.616 444.601C470.134 444.792 469.626 444.97 469.105 445.135C468.331 445.389 467.62 445.592 466.985 445.744C466.35 445.884 465.766 445.973 465.233 445.999C464.699 446.024 464.217 445.986 463.76 445.884C463.315 445.783 462.884 445.617 462.477 445.376C461.919 445.046 461.538 444.703 461.347 444.309C461.157 443.928 461.094 443.522 461.195 443.115C461.284 442.696 461.513 442.29 461.868 441.858C462.224 441.439 462.681 441.032 463.239 440.651L461.665 439.737L463.227 438.835L464.814 439.749C465.283 439.521 465.766 439.318 466.261 439.127C466.744 438.937 467.239 438.772 467.721 438.619C468.204 438.467 468.661 438.327 469.118 438.213C469.562 438.098 469.981 437.984 470.349 437.882L471.225 440.283ZM465.956 442.798C466.109 442.887 466.299 442.925 466.528 442.899C466.756 442.887 467.048 442.823 467.391 442.722L466.21 442.036C465.74 442.366 465.664 442.62 465.956 442.798ZM473.46 444.043C473.32 443.954 473.105 443.928 472.838 443.954C472.571 443.979 472.267 444.043 471.924 444.144L473.079 444.805C473.371 444.614 473.536 444.449 473.587 444.335C473.638 444.22 473.587 444.119 473.46 444.043Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 439.711C470.794 439.787 470.349 439.901 469.88 440.016C469.473 440.117 469.054 440.244 468.585 440.397C468.127 440.549 467.683 440.714 467.277 440.892L468.673 441.705C468.813 441.654 468.965 441.591 469.131 441.54C469.296 441.489 469.473 441.425 469.638 441.362C470.438 441.083 471.187 440.841 471.886 440.663C472.584 440.473 473.244 440.346 473.866 440.282C474.488 440.219 475.073 440.232 475.631 440.333C476.19 440.435 476.736 440.625 477.244 440.93C477.853 441.286 478.247 441.667 478.412 442.061C478.577 442.467 478.577 442.873 478.412 443.28C478.247 443.686 477.955 444.105 477.536 444.512C477.117 444.918 476.622 445.299 476.05 445.668L477.942 446.76L476.368 447.662L474.45 446.557C473.485 447.039 472.457 447.471 471.34 447.865C470.235 448.246 469.156 448.551 468.127 448.767L467.112 446.277C467.645 446.176 468.191 446.049 468.75 445.909C469.219 445.795 469.753 445.642 470.337 445.452C470.921 445.261 471.467 445.058 471.987 444.817L470.616 444.029C470.134 444.22 469.626 444.398 469.105 444.563C468.331 444.817 467.62 445.02 466.985 445.172C466.35 445.312 465.766 445.401 465.233 445.426C464.699 445.452 464.217 445.414 463.76 445.312C463.315 445.21 462.884 445.045 462.477 444.804C461.919 444.474 461.538 444.131 461.347 443.737C461.157 443.356 461.094 442.95 461.195 442.543C461.284 442.124 461.513 441.718 461.868 441.286C462.224 440.867 462.681 440.46 463.239 440.079L461.665 439.165L463.227 438.263L464.814 439.177C465.283 438.949 465.766 438.745 466.261 438.555C466.744 438.364 467.239 438.199 467.721 438.047C468.204 437.895 468.661 437.755 469.118 437.64C469.562 437.526 469.981 437.412 470.349 437.31L471.225 439.711ZM465.956 442.213C466.109 442.302 466.299 442.34 466.528 442.315C466.756 442.302 467.048 442.238 467.391 442.137L466.21 441.451C465.74 441.781 465.664 442.035 465.956 442.213ZM473.46 443.458C473.32 443.369 473.105 443.343 472.838 443.369C472.571 443.394 472.267 443.458 471.924 443.559L473.079 444.22C473.371 444.029 473.536 443.864 473.587 443.75C473.638 443.635 473.587 443.534 473.46 443.458Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 435.571H446.543V442.163H446.556C446.556 442.226 446.543 442.29 446.543 442.353C446.543 449.859 456.992 455.956 469.892 455.956C482.792 455.956 493.241 449.872 493.241 442.353C493.241 442.29 493.229 442.226 493.229 442.163H493.241V435.571H493.229Z",
    fill: "url(#paint72_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 454.482C456.98 454.482 446.53 448.398 446.53 440.879V442.149H446.543C446.543 442.213 446.53 442.276 446.53 442.34C446.53 449.846 456.98 455.943 469.88 455.943C482.767 455.943 493.229 449.859 493.229 442.34C493.229 442.276 493.216 442.213 493.216 442.149H493.229V440.879C493.229 448.398 482.779 454.482 469.88 454.482Z",
    fill: "url(#paint73_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 441.476V441.286H493.216C493.216 441.349 493.229 441.413 493.229 441.476Z",
    fill: "url(#paint74_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.028 455.283C477.244 455.245 477.459 455.194 477.688 455.143V437.882H477.028V455.283Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.961 454.597C480.177 454.534 480.405 454.483 480.621 454.419V437.882H479.961V454.597Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.893 453.632C483.122 453.543 483.325 453.441 483.554 453.352V437.882H482.893V453.632Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.095 455.715C474.311 455.689 474.539 455.677 474.755 455.651V437.882H474.095V455.715Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.759 450.317C488.988 450.139 489.204 449.961 489.42 449.771V437.882H488.759V450.317Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.692 447.154C491.934 446.773 492.162 446.392 492.353 445.998V437.882H491.692V447.154Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.827 452.26C486.042 452.146 486.271 452.031 486.487 451.904V437.882H485.827V452.26Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.162 455.905C471.378 455.893 471.606 455.893 471.822 455.88V437.882H471.162V455.905Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.229 455.893C468.445 455.905 468.661 455.905 468.889 455.905V437.882H468.229V455.893Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.376 455.207C462.592 455.245 462.807 455.296 463.036 455.346V437.882H462.376V455.207Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.296 455.677C465.512 455.702 465.728 455.715 465.956 455.74V437.882H465.296V455.677Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.443 454.495C459.659 454.559 459.875 454.622 460.103 454.673V437.882H459.443V454.495Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.711 446.583C447.914 446.938 448.117 447.281 448.371 447.624V437.882H447.711V446.583Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.644 450.037C450.847 450.215 451.076 450.38 451.304 450.545V437.882H450.644V450.037Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.51 453.479C456.726 453.568 456.942 453.657 457.17 453.733V437.882H456.51V453.479Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.577 452.07C453.793 452.184 454.009 452.298 454.237 452.412V437.882H453.577V452.07Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 449.262C482.775 449.262 493.229 443.172 493.229 435.659C493.229 428.146 482.775 422.056 469.88 422.056C456.984 422.056 446.53 428.146 446.53 435.659C446.53 443.172 456.984 449.262 469.88 449.262Z",
    fill: "url(#paint75_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 448.894C457.259 448.894 447 443.051 446.581 435.76C446.569 435.913 446.543 436.078 446.543 436.23C446.543 443.737 456.992 449.833 469.892 449.833C482.792 449.833 493.241 443.75 493.241 436.23C493.241 436.065 493.216 435.913 493.203 435.76C492.759 443.064 482.5 448.894 469.88 448.894Z",
    fill: "url(#paint76_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.879 445.82C479.514 445.82 487.325 441.271 487.325 435.659C487.325 430.047 479.514 425.498 469.879 425.498C460.245 425.498 452.434 430.047 452.434 435.659C452.434 441.271 460.245 445.82 469.879 445.82Z",
    fill: "url(#paint77_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.464 426.006C479.783 426.006 487.376 430.274 487.871 435.621C487.883 435.443 487.922 435.266 487.922 435.075C487.922 429.461 480.113 424.914 470.464 424.914C460.827 424.914 453.018 429.461 453.018 435.075C453.018 435.266 453.044 435.443 453.069 435.621C453.552 430.261 461.144 426.006 470.464 426.006Z",
    fill: "url(#paint78_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 426.59C479.199 426.59 486.792 430.858 487.287 436.205C487.299 436.027 487.337 435.849 487.337 435.659C487.337 430.045 479.529 425.498 469.892 425.498C460.255 425.498 452.447 430.045 452.447 435.659C452.447 435.849 452.472 436.027 452.498 436.205C452.968 430.845 460.56 426.59 469.88 426.59Z",
    fill: "url(#paint79_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.144 422.564C487.388 424.355 490.931 427.912 490.042 430.503C489.153 433.094 484.189 433.754 478.945 431.976C473.701 430.185 470.159 426.629 471.048 424.038C471.924 421.434 476.901 420.773 482.144 422.564Z",
    fill: "url(#paint80_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 432.471C470.794 432.548 470.349 432.662 469.88 432.776C469.473 432.878 469.054 433.005 468.585 433.157C468.127 433.31 467.683 433.475 467.277 433.653L468.673 434.465C468.813 434.415 468.965 434.351 469.131 434.3C469.296 434.25 469.473 434.186 469.638 434.123C470.438 433.843 471.187 433.602 471.886 433.424C472.584 433.233 473.244 433.106 473.866 433.043C474.488 432.979 475.073 432.992 475.631 433.094C476.19 433.195 476.736 433.386 477.244 433.691C477.853 434.046 478.247 434.427 478.412 434.821C478.577 435.228 478.577 435.634 478.412 436.04C478.247 436.447 477.955 436.866 477.536 437.272C477.117 437.679 476.622 438.06 476.05 438.428L477.942 439.521L476.368 440.422L474.45 439.317C473.485 439.8 472.457 440.232 471.34 440.626C470.235 441.007 469.156 441.311 468.127 441.527L467.112 439.038C467.645 438.936 468.191 438.809 468.75 438.67C469.219 438.555 469.753 438.403 470.337 438.212C470.921 438.022 471.467 437.819 471.987 437.577L470.616 436.79C470.134 436.98 469.626 437.158 469.105 437.323C468.331 437.577 467.62 437.78 466.985 437.933C466.35 438.073 465.766 438.162 465.233 438.187C464.699 438.212 464.217 438.174 463.76 438.073C463.315 437.971 462.884 437.806 462.477 437.565C461.919 437.234 461.538 436.891 461.347 436.498C461.157 436.117 461.094 435.71 461.195 435.304C461.284 434.885 461.513 434.478 461.868 434.046C462.224 433.627 462.681 433.221 463.239 432.84L461.665 431.925L463.227 431.023L464.814 431.938C465.283 431.709 465.766 431.506 466.261 431.316C466.744 431.125 467.239 430.96 467.721 430.807C468.204 430.655 468.661 430.515 469.118 430.401C469.562 430.287 469.981 430.172 470.349 430.071L471.225 432.471ZM465.956 434.974C466.109 435.062 466.299 435.101 466.528 435.075C466.756 435.062 467.048 434.999 467.391 434.897L466.21 434.211C465.74 434.542 465.664 434.796 465.956 434.974ZM473.46 436.218C473.32 436.129 473.105 436.104 472.838 436.129C472.571 436.155 472.267 436.218 471.924 436.32L473.079 436.98C473.371 436.79 473.536 436.625 473.587 436.51C473.638 436.396 473.587 436.294 473.46 436.218Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 431.887C470.794 431.963 470.349 432.077 469.88 432.192C469.473 432.293 469.054 432.42 468.585 432.573C468.127 432.725 467.683 432.89 467.277 433.068L468.673 433.881C468.813 433.83 468.965 433.767 469.131 433.716C469.296 433.665 469.473 433.602 469.638 433.538C470.438 433.259 471.187 433.017 471.886 432.84C472.584 432.649 473.244 432.522 473.866 432.458C474.488 432.395 475.073 432.408 475.631 432.509C476.19 432.611 476.736 432.801 477.244 433.106C477.853 433.462 478.247 433.843 478.412 434.237C478.577 434.643 478.577 435.05 478.412 435.456C478.247 435.862 477.955 436.282 477.536 436.688C477.117 437.094 476.622 437.475 476.05 437.844L477.942 438.936L476.368 439.838L474.45 438.733C473.485 439.216 472.457 439.647 471.34 440.041C470.235 440.422 469.156 440.727 468.127 440.943L467.112 438.453C467.645 438.352 468.191 438.225 468.75 438.085C469.219 437.971 469.753 437.818 470.337 437.628C470.921 437.437 471.467 437.234 471.987 436.993L470.616 436.205C470.134 436.396 469.626 436.574 469.105 436.739C468.331 436.993 467.62 437.196 466.985 437.348C466.35 437.488 465.766 437.577 465.233 437.602C464.699 437.628 464.217 437.59 463.76 437.488C463.315 437.387 462.884 437.221 462.477 436.98C461.919 436.65 461.538 436.307 461.347 435.913C461.157 435.532 461.094 435.126 461.195 434.719C461.284 434.3 461.513 433.894 461.868 433.462C462.224 433.043 462.681 432.636 463.239 432.255L461.665 431.341L463.227 430.439L464.814 431.353C465.283 431.125 465.766 430.922 466.261 430.731C466.744 430.541 467.239 430.375 467.721 430.223C468.204 430.071 468.661 429.931 469.118 429.817C469.562 429.702 469.981 429.588 470.349 429.486L471.225 431.887ZM465.956 434.389C466.109 434.478 466.299 434.516 466.528 434.491C466.756 434.478 467.048 434.414 467.391 434.313L466.21 433.627C465.74 433.957 465.664 434.211 465.956 434.389ZM473.46 435.634C473.32 435.545 473.105 435.519 472.838 435.545C472.571 435.57 472.267 435.634 471.924 435.735L473.079 436.396C473.371 436.205 473.536 436.04 473.587 435.926C473.638 435.812 473.587 435.723 473.46 435.634Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 427.747H446.543V434.339H446.556C446.556 434.402 446.543 434.466 446.543 434.529C446.543 442.036 456.992 448.132 469.892 448.132C482.792 448.132 493.241 442.048 493.241 434.529C493.241 434.466 493.229 434.402 493.229 434.339H493.241V427.747H493.229Z",
    fill: "url(#paint81_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 446.671C456.98 446.671 446.53 440.587 446.53 433.068V434.338H446.543C446.543 434.402 446.53 434.465 446.53 434.529C446.53 442.035 456.98 448.132 469.88 448.132C482.767 448.132 493.229 442.048 493.229 434.529C493.229 434.465 493.216 434.402 493.216 434.338H493.229V433.068C493.229 440.575 482.779 446.671 469.88 446.671Z",
    fill: "url(#paint82_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 433.652V433.462H493.216C493.216 433.525 493.229 433.589 493.229 433.652Z",
    fill: "url(#paint83_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.028 447.472C477.244 447.433 477.459 447.383 477.688 447.332V430.058H477.028V447.472Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.961 446.773C480.177 446.71 480.405 446.659 480.621 446.595V430.058H479.961V446.773Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.893 445.808C483.122 445.719 483.325 445.617 483.554 445.528V430.058H482.893V445.808Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.095 447.891C474.311 447.865 474.539 447.853 474.755 447.827V430.071H474.095V447.891Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.759 442.493C488.988 442.315 489.204 442.137 489.42 441.946V430.045H488.759V442.493Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.692 439.33C491.934 438.949 492.162 438.568 492.353 438.174V430.058H491.692V439.33Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.827 444.436C486.042 444.322 486.271 444.207 486.487 444.08V430.058H485.827V444.436Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.162 448.081C471.378 448.068 471.606 448.068 471.822 448.056V430.045H471.162V448.081Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.229 448.069C468.445 448.081 468.661 448.081 468.889 448.094V430.058H468.229V448.069Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.376 447.395C462.592 447.434 462.807 447.484 463.036 447.535V430.071H462.376V447.395Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.296 447.853C465.512 447.878 465.728 447.891 465.956 447.916V430.058H465.296V447.853Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.443 446.671C459.659 446.735 459.875 446.798 460.103 446.849V430.045H459.443V446.671Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.711 438.759C447.914 439.114 448.117 439.457 448.371 439.8V430.058H447.711V438.759Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.644 442.213C450.847 442.391 451.076 442.556 451.304 442.721V430.058H450.644V442.213Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.51 445.655C456.726 445.744 456.942 445.833 457.17 445.909V430.058H456.51V445.655Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.577 444.245C453.793 444.36 454.009 444.474 454.237 444.588V430.058H453.577V444.245Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 441.438C482.775 441.438 493.229 435.348 493.229 427.835C493.229 420.323 482.775 414.232 469.88 414.232C456.984 414.232 446.53 420.323 446.53 427.835C446.53 435.348 456.984 441.438 469.88 441.438Z",
    fill: "url(#paint84_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 441.07C457.259 441.07 447 435.227 446.581 427.937C446.569 428.089 446.543 428.254 446.543 428.407C446.543 435.913 456.992 442.01 469.892 442.01C482.792 442.01 493.241 435.926 493.241 428.407C493.241 428.241 493.216 428.089 493.203 427.937C492.759 435.24 482.5 441.07 469.88 441.07Z",
    fill: "url(#paint85_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.879 437.996C479.514 437.996 487.325 433.447 487.325 427.835C487.325 422.223 479.514 417.674 469.879 417.674C460.245 417.674 452.434 422.223 452.434 427.835C452.434 433.447 460.245 437.996 469.879 437.996Z",
    fill: "url(#paint86_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.464 418.182C479.783 418.182 487.376 422.437 487.871 427.797C487.883 427.619 487.922 427.441 487.922 427.251C487.922 421.637 480.113 417.09 470.464 417.09C460.827 417.09 453.018 421.637 453.018 427.251C453.018 427.441 453.044 427.619 453.069 427.797C453.552 422.45 461.144 418.182 470.464 418.182Z",
    fill: "url(#paint87_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 418.766C479.199 418.766 486.792 423.034 487.287 428.381C487.299 428.203 487.337 428.026 487.337 427.835C487.337 422.221 479.529 417.674 469.892 417.674C460.255 417.674 452.447 422.221 452.447 427.835C452.447 428.026 452.472 428.203 452.498 428.381C452.968 423.021 460.56 418.766 469.88 418.766Z",
    fill: "url(#paint88_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.144 414.74C487.388 416.531 490.931 420.088 490.042 422.679C489.153 425.282 484.189 425.93 478.945 424.152C473.701 422.361 470.159 418.805 471.048 416.214C471.924 413.61 476.901 412.95 482.144 414.74Z",
    fill: "url(#paint89_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 424.647C470.794 424.723 470.349 424.838 469.88 424.952C469.473 425.053 469.054 425.18 468.585 425.333C468.127 425.485 467.683 425.65 467.277 425.828L468.673 426.641C468.813 426.59 468.965 426.527 469.131 426.476C469.296 426.425 469.473 426.362 469.638 426.298C470.438 426.019 471.187 425.777 471.886 425.6C472.584 425.409 473.244 425.282 473.866 425.219C474.488 425.155 475.073 425.168 475.631 425.269C476.19 425.371 476.736 425.561 477.244 425.866C477.853 426.222 478.247 426.603 478.412 426.997C478.577 427.403 478.577 427.81 478.412 428.216C478.247 428.622 477.955 429.042 477.536 429.448C477.117 429.854 476.622 430.236 476.05 430.604L477.942 431.696L476.368 432.598L474.45 431.493C473.485 431.976 472.457 432.407 471.34 432.801C470.235 433.182 469.156 433.487 468.127 433.703L467.112 431.214C467.645 431.112 468.191 430.985 468.75 430.845C469.219 430.731 469.753 430.578 470.337 430.388C470.921 430.197 471.467 429.994 471.987 429.753L470.616 428.965C470.134 429.156 469.626 429.334 469.105 429.499C468.331 429.753 467.62 429.956 466.985 430.109C466.35 430.248 465.766 430.337 465.233 430.363C464.699 430.388 464.217 430.35 463.76 430.248C463.315 430.147 462.884 429.981 462.477 429.74C461.919 429.41 461.538 429.067 461.347 428.673C461.157 428.292 461.094 427.886 461.195 427.479C461.284 427.06 461.513 426.654 461.868 426.222C462.224 425.803 462.681 425.396 463.239 425.015L461.665 424.101L463.227 423.199L464.814 424.114C465.283 423.885 465.766 423.682 466.261 423.491C466.744 423.301 467.239 423.136 467.721 422.983C468.204 422.831 468.661 422.691 469.118 422.577C469.562 422.462 469.981 422.348 470.349 422.246L471.225 424.647ZM465.956 427.149C466.109 427.238 466.299 427.276 466.528 427.251C466.756 427.238 467.048 427.175 467.391 427.073L466.21 426.387C465.74 426.717 465.664 426.971 465.956 427.149ZM473.46 428.407C473.32 428.318 473.105 428.292 472.838 428.318C472.571 428.343 472.267 428.407 471.924 428.508L473.079 429.169C473.371 428.978 473.536 428.813 473.587 428.699C473.638 428.584 473.587 428.483 473.46 428.407Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 424.063C470.794 424.139 470.349 424.254 469.88 424.368C469.473 424.47 469.054 424.597 468.585 424.749C468.127 424.901 467.683 425.066 467.277 425.244L468.673 426.057C468.813 426.006 468.965 425.943 469.131 425.892C469.296 425.841 469.473 425.778 469.638 425.714C470.438 425.435 471.187 425.193 471.886 425.016C472.584 424.825 473.244 424.698 473.866 424.635C474.488 424.571 475.073 424.584 475.631 424.685C476.19 424.787 476.736 424.978 477.244 425.282C477.853 425.638 478.247 426.019 478.412 426.426C478.577 426.832 478.577 427.238 478.412 427.645C478.247 428.051 477.955 428.47 477.536 428.877C477.117 429.283 476.622 429.664 476.05 430.033L477.942 431.125L476.368 432.027L474.45 430.922C473.485 431.404 472.457 431.836 471.34 432.23C470.235 432.611 469.156 432.916 468.127 433.132L467.112 430.642C467.645 430.541 468.191 430.414 468.75 430.274C469.219 430.16 469.753 430.007 470.337 429.817C470.921 429.626 471.467 429.423 471.987 429.182L470.616 428.394C470.134 428.585 469.626 428.763 469.105 428.928C468.331 429.182 467.62 429.385 466.985 429.537C466.35 429.677 465.766 429.766 465.233 429.791C464.699 429.817 464.217 429.779 463.76 429.677C463.315 429.575 462.884 429.41 462.477 429.169C461.919 428.839 461.538 428.496 461.347 428.102C461.157 427.721 461.094 427.315 461.195 426.908C461.284 426.489 461.513 426.083 461.868 425.651C462.224 425.232 462.681 424.825 463.239 424.444L461.665 423.53L463.227 422.628L464.814 423.542C465.283 423.314 465.766 423.111 466.261 422.92C466.744 422.729 467.239 422.564 467.721 422.412C468.204 422.26 468.661 422.12 469.118 422.005C469.562 421.891 469.981 421.777 470.349 421.675L471.225 424.063ZM465.956 426.565C466.109 426.654 466.299 426.692 466.528 426.667C466.756 426.654 467.048 426.591 467.391 426.489L466.21 425.803C465.74 426.146 465.664 426.4 465.956 426.565ZM473.46 427.823C473.32 427.734 473.105 427.708 472.838 427.734C472.571 427.759 472.267 427.823 471.924 427.924L473.079 428.585C473.371 428.394 473.536 428.229 473.587 428.115C473.638 428 473.587 427.899 473.46 427.823Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 419.897H446.543V426.489H446.556C446.556 426.553 446.543 426.616 446.543 426.68C446.543 434.186 456.992 440.283 469.892 440.283C482.792 440.283 493.241 434.199 493.241 426.68C493.241 426.616 493.229 426.553 493.229 426.489H493.241V419.897H493.229Z",
    fill: "url(#paint90_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 438.822C456.98 438.822 446.53 432.738 446.53 425.219V426.489H446.543C446.543 426.553 446.53 426.616 446.53 426.68C446.53 434.186 456.98 440.283 469.88 440.283C482.767 440.283 493.229 434.199 493.229 426.68C493.229 426.616 493.216 426.553 493.216 426.489H493.229V425.219C493.229 432.726 482.779 438.822 469.88 438.822Z",
    fill: "url(#paint91_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 425.803V425.613H493.216C493.216 425.676 493.229 425.74 493.229 425.803Z",
    fill: "url(#paint92_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.028 439.623C477.244 439.584 477.459 439.534 477.688 439.483V422.209H477.028V439.623Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.961 438.924C480.177 438.861 480.405 438.81 480.621 438.746V422.209H479.961V438.924Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.893 437.959C483.122 437.87 483.325 437.768 483.554 437.679V422.209H482.893V437.959Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.095 440.041C474.311 440.016 474.539 440.003 474.755 439.978V422.222H474.095V440.041Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.759 434.643C488.988 434.465 489.204 434.288 489.42 434.097V422.196H488.759V434.643Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.692 431.481C491.934 431.1 492.162 430.719 492.353 430.325V422.209H491.692V431.481Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.827 436.587C486.042 436.473 486.271 436.358 486.487 436.231V422.209H485.827V436.587Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.162 440.232C471.378 440.219 471.606 440.219 471.822 440.206V422.196H471.162V440.232Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.229 440.22C468.445 440.232 468.661 440.232 468.889 440.245V422.209H468.229V440.22Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.376 439.534C462.592 439.572 462.807 439.623 463.036 439.673V422.209H462.376V439.534Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.296 440.004C465.512 440.029 465.728 440.042 465.956 440.067V422.209H465.296V440.004Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.443 438.822C459.659 438.885 459.875 438.949 460.103 439V422.196H459.443V438.822Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.711 430.91C447.914 431.265 448.117 431.608 448.371 431.951V422.209H447.711V430.91Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.644 434.364C450.847 434.542 451.076 434.707 451.304 434.872V422.209H450.644V434.364Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.51 437.806C456.726 437.895 456.942 437.984 457.17 438.06V422.196H456.51V437.806Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.577 436.396C453.793 436.511 454.009 436.625 454.237 436.739V422.209H453.577V436.396Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 433.589C482.775 433.589 493.229 427.499 493.229 419.986C493.229 412.473 482.775 406.383 469.88 406.383C456.984 406.383 446.53 412.473 446.53 419.986C446.53 427.499 456.984 433.589 469.88 433.589Z",
    fill: "url(#paint93_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 433.22C457.259 433.22 447 427.378 446.581 420.087C446.569 420.24 446.543 420.405 446.543 420.557C446.543 428.064 456.992 434.16 469.892 434.16C482.792 434.16 493.241 428.076 493.241 420.557C493.241 420.392 493.216 420.24 493.203 420.087C492.759 427.391 482.5 433.22 469.88 433.22Z",
    fill: "url(#paint94_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.879 430.147C479.514 430.147 487.325 425.598 487.325 419.986C487.325 414.374 479.514 409.825 469.879 409.825C460.245 409.825 452.434 414.374 452.434 419.986C452.434 425.598 460.245 430.147 469.879 430.147Z",
    fill: "url(#paint95_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.464 410.333C479.783 410.333 487.376 414.601 487.871 419.948C487.883 419.77 487.922 419.592 487.922 419.402C487.922 413.788 480.113 409.241 470.464 409.241C460.827 409.241 453.018 413.788 453.018 419.402C453.018 419.592 453.044 419.77 453.069 419.948C453.552 414.588 461.144 410.333 470.464 410.333Z",
    fill: "url(#paint96_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 410.917C479.199 410.917 486.792 415.185 487.287 420.532C487.299 420.354 487.337 420.176 487.337 419.986C487.337 414.372 479.529 409.825 469.892 409.825C460.255 409.825 452.447 414.372 452.447 419.986C452.447 420.176 452.472 420.354 452.498 420.532C452.968 415.172 460.56 410.917 469.88 410.917Z",
    fill: "url(#paint97_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.144 406.891C487.388 408.682 490.931 412.238 490.042 414.83C489.153 417.433 484.189 418.081 478.945 416.303C473.701 414.512 470.159 410.956 471.048 408.365C471.924 405.761 476.901 405.1 482.144 406.891Z",
    fill: "url(#paint98_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 416.798C470.794 416.874 470.349 416.989 469.88 417.103C469.473 417.205 469.054 417.332 468.585 417.484C468.127 417.637 467.683 417.802 467.277 417.98L468.673 418.792C468.813 418.742 468.965 418.678 469.131 418.627C469.296 418.576 469.473 418.513 469.638 418.449C470.438 418.17 471.187 417.929 471.886 417.751C472.584 417.56 473.244 417.433 473.866 417.37C474.488 417.306 475.073 417.319 475.631 417.421C476.19 417.522 476.736 417.713 477.244 418.018C477.853 418.373 478.247 418.754 478.412 419.148C478.577 419.554 478.577 419.961 478.412 420.367C478.247 420.774 477.955 421.193 477.536 421.599C477.117 422.006 476.622 422.387 476.05 422.755L477.942 423.847L476.368 424.749L474.45 423.644C473.485 424.127 472.457 424.559 471.34 424.953C470.235 425.334 469.156 425.638 468.127 425.854L467.112 423.365C467.645 423.263 468.191 423.136 468.75 422.997C469.219 422.882 469.753 422.73 470.337 422.539C470.921 422.349 471.467 422.146 471.987 421.904L470.616 421.117C470.134 421.307 469.626 421.485 469.105 421.65C468.331 421.904 467.62 422.107 466.985 422.26C466.35 422.4 465.766 422.488 465.233 422.514C464.699 422.539 464.217 422.501 463.76 422.4C463.315 422.298 462.884 422.133 462.477 421.891C461.919 421.561 461.538 421.218 461.347 420.825C461.157 420.444 461.094 420.037 461.195 419.631C461.284 419.212 461.513 418.805 461.868 418.373C462.224 417.954 462.681 417.548 463.239 417.167L461.665 416.252L463.227 415.35L464.814 416.265C465.283 416.036 465.766 415.833 466.261 415.642C466.744 415.452 467.239 415.287 467.721 415.134C468.204 414.982 468.661 414.842 469.118 414.728C469.562 414.614 469.981 414.499 470.349 414.398L471.225 416.798ZM465.956 419.3C466.109 419.389 466.299 419.427 466.528 419.402C466.756 419.389 467.048 419.326 467.391 419.224L466.21 418.538C465.74 418.869 465.664 419.123 465.956 419.3ZM473.46 420.545C473.32 420.456 473.105 420.431 472.838 420.456C472.571 420.482 472.267 420.545 471.924 420.647L473.079 421.307C473.371 421.117 473.536 420.952 473.587 420.837C473.638 420.723 473.587 420.634 473.46 420.545Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 416.214C470.794 416.29 470.349 416.404 469.88 416.519C469.473 416.62 469.054 416.747 468.585 416.9C468.127 417.052 467.683 417.217 467.277 417.395L468.673 418.208C468.813 418.157 468.965 418.094 469.131 418.043C469.296 417.992 469.473 417.928 469.638 417.865C470.438 417.586 471.187 417.344 471.886 417.166C472.584 416.976 473.244 416.849 473.866 416.785C474.488 416.722 475.073 416.735 475.631 416.836C476.19 416.938 476.736 417.128 477.244 417.433C477.853 417.789 478.247 418.17 478.412 418.564C478.577 418.97 478.577 419.376 478.412 419.783C478.247 420.189 477.955 420.608 477.536 421.015C477.117 421.421 476.622 421.802 476.05 422.171L477.942 423.263L476.368 424.165L474.45 423.06C473.485 423.542 472.457 423.974 471.34 424.368C470.235 424.762 469.156 425.054 468.127 425.27L467.112 422.78C467.645 422.679 468.191 422.552 468.75 422.412C469.219 422.298 469.753 422.145 470.337 421.955C470.921 421.764 471.467 421.561 471.987 421.32L470.616 420.532C470.134 420.723 469.626 420.901 469.105 421.066C468.331 421.32 467.62 421.523 466.985 421.675C466.35 421.815 465.766 421.904 465.233 421.929C464.699 421.955 464.217 421.917 463.76 421.815C463.315 421.713 462.884 421.548 462.477 421.307C461.919 420.977 461.538 420.634 461.347 420.24C461.157 419.859 461.094 419.453 461.195 419.046C461.284 418.627 461.513 418.221 461.868 417.789C462.224 417.37 462.681 416.963 463.239 416.582L461.665 415.668L463.227 414.766L464.814 415.68C465.283 415.452 465.766 415.249 466.261 415.058C466.744 414.867 467.239 414.702 467.721 414.55C468.204 414.398 468.661 414.258 469.118 414.144C469.562 414.029 469.981 413.915 470.349 413.813L471.225 416.214ZM465.956 418.716C466.109 418.805 466.299 418.843 466.528 418.818C466.756 418.805 467.048 418.741 467.391 418.64L466.21 417.954C465.74 418.297 465.664 418.538 465.956 418.716ZM473.46 419.973C473.32 419.884 473.105 419.859 472.838 419.884C472.571 419.91 472.267 419.973 471.924 420.075L473.079 420.735C473.371 420.545 473.536 420.38 473.587 420.266C473.638 420.151 473.587 420.05 473.46 419.973Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 412.39H446.543V418.982H446.556C446.556 419.046 446.543 419.109 446.543 419.173C446.543 426.679 456.992 432.776 469.892 432.776C482.792 432.776 493.241 426.692 493.241 419.173C493.241 419.109 493.229 419.046 493.229 418.982H493.241V412.39H493.229Z",
    fill: "url(#paint99_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 431.315C456.98 431.315 446.53 425.231 446.53 417.712V418.982H446.543C446.543 419.046 446.53 419.109 446.53 419.173C446.53 426.679 456.98 432.776 469.88 432.776C482.767 432.776 493.229 426.692 493.229 419.173C493.229 419.109 493.216 419.046 493.216 418.982H493.229V417.712C493.229 425.231 482.779 431.315 469.88 431.315Z",
    fill: "url(#paint100_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 418.296V418.106H493.216C493.216 418.169 493.229 418.233 493.229 418.296Z",
    fill: "url(#paint101_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.028 432.115C477.244 432.077 477.459 432.026 477.688 431.976V414.702H477.028V432.115Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.961 431.417C480.177 431.353 480.405 431.302 480.621 431.239V414.702H479.961V431.417Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.893 430.464C483.122 430.375 483.325 430.273 483.554 430.184V414.714H482.893V430.464Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.095 432.534C474.311 432.509 474.539 432.496 474.755 432.471V414.714H474.095V432.534Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.759 427.149C488.988 426.971 489.204 426.794 489.42 426.603V414.702H488.759V427.149Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.692 423.974C491.934 423.593 492.162 423.212 492.353 422.818V414.702H491.692V423.974Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.827 429.08C486.042 428.965 486.271 428.851 486.487 428.724V414.702H485.827V429.08Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.162 432.738C471.378 432.725 471.606 432.725 471.822 432.712V414.702H471.162V432.738Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.229 432.725C468.445 432.737 468.661 432.737 468.889 432.75V414.714H468.229V432.725Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.376 432.039C462.592 432.077 462.807 432.128 463.036 432.178V414.714H462.376V432.039Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.296 432.509C465.512 432.534 465.728 432.547 465.956 432.572V414.714H465.296V432.509Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.443 431.315C459.659 431.379 459.875 431.442 460.103 431.493V414.689H459.443V431.315Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.711 423.402C447.914 423.758 448.117 424.101 448.371 424.444V414.702H447.711V423.402Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.644 426.857C450.847 427.035 451.076 427.2 451.304 427.365V414.702H450.644V426.857Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.51 430.299C456.726 430.388 456.942 430.477 457.17 430.553V414.689H456.51V430.299Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.577 428.889C453.793 429.004 454.009 429.118 454.237 429.232V414.702H453.577V428.889Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 426.095C482.775 426.095 493.229 420.005 493.229 412.492C493.229 404.98 482.775 398.889 469.88 398.889C456.984 398.889 446.53 404.98 446.53 412.492C446.53 420.005 456.984 426.095 469.88 426.095Z",
    fill: "url(#paint102_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 425.727C457.259 425.727 447 419.884 446.581 412.594C446.569 412.746 446.543 412.911 446.543 413.064C446.543 420.57 456.992 426.667 469.892 426.667C482.792 426.667 493.241 420.583 493.241 413.064C493.241 412.898 493.216 412.746 493.203 412.594C492.759 419.884 482.5 425.727 469.88 425.727Z",
    fill: "url(#paint103_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.879 422.653C479.514 422.653 487.325 418.104 487.325 412.492C487.325 406.88 479.514 402.331 469.879 402.331C460.245 402.331 452.434 406.88 452.434 412.492C452.434 418.104 460.245 422.653 469.879 422.653Z",
    fill: "url(#paint104_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.464 402.827C479.783 402.827 487.376 407.082 487.871 412.441C487.883 412.264 487.922 412.086 487.922 411.895C487.922 406.281 480.113 401.734 470.464 401.734C460.827 401.734 453.018 406.281 453.018 411.895C453.018 412.086 453.044 412.264 453.069 412.441C453.552 407.094 461.144 402.827 470.464 402.827Z",
    fill: "url(#paint105_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 403.411C479.199 403.411 486.792 407.678 487.287 413.025C487.299 412.848 487.337 412.67 487.337 412.479C487.337 406.865 479.529 402.318 469.892 402.318C460.255 402.318 452.447 406.865 452.447 412.479C452.447 412.67 452.472 412.848 452.498 413.025C452.968 407.678 460.56 403.411 469.88 403.411Z",
    fill: "url(#paint106_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.144 399.385C487.388 401.175 490.931 404.732 490.042 407.323C489.153 409.927 484.189 410.574 478.945 408.796C473.701 407.005 470.159 403.449 471.048 400.858C471.924 398.254 476.901 397.606 482.144 399.385Z",
    fill: "url(#paint107_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 409.291C470.794 409.367 470.349 409.482 469.88 409.596C469.473 409.698 469.054 409.825 468.585 409.977C468.127 410.129 467.683 410.295 467.277 410.472L468.673 411.285C468.813 411.234 468.965 411.171 469.131 411.12C469.296 411.069 469.473 411.006 469.638 410.942C470.438 410.663 471.187 410.422 471.886 410.244C472.584 410.053 473.244 409.926 473.866 409.863C474.488 409.799 475.073 409.812 475.631 409.914C476.19 410.015 476.736 410.206 477.244 410.511C477.853 410.866 478.247 411.247 478.412 411.641C478.577 412.047 478.577 412.454 478.412 412.86C478.247 413.267 477.955 413.686 477.536 414.092C477.117 414.499 476.622 414.88 476.05 415.248L477.942 416.34L476.368 417.242L474.45 416.137C473.485 416.62 472.457 417.052 471.34 417.445C470.235 417.826 469.156 418.131 468.127 418.347L467.112 415.858C467.645 415.756 468.191 415.629 468.75 415.489C469.219 415.375 469.753 415.223 470.337 415.032C470.921 414.842 471.467 414.638 471.987 414.397L470.616 413.61C470.134 413.8 469.626 413.978 469.105 414.143C468.331 414.397 467.62 414.6 466.985 414.753C466.35 414.892 465.766 414.981 465.233 415.007C464.699 415.032 464.217 414.994 463.76 414.892C463.315 414.791 462.884 414.626 462.477 414.384C461.919 414.054 461.538 413.711 461.347 413.317C461.157 412.936 461.094 412.53 461.195 412.124C461.284 411.704 461.513 411.298 461.868 410.866C462.224 410.447 462.681 410.041 463.239 409.66L461.665 408.745L463.227 407.843L464.814 408.758C465.283 408.529 465.766 408.326 466.261 408.135C466.744 407.945 467.239 407.78 467.721 407.627C468.204 407.475 468.661 407.335 469.118 407.221C469.562 407.107 469.981 406.992 470.349 406.891L471.225 409.291ZM465.956 411.793C466.109 411.882 466.299 411.92 466.528 411.895C466.756 411.882 467.048 411.819 467.391 411.717L466.21 411.031C465.74 411.374 465.664 411.628 465.956 411.793ZM473.46 413.051C473.32 412.962 473.105 412.936 472.838 412.962C472.571 412.987 472.267 413.051 471.924 413.152L473.079 413.813C473.371 413.622 473.536 413.457 473.587 413.343C473.638 413.229 473.587 413.127 473.46 413.051Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 408.707C470.794 408.783 470.349 408.898 469.88 409.012C469.473 409.114 469.054 409.241 468.585 409.393C468.127 409.546 467.683 409.711 467.277 409.888L468.673 410.701C468.813 410.651 468.965 410.587 469.131 410.536C469.296 410.485 469.473 410.422 469.638 410.358C470.438 410.079 471.187 409.838 471.886 409.66C472.584 409.469 473.244 409.342 473.866 409.279C474.488 409.215 475.073 409.228 475.631 409.33C476.19 409.431 476.736 409.622 477.244 409.927C477.853 410.282 478.247 410.663 478.412 411.057C478.577 411.463 478.577 411.87 478.412 412.276C478.247 412.683 477.955 413.102 477.536 413.508C477.117 413.915 476.622 414.296 476.05 414.664L477.942 415.756L476.368 416.658L474.45 415.553C473.485 416.036 472.457 416.468 471.34 416.861C470.235 417.255 469.156 417.547 468.127 417.763L467.112 415.274C467.645 415.172 468.191 415.045 468.75 414.905C469.219 414.791 469.753 414.639 470.337 414.448C470.921 414.258 471.467 414.054 471.987 413.813L470.616 413.026C470.134 413.216 469.626 413.394 469.105 413.559C468.331 413.813 467.62 414.016 466.985 414.169C466.35 414.308 465.766 414.397 465.233 414.423C464.699 414.448 464.217 414.41 463.76 414.308C463.315 414.207 462.884 414.042 462.477 413.8C461.919 413.47 461.538 413.127 461.347 412.734C461.157 412.352 461.094 411.946 461.195 411.54C461.284 411.12 461.513 410.714 461.868 410.282C462.224 409.863 462.681 409.457 463.239 409.076L461.665 408.161L463.227 407.259L464.814 408.174C465.283 407.945 465.766 407.742 466.261 407.551C466.744 407.361 467.239 407.196 467.721 407.043C468.204 406.891 468.661 406.751 469.118 406.637C469.562 406.523 469.981 406.408 470.349 406.307L471.225 408.707ZM465.956 411.222C466.109 411.311 466.299 411.349 466.528 411.324C466.756 411.311 467.048 411.247 467.391 411.146L466.21 410.46C465.74 410.79 465.664 411.044 465.956 411.222ZM473.46 412.467C473.32 412.378 473.105 412.352 472.838 412.378C472.571 412.403 472.267 412.467 471.924 412.568L473.079 413.229C473.371 413.038 473.536 412.873 473.587 412.759C473.638 412.645 473.587 412.543 473.46 412.467Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 404.96H446.543V411.552H446.556C446.556 411.616 446.543 411.679 446.543 411.743C446.543 419.249 456.992 425.346 469.892 425.346C482.792 425.346 493.241 419.262 493.241 411.743C493.241 411.679 493.229 411.616 493.229 411.552H493.241V404.96H493.229Z",
    fill: "url(#paint108_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 423.885C456.98 423.885 446.53 417.801 446.53 410.282V411.552H446.543C446.543 411.615 446.53 411.679 446.53 411.742C446.53 419.249 456.98 425.345 469.88 425.345C482.767 425.345 493.229 419.261 493.229 411.742C493.229 411.679 493.216 411.615 493.216 411.552H493.229V410.282C493.229 417.788 482.779 423.885 469.88 423.885Z",
    fill: "url(#paint109_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 410.866V410.676H493.216C493.216 410.739 493.229 410.803 493.229 410.866Z",
    fill: "url(#paint110_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.028 424.685C477.244 424.647 477.459 424.596 477.688 424.545V407.272H477.028V424.685Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.961 423.986C480.177 423.923 480.405 423.872 480.621 423.809V407.272H479.961V423.986Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.893 423.034C483.122 422.945 483.325 422.843 483.554 422.754V407.272H482.893V423.034Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.095 425.104C474.311 425.079 474.539 425.066 474.755 425.041V407.272H474.095V425.104Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.759 419.719C488.988 419.541 489.204 419.363 489.42 419.173V407.272H488.759V419.719Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.692 416.544C491.934 416.163 492.162 415.781 492.353 415.388V407.272H491.692V416.544Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.827 421.649C486.042 421.535 486.271 421.421 486.487 421.294V407.272H485.827V421.649Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.162 425.295C471.378 425.282 471.606 425.282 471.822 425.269V407.272H471.162V425.295Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.229 425.295C468.445 425.307 468.661 425.307 468.889 425.307V407.272H468.229V425.295Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.376 424.609C462.592 424.647 462.807 424.698 463.036 424.749V407.272H462.376V424.609Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.296 425.066C465.512 425.092 465.728 425.104 465.956 425.13V407.272H465.296V425.066Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.443 423.885C459.659 423.948 459.875 424.012 460.103 424.063V407.272H459.443V423.885Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.711 415.972C447.914 416.328 448.117 416.671 448.371 417.014V407.272H447.711V415.972Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.644 419.427C450.847 419.605 451.076 419.77 451.304 419.935V407.272H450.644V419.427Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.51 422.869C456.726 422.958 456.942 423.047 457.17 423.123V407.272H456.51V422.869Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.577 421.459C453.793 421.573 454.009 421.688 454.237 421.802V407.272H453.577V421.459Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 418.652C482.775 418.652 493.229 412.561 493.229 405.049C493.229 397.536 482.775 391.446 469.88 391.446C456.984 391.446 446.53 397.536 446.53 405.049C446.53 412.561 456.984 418.652 469.88 418.652Z",
    fill: "url(#paint111_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 418.296C457.259 418.296 447 412.454 446.581 405.163C446.569 405.316 446.543 405.481 446.543 405.633C446.543 413.14 456.992 419.236 469.892 419.236C482.792 419.236 493.241 413.152 493.241 405.633C493.241 405.468 493.216 405.316 493.203 405.163C492.759 412.454 482.5 418.296 469.88 418.296Z",
    fill: "url(#paint112_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.879 415.21C479.514 415.21 487.325 410.661 487.325 405.049C487.325 399.437 479.514 394.888 469.879 394.888C460.245 394.888 452.434 399.437 452.434 405.049C452.434 410.661 460.245 415.21 469.879 415.21Z",
    fill: "url(#paint113_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.464 395.396C479.783 395.396 487.376 399.663 487.871 405.011C487.883 404.833 487.922 404.655 487.922 404.464C487.922 398.851 480.113 394.303 470.464 394.303C460.827 394.303 453.018 398.851 453.018 404.464C453.018 404.655 453.044 404.833 453.069 405.011C453.552 399.663 461.144 395.396 470.464 395.396Z",
    fill: "url(#paint114_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 395.98C479.199 395.98 486.792 400.248 487.287 405.595C487.299 405.417 487.337 405.239 487.337 405.049C487.337 399.435 479.529 394.888 469.892 394.888C460.255 394.888 452.447 399.435 452.447 405.049C452.447 405.239 452.472 405.417 452.498 405.595C452.968 400.235 460.56 395.98 469.88 395.98Z",
    fill: "url(#paint115_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.144 391.954C487.388 393.745 490.931 397.301 490.042 399.892C489.153 402.483 484.189 403.144 478.945 401.365C473.701 399.575 470.159 396.018 471.048 393.427C471.924 390.823 476.901 390.163 482.144 391.954Z",
    fill: "url(#paint116_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 401.861C470.794 401.937 470.349 402.051 469.88 402.166C469.473 402.267 469.054 402.394 468.585 402.547C468.127 402.699 467.683 402.864 467.277 403.042L468.673 403.855C468.813 403.804 468.965 403.741 469.131 403.69C469.296 403.639 469.473 403.576 469.638 403.512C470.438 403.233 471.187 402.991 471.886 402.813C472.584 402.623 473.244 402.496 473.866 402.432C474.488 402.369 475.073 402.382 475.631 402.483C476.19 402.585 476.736 402.775 477.244 403.08C477.853 403.436 478.247 403.817 478.412 404.211C478.577 404.617 478.577 405.023 478.412 405.43C478.247 405.836 477.955 406.255 477.536 406.662C477.117 407.068 476.622 407.449 476.05 407.818L477.942 408.91L476.368 409.812L474.45 408.707C473.485 409.189 472.457 409.621 471.34 410.015C470.235 410.396 469.156 410.701 468.127 410.917L467.112 408.427C467.645 408.326 468.191 408.199 468.75 408.059C469.219 407.945 469.753 407.792 470.337 407.602C470.921 407.411 471.467 407.208 471.987 406.967L470.616 406.179C470.134 406.37 469.626 406.548 469.105 406.713C468.331 406.967 467.62 407.17 466.985 407.322C466.35 407.462 465.766 407.551 465.233 407.576C464.699 407.602 464.217 407.564 463.76 407.462C463.315 407.36 462.884 407.195 462.477 406.954C461.919 406.624 461.538 406.281 461.347 405.887C461.157 405.506 461.094 405.1 461.195 404.693C461.284 404.274 461.513 403.868 461.868 403.436C462.224 403.017 462.681 402.61 463.239 402.229L461.665 401.315L463.227 400.413L464.814 401.327C465.283 401.099 465.766 400.896 466.261 400.705C466.744 400.515 467.239 400.349 467.721 400.197C468.204 400.045 468.661 399.905 469.118 399.791C469.562 399.676 469.981 399.562 470.349 399.46L471.225 401.861ZM465.956 404.363C466.109 404.452 466.299 404.49 466.528 404.465C466.756 404.452 467.048 404.388 467.391 404.287L466.21 403.601C465.74 403.944 465.664 404.185 465.956 404.363ZM473.46 405.62C473.32 405.532 473.105 405.506 472.838 405.532C472.571 405.557 472.267 405.62 471.924 405.722L473.079 406.382C473.371 406.192 473.536 406.027 473.587 405.913C473.638 405.798 473.587 405.697 473.46 405.62Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 401.276C470.794 401.353 470.349 401.467 469.88 401.581C469.473 401.683 469.054 401.81 468.585 401.962C468.127 402.115 467.683 402.28 467.277 402.458L468.673 403.27C468.813 403.22 468.965 403.156 469.131 403.105C469.296 403.055 469.473 402.991 469.638 402.928C470.438 402.648 471.187 402.407 471.886 402.229C472.584 402.038 473.244 401.911 473.866 401.848C474.488 401.784 475.073 401.797 475.631 401.899C476.19 402 476.736 402.191 477.244 402.496C477.853 402.851 478.247 403.232 478.412 403.626C478.577 404.033 478.577 404.439 478.412 404.845C478.247 405.252 477.955 405.671 477.536 406.077C477.117 406.484 476.622 406.865 476.05 407.233L477.942 408.326L476.368 409.227L474.45 408.122C473.485 408.605 472.457 409.037 471.34 409.431C470.235 409.812 469.156 410.116 468.127 410.332L467.112 407.843C467.645 407.741 468.191 407.614 468.75 407.475C469.219 407.36 469.753 407.208 470.337 407.017C470.921 406.827 471.467 406.624 471.987 406.382L470.616 405.595C470.134 405.785 469.626 405.963 469.105 406.128C468.331 406.382 467.62 406.586 466.985 406.738C466.35 406.878 465.766 406.967 465.233 406.992C464.699 407.017 464.217 406.979 463.76 406.878C463.315 406.776 462.884 406.611 462.477 406.37C461.919 406.039 461.538 405.696 461.347 405.303C461.157 404.922 461.094 404.515 461.195 404.109C461.284 403.69 461.513 403.283 461.868 402.851C462.224 402.432 462.681 402.026 463.239 401.645L461.665 400.73L463.227 399.828L464.814 400.743C465.283 400.514 465.766 400.311 466.261 400.121C466.744 399.93 467.239 399.765 467.721 399.613C468.204 399.46 468.661 399.32 469.118 399.206C469.562 399.092 469.981 398.977 470.349 398.876L471.225 401.276ZM465.956 403.779C466.109 403.867 466.299 403.906 466.528 403.88C466.756 403.867 467.048 403.804 467.391 403.702L466.21 403.016C465.74 403.359 465.664 403.613 465.956 403.779ZM473.46 405.036C473.32 404.947 473.105 404.922 472.838 404.947C472.571 404.972 472.267 405.036 471.924 405.138L473.079 405.798C473.371 405.608 473.536 405.442 473.587 405.328C473.638 405.214 473.587 405.112 473.46 405.036Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 397.429H446.543V404.021H446.556C446.556 404.084 446.543 404.148 446.543 404.211C446.543 411.718 456.992 417.814 469.892 417.814C482.792 417.814 493.241 411.73 493.241 404.211C493.241 404.148 493.229 404.084 493.229 404.021H493.241V397.429H493.229Z",
    fill: "url(#paint117_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 416.341C456.98 416.341 446.53 410.257 446.53 402.738V404.008H446.543C446.543 404.072 446.53 404.135 446.53 404.199C446.53 411.705 456.98 417.802 469.88 417.802C482.767 417.802 493.229 411.718 493.229 404.199C493.229 404.135 493.216 404.072 493.216 404.008H493.229V402.738C493.229 410.257 482.779 416.341 469.88 416.341Z",
    fill: "url(#paint118_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.229 403.335V403.144H493.216C493.216 403.208 493.229 403.271 493.229 403.335Z",
    fill: "url(#paint119_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.028 417.14C477.244 417.102 477.459 417.051 477.688 417.001V399.727H477.028V417.14Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.961 416.455C480.177 416.392 480.405 416.341 480.621 416.277V399.74H479.961V416.455Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.893 415.49C483.122 415.401 483.325 415.299 483.554 415.21V399.74H482.893V415.49Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.095 417.572C474.311 417.547 474.539 417.534 474.755 417.509V399.753H474.095V417.572Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.759 412.174C488.988 411.996 489.204 411.819 489.42 411.628V399.727H488.759V412.174Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.692 409.012C491.934 408.631 492.162 408.25 492.353 407.856V399.74H491.692V409.012Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.827 414.118C486.042 414.004 486.271 413.889 486.487 413.762V399.74H485.827V414.118Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.162 417.763C471.378 417.75 471.606 417.75 471.822 417.737V399.727H471.162V417.763Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.229 417.75C468.445 417.763 468.661 417.763 468.889 417.763V399.727H468.229V417.75Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.376 417.065C462.592 417.103 462.807 417.154 463.036 417.204V399.74H462.376V417.065Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.296 417.535C465.512 417.56 465.728 417.573 465.956 417.598V399.74H465.296V417.535Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.443 416.353C459.659 416.416 459.875 416.48 460.103 416.531V399.727H459.443V416.353Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.711 408.441C447.914 408.796 448.117 409.139 448.371 409.482V399.74H447.711V408.441Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.644 411.895C450.847 412.073 451.076 412.238 451.304 412.403V399.74H450.644V411.895Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.51 415.337C456.726 415.426 456.942 415.515 457.17 415.591V399.727H456.51V415.337Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.577 413.928C453.793 414.042 454.009 414.156 454.237 414.271V399.74H453.577V413.928Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 411.12C482.775 411.12 493.229 405.03 493.229 397.517C493.229 390.004 482.775 383.914 469.88 383.914C456.984 383.914 446.53 390.004 446.53 397.517C446.53 405.03 456.984 411.12 469.88 411.12Z",
    fill: "url(#paint120_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 410.752C457.259 410.752 447 404.91 446.581 397.619C446.569 397.771 446.543 397.937 446.543 398.089C446.543 405.595 456.992 411.692 469.892 411.692C482.792 411.692 493.241 405.608 493.241 398.089C493.241 397.924 493.216 397.771 493.203 397.619C492.759 404.922 482.5 410.752 469.88 410.752Z",
    fill: "url(#paint121_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.879 407.678C479.514 407.678 487.325 403.129 487.325 397.517C487.325 391.906 479.514 387.357 469.879 387.357C460.245 387.357 452.434 391.906 452.434 397.517C452.434 403.129 460.245 407.678 469.879 407.678Z",
    fill: "url(#paint122_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.464 387.864C479.783 387.864 487.376 392.119 487.871 397.479C487.883 397.301 487.922 397.124 487.922 396.933C487.922 391.319 480.113 386.772 470.464 386.772C460.827 386.772 453.018 391.319 453.018 396.933C453.018 397.124 453.044 397.301 453.069 397.479C453.552 392.119 461.144 387.864 470.464 387.864Z",
    fill: "url(#paint123_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88 388.449C479.199 388.449 486.792 392.716 487.287 398.064C487.299 397.886 487.337 397.708 487.337 397.517C487.337 391.904 479.529 387.357 469.892 387.357C460.255 387.357 452.447 391.904 452.447 397.517C452.447 397.708 452.472 397.886 452.498 398.064C452.968 392.704 460.56 388.449 469.88 388.449Z",
    fill: "url(#paint124_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.144 384.422C487.388 386.213 490.931 389.77 490.042 392.361C489.153 394.964 484.189 395.612 478.945 393.834C473.701 392.043 470.159 388.487 471.048 385.896C471.924 383.292 476.901 382.632 482.144 384.422Z",
    fill: "url(#paint125_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 394.329C470.794 394.406 470.349 394.52 469.88 394.634C469.473 394.736 469.054 394.863 468.585 395.015C468.127 395.168 467.683 395.333 467.277 395.511L468.673 396.324C468.813 396.273 468.965 396.209 469.131 396.158C469.296 396.108 469.473 396.044 469.638 395.981C470.438 395.701 471.187 395.46 471.886 395.282C472.584 395.091 473.244 394.964 473.866 394.901C474.488 394.837 475.073 394.85 475.631 394.952C476.19 395.053 476.736 395.244 477.244 395.549C477.853 395.904 478.247 396.285 478.412 396.679C478.577 397.086 478.577 397.492 478.412 397.898C478.247 398.305 477.955 398.724 477.536 399.13C477.117 399.537 476.622 399.918 476.05 400.286L477.942 401.379L476.368 402.28L474.45 401.175C473.485 401.658 472.457 402.09 471.34 402.484C470.235 402.865 469.156 403.169 468.127 403.385L467.112 400.896C467.645 400.794 468.191 400.667 468.75 400.528C469.219 400.413 469.753 400.261 470.337 400.07C470.921 399.88 471.467 399.677 471.987 399.435L470.616 398.648C470.134 398.838 469.626 399.016 469.105 399.181C468.331 399.435 467.62 399.639 466.985 399.791C466.35 399.931 465.766 400.02 465.233 400.045C464.699 400.07 464.217 400.032 463.76 399.931C463.315 399.829 462.884 399.664 462.477 399.423C461.919 399.092 461.538 398.749 461.347 398.356C461.157 397.975 461.094 397.568 461.195 397.162C461.284 396.743 461.513 396.336 461.868 395.904C462.224 395.485 462.681 395.079 463.239 394.698L461.665 393.783L463.227 392.881L464.814 393.796C465.283 393.567 465.766 393.364 466.261 393.174C466.744 392.983 467.239 392.818 467.721 392.666C468.204 392.513 468.661 392.373 469.118 392.259C469.562 392.145 469.981 392.03 470.349 391.929L471.225 394.329ZM465.956 396.832C466.109 396.92 466.299 396.959 466.528 396.933C466.756 396.92 467.048 396.857 467.391 396.755L466.21 396.069C465.74 396.4 465.664 396.654 465.956 396.832ZM473.46 398.076C473.32 397.987 473.105 397.962 472.838 397.987C472.571 398.013 472.267 398.076 471.924 398.178L473.079 398.838C473.371 398.648 473.536 398.483 473.587 398.368C473.638 398.254 473.587 398.152 473.46 398.076Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.225 393.745C470.794 393.821 470.349 393.936 469.88 394.05C469.473 394.152 469.054 394.278 468.585 394.431C468.127 394.583 467.683 394.748 467.277 394.926L468.673 395.739C468.813 395.688 468.965 395.625 469.131 395.574C469.296 395.523 469.473 395.46 469.638 395.396C470.438 395.117 471.187 394.875 471.886 394.698C472.584 394.507 473.244 394.38 473.866 394.317C474.488 394.253 475.073 394.266 475.631 394.367C476.19 394.469 476.736 394.66 477.244 394.964C477.853 395.32 478.247 395.701 478.412 396.107C478.577 396.514 478.577 396.92 478.412 397.327C478.247 397.733 477.955 398.152 477.536 398.559C477.117 398.965 476.622 399.346 476.05 399.715L477.942 400.807L476.368 401.709L474.45 400.604C473.485 401.086 472.457 401.518 471.34 401.912C470.235 402.293 469.156 402.598 468.127 402.814L467.112 400.324C467.645 400.223 468.191 400.096 468.75 399.956C469.219 399.842 469.753 399.689 470.337 399.499C470.921 399.308 471.467 399.105 471.987 398.864L470.616 398.076C470.134 398.267 469.626 398.445 469.105 398.61C468.331 398.864 467.62 399.067 466.985 399.219C466.35 399.359 465.766 399.448 465.233 399.473C464.699 399.499 464.217 399.461 463.76 399.359C463.315 399.257 462.884 399.092 462.477 398.851C461.919 398.521 461.538 398.178 461.347 397.784C461.157 397.403 461.094 396.997 461.195 396.59C461.284 396.171 461.513 395.765 461.868 395.333C462.224 394.914 462.681 394.507 463.239 394.126L461.665 393.212L463.227 392.31L464.814 393.224C465.283 392.996 465.766 392.792 466.261 392.602C466.744 392.411 467.239 392.246 467.721 392.094C468.204 391.941 468.661 391.802 469.118 391.687C469.562 391.573 469.981 391.459 470.349 391.357L471.225 393.745ZM465.956 396.247C466.109 396.336 466.299 396.374 466.528 396.349C466.756 396.336 467.048 396.273 467.391 396.171L466.21 395.485C465.74 395.815 465.664 396.069 465.956 396.247ZM473.46 397.492C473.32 397.403 473.105 397.378 472.838 397.403C472.571 397.428 472.267 397.492 471.924 397.594L473.079 398.254C473.371 398.063 473.536 397.898 473.587 397.784C473.638 397.682 473.587 397.581 473.46 397.492Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.593 437.158H382.907V443.75H382.92C382.92 443.813 382.907 443.877 382.907 443.94C382.907 451.447 393.356 457.543 406.256 457.543C419.156 457.543 429.605 451.459 429.605 443.94C429.605 443.877 429.593 443.813 429.593 443.75H429.605V437.158H429.593Z",
    fill: "url(#paint126_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 456.083C393.356 456.083 382.907 449.999 382.907 442.48V443.75H382.92C382.92 443.813 382.907 443.877 382.907 443.94C382.907 451.447 393.356 457.543 406.256 457.543C419.143 457.543 429.605 451.459 429.605 443.94C429.605 443.877 429.593 443.813 429.593 443.75H429.605V442.48C429.593 449.986 419.143 456.083 406.256 456.083Z",
    fill: "url(#paint127_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.593 443.064V442.874H429.58C429.593 442.937 429.593 443.001 429.593 443.064Z",
    fill: "url(#paint128_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.404 456.883C413.62 456.845 413.836 456.794 414.064 456.743V439.47H413.404V456.883Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.337 456.184C416.553 456.121 416.782 456.07 416.998 456.007V439.47H416.337V456.184Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27 455.219C419.499 455.13 419.702 455.029 419.93 454.94V439.47H419.27V455.219Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.471 457.302C410.687 457.276 410.916 457.264 411.132 457.238V439.482H410.471V457.302Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.136 451.904C425.365 451.726 425.58 451.548 425.796 451.358V439.457H425.136V451.904Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.069 448.742C428.31 448.36 428.539 447.979 428.729 447.586V439.47H428.069V448.742Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.203 453.847C422.419 453.733 422.648 453.619 422.863 453.492V439.47H422.203V453.847Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.538 457.493C407.754 457.48 407.983 457.48 408.199 457.467V439.457H407.538V457.493Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.606 457.48C404.821 457.493 405.037 457.493 405.266 457.493V439.457H404.606V457.48Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.74 456.794C398.956 456.832 399.171 456.883 399.4 456.934V439.47H398.74V456.794Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.672 457.264C401.888 457.289 402.104 457.302 402.333 457.328V439.47H401.672V457.264Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.807 456.083C396.022 456.146 396.238 456.21 396.467 456.261V439.457H395.807V456.083Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.075 448.17C384.278 448.526 384.481 448.869 384.735 449.212V439.47H384.075V448.17Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.008 451.625C387.211 451.803 387.44 451.968 387.668 452.133V439.47H387.008V451.625Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.874 455.067C393.09 455.156 393.305 455.245 393.534 455.321V439.457H392.874V455.067Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.941 453.657C390.157 453.771 390.373 453.886 390.601 454V439.47H389.941V453.657Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 450.849C419.152 450.849 429.605 444.759 429.605 437.246C429.605 429.734 419.152 423.643 406.256 423.643C393.361 423.643 382.907 429.734 382.907 437.246C382.907 444.759 393.361 450.849 406.256 450.849Z",
    fill: "url(#paint129_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 450.481C393.636 450.481 383.377 444.639 382.958 437.348C382.945 437.501 382.92 437.666 382.92 437.818C382.92 445.325 393.369 451.421 406.269 451.421C419.169 451.421 429.618 445.337 429.618 437.818C429.618 437.653 429.593 437.501 429.58 437.348C429.123 444.651 418.877 450.481 406.256 450.481Z",
    fill: "url(#paint130_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 447.408C415.891 447.408 423.701 442.858 423.701 437.247C423.701 431.635 415.891 427.086 406.256 427.086C396.621 427.086 388.811 431.635 388.811 437.247C388.811 442.858 396.621 447.408 406.256 447.408Z",
    fill: "url(#paint131_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.828 427.594C416.147 427.594 423.74 431.849 424.235 437.208C424.248 437.031 424.286 436.853 424.286 436.662C424.286 431.048 416.477 426.501 406.84 426.501C397.204 426.501 389.395 431.048 389.395 436.662C389.395 436.853 389.421 437.031 389.446 437.208C389.916 431.849 397.508 427.594 406.828 427.594Z",
    fill: "url(#paint132_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 428.178C415.576 428.178 423.168 432.433 423.663 437.793C423.676 437.615 423.714 437.437 423.714 437.247C423.714 431.633 415.906 427.086 406.256 427.086C396.619 427.086 388.811 431.633 388.811 437.247C388.811 437.437 388.836 437.615 388.862 437.793C389.331 432.433 396.924 428.178 406.256 428.178Z",
    fill: "url(#paint133_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.509 424.152C423.752 425.943 427.295 429.499 426.406 432.09C425.517 434.694 420.553 435.341 415.309 433.563C410.065 431.772 406.523 428.216 407.412 425.625C408.3 423.021 413.265 422.361 418.509 424.152Z",
    fill: "url(#paint134_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.602 434.059C407.17 434.135 406.726 434.249 406.256 434.363C405.85 434.465 405.431 434.592 404.961 434.745C404.504 434.897 404.06 435.062 403.654 435.24L405.05 436.053C405.19 436.002 405.342 435.938 405.507 435.888C405.672 435.837 405.85 435.773 406.015 435.71C406.815 435.43 407.564 435.189 408.262 435.011C408.961 434.821 409.621 434.694 410.243 434.63C410.865 434.567 411.449 434.579 412.008 434.681C412.567 434.783 413.113 434.973 413.62 435.278C414.23 435.634 414.623 436.015 414.788 436.408C414.954 436.815 414.954 437.221 414.788 437.628C414.623 438.034 414.331 438.453 413.912 438.86C413.493 439.266 412.998 439.647 412.427 440.016L414.319 441.108L412.744 442.01L410.827 440.905C409.862 441.387 408.834 441.819 407.716 442.213C406.612 442.594 405.533 442.899 404.504 443.115L403.488 440.625C404.022 440.524 404.568 440.397 405.126 440.257C405.596 440.143 406.129 439.99 406.713 439.8C407.297 439.609 407.843 439.406 408.364 439.165L406.993 438.377C406.51 438.568 406.002 438.745 405.482 438.911C404.707 439.165 403.996 439.368 403.361 439.52C402.727 439.66 402.143 439.749 401.609 439.774C401.076 439.8 400.594 439.761 400.137 439.66C399.692 439.558 399.26 439.393 398.854 439.152C398.296 438.822 397.915 438.479 397.724 438.085C397.534 437.704 397.47 437.297 397.572 436.891C397.661 436.472 397.889 436.065 398.245 435.634C398.6 435.214 399.057 434.808 399.616 434.427L398.042 433.512L399.616 432.611L401.203 433.525C401.673 433.297 402.155 433.093 402.65 432.903C403.133 432.712 403.628 432.547 404.111 432.395C404.593 432.242 405.05 432.103 405.507 431.988C405.952 431.874 406.371 431.76 406.739 431.658L407.602 434.059ZM402.333 436.561C402.485 436.65 402.676 436.688 402.904 436.662C403.133 436.65 403.425 436.586 403.768 436.485L402.587 435.799C402.117 436.129 402.028 436.383 402.333 436.561ZM409.824 437.806C409.684 437.717 409.469 437.691 409.202 437.717C408.935 437.742 408.631 437.806 408.288 437.907L409.443 438.568C409.735 438.377 409.9 438.212 409.951 438.098C410.002 437.996 409.964 437.894 409.824 437.806Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.602 433.474C407.17 433.55 406.726 433.665 406.256 433.779C405.85 433.881 405.431 434.008 404.961 434.16C404.504 434.312 404.06 434.478 403.654 434.655L405.05 435.468C405.19 435.417 405.342 435.354 405.507 435.303C405.672 435.252 405.85 435.189 406.015 435.125C406.815 434.846 407.564 434.605 408.262 434.427C408.961 434.236 409.621 434.109 410.243 434.046C410.865 433.982 411.449 433.995 412.008 434.097C412.567 434.198 413.113 434.389 413.62 434.694C414.23 435.049 414.623 435.43 414.788 435.824C414.954 436.23 414.954 436.637 414.788 437.043C414.623 437.45 414.331 437.869 413.912 438.275C413.493 438.682 412.998 439.063 412.427 439.431L414.319 440.523L412.744 441.425L410.827 440.32C409.862 440.803 408.834 441.235 407.716 441.628C406.612 442.022 405.533 442.314 404.504 442.53L403.488 440.041C404.022 439.939 404.568 439.812 405.126 439.672C405.596 439.558 406.129 439.406 406.713 439.215C407.297 439.025 407.843 438.821 408.364 438.58L406.993 437.793C406.51 437.983 406.002 438.161 405.482 438.326C404.707 438.58 403.996 438.783 403.361 438.936C402.727 439.075 402.143 439.164 401.609 439.19C401.076 439.215 400.594 439.177 400.137 439.075C399.679 438.974 399.26 438.809 398.854 438.567C398.296 438.237 397.915 437.894 397.724 437.5C397.534 437.119 397.47 436.713 397.572 436.307C397.661 435.887 397.889 435.481 398.245 435.049C398.6 434.63 399.057 434.224 399.616 433.843L398.054 432.928L399.629 432.026L401.216 432.941C401.686 432.712 402.168 432.509 402.663 432.318C403.146 432.128 403.641 431.963 404.123 431.81C404.606 431.658 405.063 431.518 405.52 431.404C405.964 431.29 406.383 431.175 406.751 431.074L407.602 433.474ZM402.333 435.976C402.485 436.065 402.676 436.103 402.904 436.078C403.133 436.065 403.425 436.002 403.768 435.9L402.587 435.214C402.117 435.557 402.028 435.811 402.333 435.976ZM409.824 437.234C409.684 437.145 409.469 437.119 409.202 437.145C408.935 437.17 408.631 437.234 408.288 437.335L409.443 437.996C409.735 437.805 409.9 437.64 409.951 437.526C410.002 437.412 409.964 437.31 409.824 437.234Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.593 429.334H382.907V435.926H382.92C382.92 435.989 382.907 436.053 382.907 436.116C382.907 443.623 393.356 449.72 406.256 449.72C419.156 449.72 429.605 443.636 429.605 436.116C429.605 436.053 429.593 435.989 429.593 435.926H429.605V429.334H429.593Z",
    fill: "url(#paint135_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 448.259C393.356 448.259 382.907 442.175 382.907 434.656V435.926H382.92C382.92 435.989 382.907 436.053 382.907 436.116C382.907 443.623 393.356 449.719 406.256 449.719C419.143 449.719 429.605 443.635 429.605 436.116C429.605 436.053 429.593 435.989 429.593 435.926H429.605V434.656C429.593 442.175 419.143 448.259 406.256 448.259Z",
    fill: "url(#paint136_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.593 435.24V435.049H429.58C429.593 435.113 429.593 435.176 429.593 435.24Z",
    fill: "url(#paint137_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.404 449.059C413.62 449.021 413.836 448.97 414.064 448.919V431.646H413.404V449.059Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.337 448.361C416.553 448.297 416.782 448.246 416.998 448.183V431.646H416.337V448.361Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27 447.408C419.499 447.319 419.702 447.217 419.93 447.128V431.658H419.27V447.408Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.471 449.478C410.687 449.452 410.916 449.44 411.132 449.414V431.658H410.471V449.478Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.136 444.093C425.365 443.915 425.58 443.737 425.796 443.547V431.646H425.136V444.093Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.069 440.918C428.31 440.537 428.539 440.156 428.729 439.762V431.646H428.069V440.918Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.203 446.024C422.419 445.909 422.648 445.795 422.863 445.668V431.646H422.203V446.024Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.538 449.681C407.754 449.669 407.983 449.669 408.199 449.656V431.646H407.538V449.681Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.606 449.668C404.821 449.681 405.037 449.681 405.266 449.694V431.658H404.606V449.668Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.74 448.982C398.956 449.021 399.171 449.071 399.4 449.122V431.658H398.74V448.982Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.672 449.452C401.888 449.478 402.104 449.491 402.333 449.516V431.658H401.672V449.452Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.807 448.259C396.022 448.322 396.238 448.386 396.467 448.437V431.633H395.807V448.259Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.075 440.346C384.278 440.702 384.481 441.045 384.735 441.388V431.646H384.075V440.346Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.008 443.801C387.211 443.979 387.44 444.144 387.668 444.309V431.646H387.008V443.801Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.874 447.243C393.09 447.332 393.305 447.421 393.534 447.497V431.633H392.874V447.243Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.941 445.833C390.157 445.947 390.373 446.062 390.601 446.176V431.646H389.941V445.833Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 443.039C419.152 443.039 429.605 436.949 429.605 429.436C429.605 421.923 419.152 415.833 406.256 415.833C393.361 415.833 382.907 421.923 382.907 429.436C382.907 436.949 393.361 443.039 406.256 443.039Z",
    fill: "url(#paint138_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 442.67C393.636 442.67 383.377 436.828 382.958 429.537C382.945 429.69 382.92 429.855 382.92 430.007C382.92 437.514 393.369 443.61 406.269 443.61C419.169 443.61 429.618 437.526 429.618 430.007C429.618 429.842 429.593 429.69 429.58 429.537C429.123 436.828 418.877 442.67 406.256 442.67Z",
    fill: "url(#paint139_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 439.597C415.891 439.597 423.701 435.047 423.701 429.436C423.701 423.824 415.891 419.275 406.256 419.275C396.621 419.275 388.811 423.824 388.811 429.436C388.811 435.047 396.621 439.597 406.256 439.597Z",
    fill: "url(#paint140_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.828 419.77C416.147 419.77 423.74 424.038 424.235 429.385C424.248 429.207 424.286 429.029 424.286 428.839C424.286 423.225 416.477 418.678 406.84 418.678C397.204 418.678 389.395 423.225 389.395 428.839C389.395 429.029 389.421 429.207 389.446 429.385C389.916 424.038 397.508 419.77 406.828 419.77Z",
    fill: "url(#paint141_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 420.354C415.576 420.354 423.168 424.622 423.663 429.969C423.676 429.791 423.714 429.613 423.714 429.423C423.714 423.809 415.906 419.262 406.256 419.262C396.619 419.262 388.811 423.809 388.811 429.423C388.811 429.613 388.836 429.791 388.862 429.969C389.331 424.622 396.924 420.354 406.256 420.354Z",
    fill: "url(#paint142_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.509 416.328C423.752 418.119 427.295 421.675 426.406 424.266C425.517 426.87 420.553 427.518 415.309 425.74C410.065 423.949 406.523 420.393 407.412 417.801C408.3 415.198 413.265 414.55 418.509 416.328Z",
    fill: "url(#paint143_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.602 426.235C407.17 426.311 406.726 426.425 406.256 426.54C405.85 426.641 405.431 426.768 404.961 426.921C404.504 427.073 404.06 427.238 403.654 427.416L405.05 428.229C405.19 428.178 405.342 428.115 405.507 428.064C405.672 428.013 405.85 427.949 406.015 427.886C406.815 427.607 407.564 427.365 408.262 427.187C408.961 426.997 409.621 426.87 410.243 426.806C410.865 426.743 411.449 426.756 412.008 426.857C412.567 426.959 413.113 427.149 413.62 427.454C414.23 427.81 414.623 428.191 414.788 428.585C414.954 428.991 414.954 429.397 414.788 429.804C414.623 430.21 414.331 430.629 413.912 431.036C413.493 431.442 412.998 431.823 412.427 432.192L414.319 433.284L412.744 434.186L410.827 433.081C409.862 433.563 408.834 433.995 407.716 434.389C406.612 434.783 405.533 435.075 404.504 435.291L403.488 432.801C404.022 432.7 404.568 432.573 405.126 432.433C405.596 432.319 406.129 432.166 406.713 431.976C407.297 431.785 407.843 431.582 408.364 431.341L406.993 430.553C406.51 430.744 406.002 430.922 405.482 431.087C404.707 431.341 403.996 431.544 403.361 431.696C402.727 431.836 402.143 431.925 401.609 431.95C401.076 431.976 400.594 431.938 400.137 431.836C399.679 431.734 399.26 431.569 398.854 431.328C398.296 430.998 397.915 430.655 397.724 430.261C397.534 429.88 397.47 429.474 397.572 429.067C397.661 428.648 397.889 428.242 398.245 427.81C398.6 427.391 399.057 426.984 399.616 426.603L398.054 425.689L399.629 424.787L401.216 425.701C401.686 425.473 402.168 425.27 402.663 425.079C403.146 424.888 403.641 424.723 404.123 424.571C404.606 424.419 405.063 424.279 405.52 424.164C405.964 424.05 406.383 423.936 406.751 423.834L407.602 426.235ZM402.333 428.737C402.485 428.826 402.676 428.864 402.904 428.839C403.133 428.826 403.425 428.762 403.768 428.661L402.587 427.975C402.117 428.318 402.028 428.572 402.333 428.737ZM409.824 429.994C409.684 429.905 409.469 429.88 409.202 429.905C408.935 429.931 408.631 429.994 408.288 430.096L409.443 430.756C409.735 430.566 409.9 430.401 409.951 430.286C410.002 430.172 409.964 430.071 409.824 429.994Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.602 425.651C407.17 425.727 406.726 425.841 406.256 425.956C405.85 426.057 405.431 426.184 404.961 426.337C404.504 426.489 404.06 426.654 403.654 426.832L405.05 427.645C405.19 427.594 405.342 427.531 405.507 427.48C405.672 427.429 405.85 427.366 406.015 427.302C406.815 427.023 407.564 426.781 408.262 426.603C408.961 426.413 409.621 426.286 410.243 426.222C410.865 426.159 411.449 426.172 412.008 426.273C412.567 426.375 413.113 426.565 413.62 426.87C414.23 427.226 414.623 427.607 414.788 428.001C414.954 428.407 414.954 428.813 414.788 429.22C414.623 429.626 414.331 430.045 413.912 430.452C413.493 430.858 412.998 431.239 412.427 431.608L414.319 432.7L412.744 433.602L410.827 432.497C409.862 432.979 408.834 433.411 407.716 433.805C406.612 434.186 405.533 434.491 404.504 434.707L403.488 432.217C404.022 432.116 404.568 431.989 405.126 431.849C405.596 431.735 406.129 431.582 406.713 431.392C407.297 431.201 407.843 430.998 408.364 430.757L406.993 429.969C406.51 430.16 406.002 430.338 405.482 430.503C404.707 430.757 403.996 430.96 403.361 431.112C402.727 431.252 402.143 431.341 401.609 431.366C401.076 431.392 400.594 431.354 400.137 431.252C399.692 431.15 399.26 430.985 398.854 430.744C398.296 430.414 397.915 430.071 397.724 429.677C397.534 429.296 397.47 428.89 397.572 428.483C397.661 428.064 397.889 427.658 398.245 427.226C398.6 426.807 399.057 426.4 399.616 426.019L398.042 425.105L399.616 424.203L401.203 425.117C401.673 424.889 402.155 424.686 402.65 424.495C403.133 424.305 403.628 424.139 404.111 423.987C404.593 423.835 405.05 423.695 405.507 423.581C405.952 423.466 406.371 423.352 406.739 423.25L407.602 425.651ZM402.333 428.153C402.485 428.242 402.676 428.28 402.904 428.255C403.133 428.242 403.425 428.178 403.768 428.077L402.587 427.391C402.117 427.734 402.028 427.988 402.333 428.153ZM409.824 429.41C409.684 429.321 409.469 429.296 409.202 429.321C408.935 429.347 408.631 429.41 408.288 429.512L409.443 430.172C409.735 429.982 409.9 429.817 409.951 429.703C410.002 429.588 409.964 429.487 409.824 429.41Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.593 421.51H382.907V428.102H382.92C382.92 428.166 382.907 428.229 382.907 428.293C382.907 435.799 393.356 441.896 406.256 441.896C419.156 441.896 429.605 435.812 429.605 428.293C429.605 428.229 429.593 428.166 429.593 428.102H429.605V421.51H429.593Z",
    fill: "url(#paint144_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 440.435C393.356 440.435 382.907 434.351 382.907 426.832V428.102H382.92C382.92 428.166 382.907 428.229 382.907 428.293C382.907 435.799 393.356 441.896 406.256 441.896C419.143 441.896 429.605 435.812 429.605 428.293C429.605 428.229 429.593 428.166 429.593 428.102H429.605V426.832C429.593 434.351 419.143 440.435 406.256 440.435Z",
    fill: "url(#paint145_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.593 427.416V427.226H429.58C429.593 427.289 429.593 427.353 429.593 427.416Z",
    fill: "url(#paint146_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.404 441.235C413.62 441.197 413.836 441.146 414.064 441.096V423.822H413.404V441.235Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.337 440.549C416.553 440.486 416.782 440.435 416.998 440.372V423.835H416.337V440.549Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27 439.584C419.499 439.495 419.702 439.394 419.93 439.305V423.835H419.27V439.584Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.471 441.654C410.687 441.629 410.916 441.616 411.132 441.591V423.835H410.471V441.654Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.136 436.269C425.365 436.091 425.58 435.913 425.796 435.723V423.822H425.136V436.269Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.069 433.107C428.31 432.726 428.539 432.344 428.729 431.951V423.835H428.069V433.107Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.203 438.2C422.419 438.085 422.648 437.971 422.863 437.844V423.822H422.203V438.2Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.538 441.858C407.754 441.845 407.983 441.845 408.199 441.832V423.822H407.538V441.858Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.606 441.845C404.821 441.858 405.037 441.858 405.266 441.858V423.822H404.606V441.845Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.74 441.159C398.956 441.197 399.171 441.248 399.4 441.299V423.835H398.74V441.159Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.672 441.629C401.888 441.655 402.104 441.667 402.333 441.693V423.835H401.672V441.629Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.807 440.448C396.022 440.511 396.238 440.575 396.467 440.626V423.822H395.807V440.448Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.075 432.522C384.278 432.878 384.481 433.221 384.735 433.564V423.822H384.075V432.522Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.008 435.99C387.211 436.168 387.44 436.333 387.668 436.498V423.835H387.008V435.99Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.874 439.432C393.09 439.521 393.305 439.61 393.534 439.686V423.822H392.874V439.432Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.941 438.009C390.157 438.123 390.373 438.238 390.601 438.352V423.822H389.941V438.009Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 435.215C419.152 435.215 429.605 429.124 429.605 421.612C429.605 414.099 419.152 408.009 406.256 408.009C393.361 408.009 382.907 414.099 382.907 421.612C382.907 429.124 393.361 435.215 406.256 435.215Z",
    fill: "url(#paint147_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 434.846C393.636 434.846 383.377 429.004 382.958 421.713C382.945 421.866 382.92 422.031 382.92 422.183C382.92 429.69 393.369 435.786 406.269 435.786C419.169 435.786 429.618 429.702 429.618 422.183C429.618 422.018 429.593 421.866 429.58 421.713C429.123 429.004 418.877 434.846 406.256 434.846Z",
    fill: "url(#paint148_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 431.773C415.891 431.773 423.701 427.224 423.701 421.612C423.701 416 415.891 411.451 406.256 411.451C396.621 411.451 388.811 416 388.811 421.612C388.811 427.224 396.621 431.773 406.256 431.773Z",
    fill: "url(#paint149_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.828 411.959C416.147 411.959 423.74 416.214 424.235 421.574C424.248 421.396 424.286 421.218 424.286 421.027C424.286 415.413 416.477 410.866 406.84 410.866C397.204 410.866 389.395 415.413 389.395 421.027C389.395 421.218 389.421 421.396 389.446 421.574C389.916 416.214 397.508 411.959 406.828 411.959Z",
    fill: "url(#paint150_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.256 412.531C415.576 412.531 423.168 416.798 423.663 422.146C423.676 421.968 423.714 421.79 423.714 421.6C423.714 415.986 415.906 411.439 406.256 411.439C396.619 411.439 388.811 415.986 388.811 421.6C388.811 421.79 388.836 421.968 388.862 422.146C389.331 416.798 396.924 412.531 406.256 412.531Z",
    fill: "url(#paint151_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.509 408.517C423.752 410.308 427.295 413.864 426.406 416.455C425.517 419.059 420.553 419.706 415.309 417.928C410.065 416.137 406.523 412.581 407.412 409.99C408.3 407.386 413.265 406.726 418.509 408.517Z",
    fill: "url(#paint152_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.602 418.411C407.17 418.488 406.726 418.602 406.256 418.716C405.85 418.818 405.431 418.945 404.961 419.097C404.504 419.25 404.06 419.415 403.654 419.593L405.05 420.406C405.19 420.355 405.342 420.291 405.507 420.24C405.672 420.19 405.85 420.126 406.015 420.063C406.815 419.783 407.564 419.542 408.262 419.364C408.961 419.174 409.621 419.047 410.243 418.983C410.865 418.919 411.449 418.932 412.008 419.034C412.567 419.135 413.113 419.326 413.62 419.631C414.23 419.986 414.623 420.367 414.788 420.761C414.954 421.168 414.954 421.574 414.788 421.98C414.623 422.387 414.331 422.806 413.912 423.213C413.493 423.619 412.998 424 412.427 424.368L414.319 425.461L412.744 426.362L410.827 425.257C409.862 425.74 408.834 426.172 407.716 426.566C406.612 426.959 405.533 427.252 404.504 427.467L403.488 424.978C404.022 424.876 404.568 424.749 405.126 424.61C405.596 424.495 406.129 424.343 406.713 424.152C407.297 423.962 407.843 423.759 408.364 423.517L406.993 422.73C406.51 422.92 406.002 423.098 405.482 423.263C404.707 423.517 403.996 423.721 403.361 423.873C402.727 424.013 402.143 424.102 401.609 424.127C401.076 424.152 400.594 424.114 400.137 424.013C399.692 423.911 399.26 423.746 398.854 423.505C398.296 423.174 397.915 422.831 397.724 422.438C397.534 422.057 397.47 421.65 397.572 421.244C397.661 420.825 397.889 420.418 398.245 419.986C398.6 419.567 399.057 419.161 399.616 418.78L398.042 417.865L399.616 416.964L401.203 417.878C401.673 417.649 402.155 417.446 402.65 417.256C403.133 417.065 403.628 416.9 404.111 416.748C404.593 416.595 405.05 416.455 405.507 416.341C405.952 416.227 406.371 416.113 406.739 416.011L407.602 418.411ZM402.333 420.926C402.485 421.015 402.676 421.053 402.904 421.028C403.133 421.015 403.425 420.952 403.768 420.85L402.587 420.164C402.117 420.494 402.028 420.748 402.333 420.926ZM409.824 422.171C409.684 422.082 409.469 422.057 409.202 422.082C408.935 422.108 408.631 422.171 408.288 422.273L409.443 422.933C409.735 422.743 409.9 422.577 409.951 422.463C410.002 422.349 409.964 422.247 409.824 422.171Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.602 417.839C407.17 417.915 406.726 418.03 406.256 418.144C405.85 418.246 405.431 418.373 404.961 418.525C404.504 418.678 404.06 418.843 403.654 419.02L405.05 419.833C405.19 419.783 405.342 419.719 405.507 419.668C405.672 419.617 405.85 419.554 406.015 419.49C406.815 419.211 407.564 418.97 408.262 418.792C408.961 418.601 409.621 418.474 410.243 418.411C410.865 418.347 411.449 418.36 412.008 418.462C412.567 418.563 413.113 418.754 413.62 419.059C414.23 419.414 414.623 419.795 414.788 420.189C414.954 420.595 414.954 421.002 414.788 421.408C414.623 421.815 414.331 422.234 413.912 422.64C413.493 423.047 412.998 423.428 412.427 423.796L414.319 424.888L412.744 425.79L410.827 424.685C409.862 425.168 408.834 425.6 407.716 425.993C406.612 426.375 405.533 426.679 404.504 426.895L403.488 424.406C404.022 424.304 404.568 424.177 405.126 424.037C405.596 423.923 406.129 423.771 406.713 423.58C407.297 423.39 407.843 423.187 408.364 422.945L406.993 422.158C406.51 422.348 406.002 422.526 405.482 422.691C404.707 422.945 403.996 423.148 403.361 423.301C402.727 423.441 402.143 423.529 401.609 423.555C401.076 423.58 400.594 423.542 400.137 423.441C399.692 423.339 399.26 423.174 398.854 422.932C398.296 422.602 397.915 422.259 397.724 421.866C397.534 421.485 397.47 421.078 397.572 420.672C397.661 420.253 397.889 419.846 398.245 419.414C398.6 418.995 399.057 418.589 399.616 418.208L398.042 417.293L399.616 416.391L401.203 417.306C401.673 417.077 402.155 416.874 402.65 416.683C403.133 416.493 403.628 416.328 404.111 416.175C404.593 416.023 405.05 415.883 405.507 415.769C405.952 415.655 406.371 415.54 406.739 415.439L407.602 417.839ZM402.333 420.341C402.485 420.43 402.676 420.468 402.904 420.443C403.133 420.43 403.425 420.367 403.768 420.265L402.587 419.579C402.117 419.91 402.028 420.164 402.333 420.341ZM409.824 421.586C409.684 421.497 409.469 421.472 409.202 421.497C408.935 421.523 408.631 421.586 408.288 421.688L409.443 422.348C409.735 422.158 409.9 421.993 409.951 421.878C410.002 421.764 409.964 421.662 409.824 421.586Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.471 462.053H413.785V468.645H413.798C413.798 468.708 413.785 468.772 413.785 468.835C413.785 476.342 424.235 482.438 437.135 482.438C450.034 482.438 460.484 476.354 460.484 468.835C460.484 468.772 460.471 468.708 460.471 468.645H460.484V462.053H460.471Z",
    fill: "url(#paint153_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.773 467.768V467.958C413.773 467.895 413.785 467.831 413.773 467.768Z",
    fill: "url(#paint154_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.122 480.977C424.235 480.977 413.773 474.894 413.773 467.374V468.645H413.785C413.785 468.708 413.773 468.772 413.773 468.835C413.773 476.341 424.222 482.438 437.122 482.438C450.009 482.438 460.471 476.354 460.471 468.835C460.471 468.772 460.458 468.708 460.458 468.645H460.471V467.374C460.471 474.881 450.009 480.977 437.122 480.977Z",
    fill: "url(#paint155_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.471 467.958V467.768H460.458C460.458 467.831 460.471 467.895 460.471 467.958Z",
    fill: "url(#paint156_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.27 481.778C444.486 481.74 444.702 481.689 444.93 481.638V464.364H444.27V481.778Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.203 481.079C447.419 481.016 447.647 480.965 447.863 480.901V464.364H447.203V481.079Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.136 480.114C450.364 480.025 450.568 479.923 450.796 479.834V464.364H450.136V480.114Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.337 482.197C441.553 482.172 441.782 482.159 441.997 482.133V464.377H441.337V482.197Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.002 476.799C456.23 476.621 456.446 476.443 456.662 476.253V464.351H456.002V476.799Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.935 473.636C459.176 473.255 459.405 472.874 459.595 472.48V464.364H458.935V473.636Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.069 478.742C453.285 478.628 453.513 478.513 453.729 478.386V464.364H453.069V478.742Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.404 482.387C438.62 482.375 438.848 482.375 439.064 482.362V464.351H438.404V482.387Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.471 482.387C435.687 482.4 435.903 482.4 436.131 482.4V464.364H435.471V482.387Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.605 481.702C429.821 481.74 430.037 481.79 430.266 481.841V464.377H429.605V481.702Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.538 482.159C432.754 482.184 432.97 482.197 433.198 482.222V464.364H432.538V482.159Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.672 480.977C426.888 481.041 427.104 481.104 427.332 481.155V464.351H426.672V480.977Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.941 473.065C415.144 473.42 415.347 473.763 415.601 474.106V464.364H414.941V473.065Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.874 476.519C418.077 476.697 418.305 476.862 418.534 477.027V464.364H417.874V476.519Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.74 479.961C423.955 480.05 424.171 480.139 424.4 480.215V464.351H423.74V479.961Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.806 478.552C421.022 478.666 421.238 478.78 421.467 478.894V464.364H420.806V478.552Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.122 475.744C450.017 475.744 460.471 469.654 460.471 462.141C460.471 454.629 450.017 448.538 437.122 448.538C424.226 448.538 413.773 454.629 413.773 462.141C413.773 469.654 424.226 475.744 437.122 475.744Z",
    fill: "url(#paint157_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.122 475.389C424.501 475.389 414.242 469.546 413.823 462.255C413.811 462.408 413.785 462.573 413.785 462.725C413.785 470.232 424.235 476.328 437.135 476.328C450.022 476.328 460.484 470.245 460.484 462.725C460.484 462.56 460.458 462.408 460.446 462.255C459.989 469.546 449.742 475.389 437.122 475.389Z",
    fill: "url(#paint158_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.122 472.302C446.757 472.302 454.567 467.753 454.567 462.141C454.567 456.529 446.757 451.98 437.122 451.98C427.487 451.98 419.677 456.529 419.677 462.141C419.677 467.753 427.487 472.302 437.122 472.302Z",
    fill: "url(#paint159_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.706 452.488C447.025 452.488 454.618 456.743 455.113 462.103C455.126 461.925 455.164 461.747 455.164 461.557C455.164 455.943 447.355 451.396 437.719 451.396C428.082 451.396 420.274 455.943 420.274 461.557C420.274 461.747 420.299 461.925 420.324 462.103C420.794 456.756 428.387 452.488 437.706 452.488Z",
    fill: "url(#paint160_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.122 453.072C446.441 453.072 454.034 457.34 454.529 462.687C454.542 462.509 454.58 462.332 454.58 462.141C454.58 456.527 446.771 451.98 437.135 451.98C427.498 451.98 419.689 456.527 419.689 462.141C419.689 462.332 419.715 462.509 419.74 462.687C420.21 457.327 427.802 453.072 437.122 453.072Z",
    fill: "url(#paint161_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.387 449.047C454.631 450.837 458.173 454.394 457.284 456.985C456.395 459.589 451.431 460.236 446.187 458.458C440.944 456.667 437.401 453.111 438.29 450.52C439.166 447.916 444.13 447.256 449.387 449.047Z",
    fill: "url(#paint162_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.468 458.953C438.036 459.029 437.592 459.144 437.122 459.258C436.716 459.359 436.297 459.487 435.827 459.639C435.37 459.791 434.925 459.956 434.519 460.134L435.916 460.947C436.055 460.896 436.208 460.833 436.373 460.782C436.538 460.731 436.716 460.668 436.881 460.604C437.681 460.325 438.43 460.083 439.128 459.906C439.826 459.715 440.487 459.588 441.109 459.525C441.731 459.461 442.315 459.474 442.874 459.575C443.432 459.677 443.978 459.868 444.486 460.172C445.095 460.528 445.489 460.909 445.654 461.303C445.819 461.709 445.819 462.116 445.654 462.522C445.489 462.929 445.197 463.348 444.778 463.754C444.359 464.161 443.864 464.542 443.293 464.91L445.184 466.002L443.623 466.904L441.705 465.799C440.741 466.282 439.712 466.714 438.595 467.107C437.49 467.488 436.411 467.793 435.383 468.009L434.367 465.52C434.9 465.418 435.446 465.291 436.005 465.151C436.474 465.037 437.008 464.885 437.592 464.694C438.176 464.503 438.722 464.3 439.242 464.059L437.871 463.271C437.389 463.462 436.881 463.64 436.36 463.805C435.586 464.059 434.875 464.262 434.24 464.415C433.605 464.554 433.021 464.643 432.488 464.669C431.954 464.694 431.472 464.656 431.015 464.554C430.57 464.453 430.139 464.288 429.733 464.046C429.174 463.716 428.793 463.373 428.603 462.979C428.412 462.598 428.349 462.192 428.45 461.785C428.539 461.366 428.768 460.96 429.123 460.528C429.479 460.109 429.936 459.702 430.494 459.321L428.92 458.407L430.482 457.505L432.069 458.42C432.538 458.191 433.021 457.988 433.503 457.797C433.986 457.607 434.481 457.442 434.964 457.289C435.446 457.137 435.903 456.997 436.36 456.883C436.805 456.768 437.224 456.654 437.592 456.553L438.468 458.953ZM433.199 461.455C433.351 461.544 433.542 461.582 433.77 461.557C433.999 461.544 434.291 461.481 434.633 461.379L433.453 460.693C432.983 461.036 432.894 461.277 433.199 461.455ZM440.69 462.713C440.55 462.624 440.334 462.598 440.068 462.624C439.801 462.649 439.496 462.713 439.153 462.814L440.309 463.475C440.601 463.284 440.766 463.119 440.817 463.005C440.867 462.89 440.829 462.789 440.69 462.713Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.468 458.369C438.036 458.445 437.592 458.56 437.122 458.674C436.716 458.776 436.297 458.903 435.827 459.055C435.37 459.207 434.925 459.373 434.519 459.55L435.916 460.363C436.055 460.312 436.208 460.249 436.373 460.198C436.538 460.147 436.716 460.084 436.881 460.02C437.681 459.741 438.43 459.5 439.128 459.322C439.826 459.131 440.487 459.004 441.109 458.941C441.731 458.877 442.315 458.89 442.874 458.991C443.432 459.093 443.978 459.284 444.486 459.588C445.095 459.944 445.489 460.325 445.654 460.719C445.819 461.125 445.819 461.532 445.654 461.938C445.489 462.345 445.197 462.764 444.778 463.17C444.359 463.577 443.864 463.958 443.293 464.326L445.184 465.418L443.623 466.32L441.705 465.215C440.741 465.698 439.712 466.13 438.595 466.523C437.49 466.904 436.411 467.209 435.383 467.425L434.367 464.936C434.9 464.834 435.446 464.707 436.005 464.567C436.474 464.453 437.008 464.301 437.592 464.11C438.176 463.92 438.722 463.716 439.242 463.475L437.871 462.688C437.389 462.878 436.881 463.056 436.36 463.221C435.586 463.475 434.875 463.678 434.24 463.831C433.605 463.97 433.021 464.059 432.488 464.085C431.954 464.11 431.472 464.072 431.015 463.97C430.57 463.869 430.139 463.704 429.733 463.462C429.174 463.132 428.793 462.789 428.603 462.395C428.412 462.014 428.349 461.608 428.45 461.201C428.539 460.782 428.768 460.376 429.123 459.944C429.479 459.525 429.936 459.119 430.494 458.737L428.92 457.823L430.482 456.921L432.069 457.836C432.538 457.607 433.021 457.404 433.503 457.213C433.986 457.023 434.481 456.858 434.964 456.705C435.446 456.553 435.903 456.413 436.36 456.299C436.805 456.185 437.224 456.07 437.592 455.969L438.468 458.369ZM433.199 460.871C433.351 460.96 433.542 460.998 433.77 460.973C433.999 460.96 434.291 460.897 434.633 460.795L433.453 460.109C432.983 460.452 432.894 460.706 433.199 460.871ZM440.69 462.129C440.55 462.04 440.334 462.014 440.068 462.04C439.801 462.065 439.496 462.129 439.153 462.23L440.309 462.891C440.601 462.7 440.766 462.535 440.817 462.421C440.867 462.307 440.829 462.205 440.69 462.129Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.3 409.012C467.543 410.803 471.086 414.359 470.197 416.95C469.308 419.554 464.344 420.202 459.1 418.423C453.856 416.633 450.314 413.076 451.203 410.485C452.091 407.894 457.056 407.234 462.3 409.012Z",
    fill: "url(#paint163_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.298 260.141C352.943 260.141 352.664 259.861 352.664 259.506V257.601C352.664 257.245 352.943 256.966 353.298 256.966C353.654 256.966 353.933 257.245 353.933 257.601V259.506C353.933 259.861 353.654 260.141 353.298 260.141Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.298 254.424C352.943 254.424 352.664 254.145 352.664 253.789V249.979C352.664 249.623 352.943 249.344 353.298 249.344C353.654 249.344 353.933 249.623 353.933 249.979V253.789C353.933 254.145 353.654 254.424 353.298 254.424ZM353.298 246.804C352.943 246.804 352.664 246.524 352.664 246.169V242.358C352.664 242.003 352.943 241.723 353.298 241.723C353.654 241.723 353.933 242.003 353.933 242.358V246.169C353.933 246.524 353.654 246.804 353.298 246.804ZM353.298 239.183C352.943 239.183 352.664 238.904 352.664 238.548V234.738C352.664 234.382 352.943 234.102 353.298 234.102C353.654 234.102 353.933 234.382 353.933 234.738V238.548C353.933 238.904 353.654 239.183 353.298 239.183ZM353.298 231.562C352.943 231.562 352.664 231.283 352.664 230.927V227.117C352.664 226.761 352.943 226.482 353.298 226.482C353.654 226.482 353.933 226.761 353.933 227.117V230.927C353.933 231.283 353.654 231.562 353.298 231.562ZM353.298 223.942C352.943 223.942 352.664 223.662 352.664 223.306V219.496C352.664 219.14 352.943 218.861 353.298 218.861C353.654 218.861 353.933 219.14 353.933 219.496V223.306C353.933 223.662 353.654 223.942 353.298 223.942ZM353.298 216.321C352.943 216.321 352.664 216.041 352.664 215.686V211.875C352.664 211.52 352.943 211.24 353.298 211.24C353.654 211.24 353.933 211.52 353.933 211.875V215.686C353.933 216.041 353.654 216.321 353.298 216.321Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.299 208.701C352.943 208.701 352.664 208.421 352.664 208.066V206.529L351.331 205.767C351.026 205.589 350.924 205.208 351.089 204.903C351.267 204.598 351.648 204.496 351.953 204.662L353.921 205.792V208.066C353.934 208.421 353.654 208.701 353.299 208.701Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.321 203.95C348.22 203.95 348.106 203.924 348.004 203.861L344.678 201.956C344.373 201.778 344.271 201.397 344.436 201.092C344.614 200.787 344.995 200.686 345.3 200.851L348.626 202.756C348.931 202.934 349.032 203.315 348.867 203.62C348.753 203.836 348.537 203.95 348.321 203.95ZM341.656 200.152C341.541 200.152 341.44 200.127 341.338 200.063L338.012 198.158C337.707 197.98 337.605 197.599 337.771 197.294C337.948 196.99 338.329 196.888 338.634 197.053L341.96 198.958C342.265 199.136 342.367 199.517 342.202 199.822C342.1 200.038 341.884 200.152 341.656 200.152ZM335.003 196.355C334.901 196.355 334.787 196.329 334.685 196.266L331.359 194.36C331.054 194.183 330.952 193.802 331.117 193.497C331.295 193.192 331.689 193.09 331.981 193.255L335.307 195.161C335.612 195.338 335.714 195.719 335.549 196.024C335.434 196.24 335.231 196.355 335.003 196.355ZM328.35 192.557C328.248 192.557 328.134 192.531 328.032 192.468L324.706 190.563C324.401 190.385 324.299 190.004 324.464 189.699C324.642 189.394 325.036 189.293 325.328 189.458L328.654 191.363C328.959 191.541 329.061 191.922 328.896 192.227C328.781 192.443 328.565 192.557 328.35 192.557ZM321.697 188.759C321.595 188.759 321.481 188.734 321.379 188.67L318.053 186.765C317.748 186.587 317.646 186.206 317.811 185.901C317.989 185.597 318.383 185.495 318.675 185.66L322.001 187.565C322.306 187.743 322.408 188.124 322.242 188.429C322.128 188.645 321.912 188.759 321.697 188.759ZM315.043 184.962C314.929 184.962 314.828 184.936 314.726 184.873L311.4 182.967C311.095 182.79 310.993 182.409 311.158 182.104C311.336 181.799 311.717 181.697 312.022 181.862L315.348 183.768C315.653 183.945 315.755 184.326 315.589 184.631C315.475 184.847 315.259 184.962 315.043 184.962ZM308.39 181.151C308.276 181.151 308.175 181.126 308.073 181.062L304.746 179.157C304.442 178.979 304.34 178.598 304.505 178.293C304.683 177.989 305.064 177.887 305.369 178.052L308.695 179.957C309 180.135 309.101 180.516 308.936 180.821C308.822 181.037 308.606 181.151 308.39 181.151ZM301.737 177.354C301.636 177.354 301.522 177.328 301.42 177.265L298.093 175.359C297.789 175.182 297.687 174.801 297.852 174.496C298.03 174.191 298.411 174.089 298.716 174.254L302.042 176.16C302.347 176.337 302.448 176.718 302.283 177.023C302.169 177.239 301.953 177.354 301.737 177.354ZM295.072 173.556C294.97 173.556 294.856 173.53 294.754 173.467L291.428 171.562C291.123 171.384 291.021 171.003 291.186 170.698C291.364 170.393 291.758 170.292 292.05 170.457L295.376 172.362C295.681 172.54 295.783 172.921 295.618 173.226C295.516 173.442 295.3 173.556 295.072 173.556ZM288.419 169.758C288.317 169.758 288.203 169.733 288.101 169.669L284.775 167.764C284.47 167.586 284.368 167.205 284.533 166.9C284.711 166.596 285.092 166.494 285.397 166.659L288.723 168.564C289.028 168.742 289.13 169.123 288.965 169.428C288.85 169.644 288.634 169.758 288.419 169.758ZM281.766 165.961C281.664 165.961 281.55 165.935 281.448 165.872L278.122 163.966C277.817 163.789 277.715 163.408 277.88 163.103C278.058 162.798 278.439 162.696 278.744 162.861L282.07 164.767C282.375 164.944 282.477 165.325 282.311 165.63C282.197 165.846 281.981 165.961 281.766 165.961ZM275.112 162.163C275.011 162.163 274.897 162.137 274.795 162.074L271.469 160.169C271.164 159.991 271.062 159.61 271.227 159.305C271.405 159 271.799 158.899 272.091 159.064L275.417 160.969C275.722 161.147 275.823 161.528 275.658 161.833C275.544 162.049 275.328 162.163 275.112 162.163Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.459 158.365C268.358 158.365 268.244 158.34 268.142 158.276L266.491 157.336C266.187 157.158 266.085 156.777 266.25 156.473C266.428 156.168 266.821 156.066 267.114 156.231L268.764 157.171C269.069 157.349 269.17 157.73 269.005 158.035C268.891 158.251 268.675 158.365 268.459 158.365Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.13 334.125C422.775 334.125 422.496 333.846 422.496 333.49V331.585C422.496 331.229 422.775 330.95 423.13 330.95C423.486 330.95 423.765 331.229 423.765 331.585V333.49C423.765 333.846 423.486 334.125 423.13 334.125Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.13 328.549C422.775 328.549 422.496 328.27 422.496 327.914V324.243C422.496 323.888 422.775 323.608 423.13 323.608C423.486 323.608 423.765 323.888 423.765 324.243V327.914C423.765 328.257 423.486 328.549 423.13 328.549ZM423.13 321.195C422.775 321.195 422.496 320.916 422.496 320.56V316.889C422.496 316.534 422.775 316.254 423.13 316.254C423.486 316.254 423.765 316.534 423.765 316.889V320.56C423.765 320.903 423.486 321.195 423.13 321.195ZM423.13 313.841C422.775 313.841 422.496 313.562 422.496 313.206V309.535C422.496 309.18 422.775 308.9 423.13 308.9C423.486 308.9 423.765 309.18 423.765 309.535V313.206C423.765 313.549 423.486 313.841 423.13 313.841ZM423.13 306.487C422.775 306.487 422.496 306.208 422.496 305.852V302.181C422.496 301.826 422.775 301.546 423.13 301.546C423.486 301.546 423.765 301.826 423.765 302.181V305.852C423.765 306.208 423.486 306.487 423.13 306.487ZM423.13 299.133C422.775 299.133 422.496 298.854 422.496 298.498V294.827C422.496 294.472 422.775 294.192 423.13 294.192C423.486 294.192 423.765 294.472 423.765 294.827V298.498C423.765 298.854 423.486 299.133 423.13 299.133ZM423.13 291.779C422.775 291.779 422.496 291.5 422.496 291.144V287.473C422.496 287.118 422.775 286.838 423.13 286.838C423.486 286.838 423.765 287.118 423.765 287.473V291.144C423.765 291.5 423.486 291.779 423.13 291.779Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.13 284.425C422.775 284.425 422.495 284.146 422.495 283.79V282.253L421.162 281.478C420.858 281.3 420.756 280.919 420.934 280.615C421.111 280.31 421.505 280.208 421.797 280.386L423.765 281.529V283.803C423.765 284.146 423.486 284.425 423.13 284.425Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.242 279.688C418.128 279.688 418.026 279.662 417.925 279.599L414.674 277.719C414.37 277.541 414.268 277.16 414.446 276.855C414.624 276.55 415.017 276.449 415.309 276.627L418.56 278.506C418.864 278.684 418.966 279.065 418.788 279.37C418.674 279.573 418.458 279.688 418.242 279.688ZM411.741 275.928C411.627 275.928 411.526 275.903 411.424 275.839L408.174 273.959C407.869 273.782 407.767 273.4 407.945 273.096C408.123 272.791 408.516 272.689 408.808 272.867L412.059 274.747C412.364 274.925 412.465 275.306 412.287 275.61C412.173 275.814 411.957 275.928 411.741 275.928ZM405.253 272.168C405.139 272.168 405.038 272.143 404.936 272.08L401.686 270.2C401.381 270.022 401.279 269.641 401.457 269.336C401.635 269.031 402.028 268.93 402.32 269.107L405.571 270.987C405.876 271.165 405.977 271.546 405.799 271.851C405.685 272.054 405.469 272.168 405.253 272.168ZM398.765 268.396C398.651 268.396 398.55 268.371 398.448 268.307L395.198 266.428C394.893 266.25 394.791 265.869 394.969 265.564C395.147 265.259 395.54 265.157 395.832 265.335L399.083 267.215C399.388 267.393 399.489 267.774 399.311 268.079C399.197 268.282 398.981 268.396 398.765 268.396ZM392.265 264.637C392.15 264.637 392.049 264.611 391.947 264.548L388.697 262.668C388.392 262.49 388.291 262.109 388.468 261.804C388.646 261.499 389.04 261.398 389.332 261.576L392.582 263.455C392.887 263.633 392.988 264.014 392.811 264.319C392.696 264.522 392.481 264.637 392.265 264.637ZM385.777 260.877C385.662 260.877 385.561 260.852 385.459 260.788L382.209 258.908C381.904 258.731 381.803 258.35 381.98 258.045C382.158 257.74 382.552 257.638 382.844 257.816L386.094 259.696C386.399 259.874 386.5 260.255 386.323 260.56C386.208 260.763 385.993 260.877 385.777 260.877ZM379.289 257.117C379.174 257.117 379.073 257.092 378.971 257.029L375.721 255.149C375.416 254.971 375.315 254.59 375.492 254.285C375.67 253.98 376.064 253.879 376.356 254.056L379.606 255.936C379.911 256.114 380.012 256.495 379.835 256.8C379.72 257.003 379.505 257.117 379.289 257.117ZM372.788 253.345C372.674 253.345 372.572 253.32 372.471 253.256L369.22 251.377C368.916 251.199 368.814 250.818 368.992 250.513C369.169 250.208 369.563 250.106 369.855 250.284L373.105 252.164C373.41 252.342 373.512 252.723 373.334 253.028C373.22 253.231 373.017 253.345 372.788 253.345ZM366.3 249.586C366.186 249.586 366.084 249.56 365.983 249.497L362.732 247.617C362.428 247.439 362.326 247.058 362.504 246.753C362.681 246.448 363.075 246.347 363.367 246.525L366.617 248.404C366.922 248.582 367.024 248.963 366.846 249.268C366.732 249.471 366.516 249.586 366.3 249.586ZM359.812 245.826C359.698 245.826 359.596 245.801 359.495 245.737L356.244 243.857C355.94 243.68 355.838 243.299 356.016 242.994C356.193 242.689 356.587 242.587 356.879 242.765L360.129 244.645C360.434 244.823 360.536 245.204 360.358 245.509C360.244 245.712 360.028 245.826 359.812 245.826ZM353.324 242.067C353.21 242.067 353.108 242.041 353.007 241.978L349.756 240.098C349.452 239.92 349.35 239.539 349.528 239.234C349.705 238.929 350.099 238.828 350.391 239.006L353.641 240.885C353.946 241.063 354.048 241.444 353.87 241.749C353.756 241.952 353.54 242.067 353.324 242.067ZM346.823 238.294C346.709 238.294 346.607 238.269 346.506 238.205L343.256 236.326C342.951 236.148 342.849 235.767 343.027 235.462C343.205 235.157 343.598 235.055 343.89 235.233L347.141 237.113C347.445 237.291 347.547 237.672 347.369 237.977C347.255 238.18 347.039 238.294 346.823 238.294ZM340.335 234.535C340.221 234.535 340.119 234.509 340.018 234.446L336.768 232.566C336.463 232.388 336.361 232.007 336.539 231.702C336.717 231.397 337.11 231.296 337.402 231.474L340.653 233.353C340.957 233.531 341.059 233.912 340.881 234.217C340.767 234.42 340.551 234.535 340.335 234.535ZM333.847 230.775C333.733 230.775 333.631 230.75 333.53 230.686L330.28 228.806C329.975 228.629 329.873 228.248 330.051 227.943C330.229 227.638 330.622 227.536 330.914 227.714L334.165 229.594C334.469 229.772 334.571 230.153 334.393 230.458C334.279 230.661 334.063 230.775 333.847 230.775ZM327.347 227.003C327.232 227.003 327.131 226.977 327.029 226.914L323.779 225.034C323.474 224.856 323.373 224.475 323.55 224.17C323.728 223.866 324.122 223.764 324.414 223.942L327.664 225.822C327.969 225.999 328.07 226.381 327.893 226.685C327.778 226.901 327.575 227.003 327.347 227.003ZM320.859 223.243C320.744 223.243 320.643 223.218 320.541 223.154L317.291 221.275C316.986 221.097 316.885 220.716 317.062 220.411C317.24 220.106 317.634 220.004 317.926 220.182L321.176 222.062C321.481 222.24 321.582 222.621 321.405 222.926C321.29 223.129 321.074 223.243 320.859 223.243ZM314.371 219.484C314.256 219.484 314.155 219.458 314.053 219.395L310.803 217.515C310.498 217.337 310.397 216.956 310.574 216.651C310.752 216.347 311.146 216.245 311.438 216.423L314.688 218.303C314.993 218.48 315.094 218.861 314.917 219.166C314.802 219.369 314.586 219.484 314.371 219.484ZM307.883 215.724C307.768 215.724 307.667 215.699 307.565 215.635L304.315 213.755C304.01 213.578 303.909 213.197 304.086 212.892C304.264 212.587 304.658 212.485 304.95 212.663L308.2 214.543C308.505 214.721 308.606 215.102 308.429 215.407C308.314 215.61 308.098 215.724 307.883 215.724ZM301.382 211.952C301.268 211.952 301.166 211.927 301.065 211.863L297.814 209.983C297.509 209.805 297.408 209.424 297.586 209.12C297.763 208.815 298.157 208.713 298.449 208.891L301.699 210.771C302.004 210.949 302.106 211.33 301.928 211.634C301.814 211.85 301.598 211.952 301.382 211.952ZM294.894 208.192C294.78 208.192 294.678 208.167 294.577 208.103L291.326 206.224C291.021 206.046 290.92 205.665 291.098 205.36C291.275 205.055 291.669 204.954 291.961 205.131L295.211 207.011C295.516 207.189 295.618 207.57 295.44 207.875C295.326 208.078 295.11 208.192 294.894 208.192ZM288.406 204.433C288.292 204.433 288.19 204.407 288.089 204.344L284.838 202.464C284.533 202.286 284.432 201.905 284.61 201.6C284.787 201.296 285.181 201.194 285.473 201.372L288.723 203.252C289.028 203.429 289.13 203.81 288.952 204.115C288.838 204.318 288.622 204.433 288.406 204.433ZM281.905 200.673C281.791 200.673 281.689 200.648 281.588 200.584L278.338 198.705C278.033 198.527 277.931 198.146 278.109 197.841C278.287 197.536 278.68 197.434 278.972 197.612L282.223 199.492C282.527 199.67 282.629 200.051 282.451 200.356C282.337 200.559 282.121 200.673 281.905 200.673ZM275.417 196.901C275.303 196.901 275.201 196.876 275.1 196.812L271.85 194.932C271.545 194.754 271.443 194.373 271.621 194.069C271.799 193.764 272.192 193.662 272.484 193.84L275.735 195.72C276.039 195.898 276.141 196.279 275.963 196.583C275.849 196.787 275.633 196.901 275.417 196.901Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.929 193.141C268.815 193.141 268.713 193.116 268.612 193.052L266.961 192.1C266.657 191.922 266.555 191.541 266.733 191.236C266.91 190.931 267.304 190.83 267.596 191.007L269.247 191.96C269.551 192.138 269.653 192.519 269.475 192.824C269.361 193.027 269.145 193.141 268.929 193.141Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.269 284.577C427.269 287.003 425.555 287.981 423.448 286.762C421.34 285.543 419.626 282.596 419.626 280.17C419.626 277.744 421.34 276.766 423.448 277.986C425.555 279.205 427.269 282.152 427.269 284.577Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.438 208.052C357.438 210.478 355.724 211.456 353.616 210.237C351.508 209.018 349.794 206.071 349.794 203.645C349.794 201.219 351.508 200.241 353.616 201.46C355.724 202.68 357.438 205.626 357.438 208.052Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M222.205 347.017C220.821 347.817 219.932 349.151 219.932 350.548C219.932 352.085 220.783 353.597 222.446 354.562C222.37 354.613 235.118 362.475 235.207 362.525L244.551 368.216C244.564 368.228 247.345 369.918 247.357 369.93C248.69 370.692 250.354 371.112 252.042 371.124C253.515 371.124 254.836 370.807 255.902 370.21C255.953 370.21 263.165 365.002 263.203 364.99C264.587 364.189 265.475 362.856 265.475 361.459C265.475 359.922 264.625 358.41 262.961 357.445C263.038 357.394 250.354 349.57 250.252 349.519L240.984 343.867C240.971 343.855 238.355 342.254 238.33 342.254C236.997 341.492 235.334 341.073 233.645 341.06C232.172 341.06 230.852 341.378 229.785 341.975C229.76 341.962 222.243 346.992 222.205 347.017Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M222.573 346.903C221.253 347.665 220.301 348.998 220.301 350.332C220.301 351.793 220.986 353.304 222.573 354.219C222.421 354.307 234.546 361.865 234.724 361.966L243.751 367.453C243.777 367.466 246.43 369.092 246.469 369.104C247.751 369.841 249.363 370.248 250.989 370.248C252.398 370.248 253.693 369.955 254.709 369.384C254.81 369.384 261.705 364.43 261.781 364.392C263.101 363.63 264.053 362.297 264.053 360.963C264.053 359.502 263.368 357.991 261.781 357.076C261.933 356.987 249.871 349.468 249.693 349.367L240.742 343.931C240.717 343.918 238.216 342.394 238.178 342.381C236.895 341.644 235.283 341.238 233.658 341.225C232.248 341.225 230.953 341.517 229.937 342.089C229.836 342.076 222.65 346.852 222.573 346.903Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M222.941 346.788C221.697 347.512 220.681 348.833 220.681 350.103C220.681 351.488 221.202 352.999 222.713 353.863C222.484 354.003 233.975 361.242 234.242 361.395L242.951 366.666C242.99 366.691 245.529 368.228 245.567 368.253C246.811 368.965 248.36 369.346 249.922 369.358C251.28 369.371 252.525 369.092 253.515 368.546C253.655 368.546 260.244 363.846 260.346 363.783C261.59 363.059 262.606 361.738 262.606 360.468C262.606 359.083 262.085 357.572 260.574 356.708C260.803 356.568 249.363 349.367 249.097 349.202L240.45 343.969C240.412 343.943 238.025 342.495 237.974 342.47C236.73 341.759 235.181 341.365 233.619 341.365C232.261 341.352 231.017 341.632 230.026 342.178C229.912 342.178 223.043 346.725 222.941 346.788Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M223.31 346.674C222.129 347.36 221.063 348.681 221.063 349.875C221.063 351.183 221.431 352.695 222.84 353.507C222.535 353.685 233.404 360.62 233.759 360.823L242.164 365.891C242.215 365.929 244.628 367.39 244.691 367.415C245.897 368.088 247.383 368.469 248.894 368.482C250.201 368.495 251.395 368.228 252.36 367.72C252.55 367.72 258.822 363.262 258.962 363.186C260.143 362.5 261.209 361.179 261.209 359.985C261.209 358.677 260.841 357.165 259.432 356.353C259.737 356.175 248.919 349.265 248.563 349.062L240.234 344.032C240.184 344.007 237.911 342.622 237.848 342.597C236.641 341.924 235.156 341.543 233.645 341.53C232.337 341.517 231.144 341.784 230.179 342.292C229.988 342.28 223.449 346.585 223.31 346.674Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M223.678 346.56C222.573 347.195 221.431 348.529 221.431 349.659C221.431 350.891 221.634 352.403 222.967 353.165C222.586 353.393 232.82 360.011 233.264 360.265L241.352 365.117C241.415 365.155 243.713 366.539 243.79 366.577C244.945 367.225 246.38 367.581 247.827 367.606C249.084 367.619 250.239 367.377 251.166 366.895C251.408 366.895 257.375 362.691 257.54 362.589C258.645 361.954 259.787 360.62 259.787 359.49C259.787 358.258 259.584 356.746 258.251 355.984C258.632 355.756 248.449 349.164 247.992 348.91L239.968 344.096C239.904 344.058 237.746 342.75 237.67 342.724C236.514 342.077 235.08 341.708 233.632 341.696C232.375 341.683 231.22 341.924 230.293 342.407C230.064 342.394 223.856 346.458 223.678 346.56Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M224.046 346.446C223.005 347.043 221.812 348.376 221.812 349.43C221.812 350.586 221.863 352.098 223.107 352.822C222.637 353.088 232.261 359.401 232.794 359.706L240.565 364.354C240.654 364.405 242.812 365.713 242.901 365.751C244.018 366.374 245.389 366.717 246.773 366.742C247.98 366.755 249.084 366.526 249.973 366.082C250.265 366.082 255.915 362.119 256.118 362.005C257.159 361.408 258.353 360.074 258.353 359.02C258.353 357.864 258.302 356.353 257.058 355.641C257.528 355.375 247.954 349.087 247.421 348.783L239.714 344.172C239.638 344.121 237.594 342.889 237.505 342.864C236.388 342.242 235.016 341.899 233.632 341.873C232.426 341.86 231.322 342.076 230.433 342.534C230.128 342.496 224.25 346.319 224.046 346.446Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M224.414 346.332C223.449 346.89 222.192 348.224 222.192 349.215C222.192 350.294 222.078 351.806 223.246 352.479C222.7 352.797 231.69 358.792 232.312 359.147L239.765 363.58C239.866 363.631 241.898 364.863 242.012 364.914C243.078 365.498 244.399 365.828 245.732 365.853C246.887 365.879 247.941 365.663 248.805 365.244C249.135 365.244 254.48 361.535 254.721 361.395C255.686 360.836 256.943 359.503 256.943 358.512C256.943 357.433 257.057 355.921 255.889 355.248C256.435 354.93 247.484 348.961 246.862 348.605L239.46 344.198C239.371 344.147 237.441 342.979 237.34 342.94C236.273 342.356 234.953 342.013 233.619 341.988C232.464 341.962 231.41 342.178 230.547 342.597C230.204 342.597 224.656 346.179 224.414 346.332Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M224.77 346.217C223.868 346.737 222.561 348.071 222.561 348.986C222.561 349.989 222.294 351.488 223.373 352.123C222.751 352.478 231.118 358.169 231.829 358.575L238.977 362.804C239.092 362.868 241.009 364.024 241.136 364.062C242.164 364.621 243.421 364.938 244.691 364.964C245.783 364.989 246.799 364.799 247.637 364.405C248.018 364.405 253.045 360.95 253.325 360.785C254.226 360.264 255.534 358.931 255.534 358.016C255.534 357.013 255.801 355.514 254.721 354.879C255.344 354.523 247.014 348.859 246.303 348.439L239.206 344.248C239.104 344.184 237.289 343.105 237.175 343.054C236.146 342.495 234.889 342.178 233.619 342.14C232.528 342.114 231.512 342.305 230.674 342.698C230.28 342.711 225.049 346.052 224.77 346.217Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M225.138 346.103C224.313 346.585 222.929 347.919 222.929 348.757C222.929 349.684 222.497 351.183 223.5 351.767C222.802 352.174 230.534 357.546 231.347 358.004L238.178 362.017C238.305 362.094 240.095 363.16 240.234 363.211C241.225 363.745 242.418 364.037 243.625 364.075C244.666 364.1 245.643 363.923 246.43 363.567C246.862 363.567 251.573 360.353 251.89 360.176C252.715 359.693 254.099 358.359 254.099 357.521C254.099 356.594 254.531 355.095 253.528 354.511C254.226 354.104 246.532 348.757 245.719 348.287L238.939 344.299C238.825 344.236 237.137 343.219 236.997 343.169C236.007 342.635 234.813 342.33 233.607 342.305C232.566 342.28 231.588 342.457 230.801 342.813C230.356 342.813 225.456 345.912 225.138 346.103Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M225.506 345.988C224.745 346.433 223.31 347.766 223.31 348.541C223.31 349.392 222.726 350.891 223.64 351.424C222.865 351.869 229.976 356.937 230.864 357.445L237.378 361.243C237.517 361.319 239.181 362.322 239.346 362.373C240.285 362.868 241.428 363.16 242.583 363.198C243.574 363.224 244.501 363.071 245.262 362.741C245.745 362.741 250.138 359.782 250.481 359.579C251.243 359.134 252.677 357.8 252.677 357.026C252.677 356.175 253.261 354.676 252.347 354.143C253.122 353.698 246.05 348.656 245.161 348.135L238.686 344.363C238.559 344.286 236.984 343.346 236.832 343.283C235.892 342.788 234.75 342.495 233.594 342.457C232.604 342.432 231.677 342.584 230.915 342.915C230.433 342.927 225.862 345.785 225.506 345.988Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M225.875 345.874C225.176 346.267 223.691 347.614 223.691 348.312C223.691 349.087 222.942 350.586 223.78 351.068C222.929 351.564 229.404 356.314 230.395 356.873L236.591 360.467C236.743 360.556 238.292 361.471 238.457 361.534C239.359 362.004 240.438 362.271 241.53 362.322C242.469 362.36 243.345 362.207 244.082 361.915C244.615 361.915 248.691 359.21 249.072 358.981C249.77 358.588 251.255 357.241 251.255 356.543C251.255 355.768 252.005 354.269 251.167 353.787C252.017 353.291 245.567 348.566 244.59 347.995L238.432 344.426C238.292 344.337 236.832 343.473 236.667 343.41C235.766 342.94 234.686 342.66 233.594 342.622C232.655 342.584 231.779 342.724 231.042 343.029C230.509 343.029 226.256 345.645 225.875 345.874Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M226.243 345.76C225.621 346.116 224.059 347.462 224.059 348.084C224.059 348.783 223.145 350.282 223.907 350.713C222.98 351.247 228.833 355.692 229.9 356.302L235.791 359.68C235.956 359.782 237.378 360.62 237.568 360.684C238.419 361.128 239.447 361.382 240.476 361.421C241.365 361.459 242.19 361.332 242.901 361.065C243.472 361.065 247.256 358.601 247.662 358.372C248.284 358.017 249.846 356.67 249.846 356.048C249.846 355.349 250.76 353.851 249.998 353.419C250.925 352.885 245.097 348.453 244.031 347.843L238.178 344.477C238.025 344.388 236.68 343.588 236.502 343.525C235.651 343.08 234.623 342.826 233.582 342.775C232.693 342.737 231.867 342.864 231.156 343.131C230.585 343.131 226.662 345.506 226.243 345.76Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M226.611 345.646C226.052 345.963 224.44 347.297 224.44 347.868C224.44 348.491 223.373 349.989 224.034 350.37C223.031 350.955 228.249 355.083 229.417 355.756L234.991 358.931C235.169 359.033 236.476 359.795 236.68 359.871C237.492 360.277 238.457 360.519 239.435 360.57C240.273 360.608 241.06 360.506 241.72 360.252C242.342 360.252 245.808 358.042 246.253 357.788C246.811 357.47 248.424 356.137 248.424 355.565C248.424 354.943 249.49 353.444 248.83 353.063C249.833 352.479 244.64 348.364 243.472 347.703L237.937 344.553C237.771 344.452 236.54 343.728 236.349 343.664C235.537 343.258 234.572 343.004 233.594 342.953C232.756 342.915 231.969 343.016 231.309 343.258C230.661 343.245 227.068 345.379 226.611 345.646Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M226.979 345.531C226.497 345.811 224.821 347.144 224.821 347.64C224.821 348.173 223.589 349.684 224.173 350.015C223.094 350.637 227.69 354.46 228.934 355.184L234.191 358.143C234.381 358.258 235.562 358.944 235.778 359.02C236.552 359.401 237.454 359.629 238.368 359.68C239.155 359.718 239.892 359.63 240.526 359.414C241.199 359.414 244.348 357.458 244.831 357.178C245.313 356.899 246.989 355.565 246.989 355.07C246.989 354.536 248.221 353.025 247.637 352.695C248.716 352.072 244.145 348.262 242.901 347.538L237.67 344.591C237.492 344.49 236.375 343.842 236.171 343.753C235.397 343.372 234.496 343.143 233.581 343.092C232.794 343.054 232.058 343.143 231.423 343.347C230.737 343.347 227.462 345.239 226.979 345.531Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M227.347 345.416C226.928 345.658 225.202 346.991 225.202 347.423C225.202 347.88 223.818 349.392 224.313 349.684C223.158 350.357 227.119 353.863 228.465 354.638L233.404 357.394C233.607 357.508 234.661 358.13 234.902 358.207C235.626 358.562 236.476 358.765 237.34 358.829C238.063 358.88 238.762 358.804 239.371 358.613C240.095 358.613 242.926 356.898 243.447 356.606C243.866 356.365 245.593 355.031 245.593 354.599C245.593 354.142 246.976 352.631 246.481 352.339C247.637 351.665 243.688 348.173 242.355 347.398L237.441 344.654C237.251 344.54 236.248 343.969 236.032 343.88C235.308 343.524 234.458 343.308 233.594 343.257C232.87 343.206 232.172 343.283 231.563 343.46C230.814 343.448 227.868 345.112 227.347 345.416Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M227.716 345.302C227.373 345.506 225.57 346.839 225.57 347.195C225.57 347.576 224.021 349.087 224.44 349.329C223.208 350.04 226.547 353.241 227.97 354.066L232.604 356.606C232.82 356.734 233.759 357.267 234.013 357.356C234.699 357.673 235.486 357.877 236.286 357.927C236.959 357.978 237.606 357.915 238.178 357.762C238.939 357.762 241.466 356.302 242.012 355.984C242.355 355.781 244.158 354.447 244.158 354.092C244.158 353.711 245.707 352.199 245.288 351.958C246.519 351.247 243.193 348.059 241.771 347.233L237.162 344.705C236.946 344.578 236.07 344.083 235.841 343.994C235.156 343.677 234.369 343.473 233.569 343.41C232.896 343.359 232.248 343.41 231.677 343.562C230.877 343.562 228.274 344.972 227.716 345.302Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M228.071 345.188C227.792 345.353 225.938 346.687 225.938 346.966C225.938 347.271 224.237 348.782 224.567 348.973C223.246 349.735 225.963 352.618 227.487 353.494L231.804 355.831C232.045 355.971 232.845 356.428 233.112 356.517C233.746 356.809 234.483 356.987 235.219 357.051C235.841 357.102 236.451 357.064 236.984 356.937C237.797 356.924 240.006 355.717 240.59 355.387C240.869 355.222 242.723 353.888 242.723 353.609C242.723 353.304 244.424 351.793 244.094 351.602C245.415 350.84 242.71 347.969 241.187 347.093L236.882 344.769C236.654 344.642 235.905 344.21 235.651 344.121C235.016 343.829 234.28 343.638 233.543 343.575C232.921 343.524 232.312 343.562 231.778 343.676C230.953 343.664 228.668 344.845 228.071 345.188Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M228.439 345.074C228.236 345.188 226.319 346.534 226.319 346.75C226.319 346.979 224.453 348.478 224.707 348.63C223.31 349.43 225.405 352.009 227.005 352.936L231.004 355.057C231.258 355.197 231.944 355.578 232.223 355.679C232.82 355.946 233.493 356.111 234.178 356.175C234.75 356.225 235.308 356.2 235.816 356.111C236.68 356.098 238.584 355.146 239.193 354.79C239.397 354.676 241.314 353.33 241.314 353.114C241.314 352.885 243.18 351.386 242.926 351.234C244.323 350.434 242.241 347.868 240.628 346.941L236.641 344.82C236.4 344.68 235.765 344.324 235.499 344.223C234.902 343.956 234.229 343.791 233.543 343.715C232.972 343.664 232.413 343.677 231.906 343.766C231.03 343.778 229.074 344.705 228.439 345.074Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M228.808 344.959C228.668 345.035 226.7 346.382 226.7 346.521C226.7 346.674 224.681 348.173 224.846 348.274C223.373 349.125 224.833 351.386 226.535 352.364L230.217 354.282C230.483 354.434 231.042 354.739 231.334 354.841C231.893 355.069 232.502 355.222 233.124 355.298C233.645 355.349 234.153 355.349 234.623 355.285C235.537 355.273 237.124 354.574 237.771 354.193C237.911 354.117 239.879 352.77 239.879 352.631C239.879 352.478 241.898 350.98 241.733 350.878C243.206 350.027 241.745 347.766 240.057 346.788L236.375 344.883C236.121 344.743 235.6 344.451 235.321 344.35C234.762 344.121 234.153 343.956 233.531 343.88C233.01 343.816 232.502 343.829 232.02 343.88C231.106 343.88 229.468 344.565 228.808 344.959Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M229.176 344.845C229.112 344.883 227.068 346.229 227.068 346.293C227.068 346.369 224.884 347.868 224.973 347.919C223.424 348.808 224.262 350.764 226.04 351.793L229.404 353.495C229.684 353.66 230.115 353.876 230.433 353.99C230.941 354.193 231.499 354.333 232.058 354.409C232.528 354.473 232.985 354.485 233.429 354.447C234.394 354.434 235.664 353.977 236.349 353.583C236.413 353.545 238.457 352.199 238.457 352.135C238.457 352.059 240.641 350.561 240.552 350.51C242.101 349.621 241.276 347.665 239.486 346.636L236.121 344.934C235.854 344.781 235.448 344.566 235.156 344.464C234.648 344.261 234.089 344.121 233.531 344.045C233.061 343.981 232.604 343.969 232.16 343.994C231.182 343.981 229.874 344.439 229.176 344.845Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.953 352.986L239.384 350.141C241.009 349.201 240.806 347.563 238.927 346.483L235.867 344.985C233.988 343.905 231.157 343.791 229.531 344.718L225.1 347.563C223.475 348.503 223.678 350.141 225.557 351.221L228.617 352.72C230.496 353.799 233.328 353.926 234.953 352.986Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.041 363.478L436.779 355.628L500.25 302.956L486.525 310.806L423.041 363.478Z",
    fill: "#0CB073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.267 358.549L248.005 350.7L350.683 277.109L336.945 284.958L234.267 358.549Z",
    fill: "#1F45CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.783 262.795L351.508 254.946L437.135 333.071L423.397 340.92L337.783 262.795Z",
    fill: "url(#paint164_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.306 288.325L478.043 280.475L532.157 263.494L518.419 271.343L464.306 288.325Z",
    fill: "#CAFF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.25 320.814L509.988 312.965L532.156 263.494L518.419 271.343L496.25 320.814Z",
    fill: "#51A245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.305 288.325L474.145 298.193L474.488 298.536L423.397 340.92L337.783 262.795L218.028 348.77L234.267 358.55L336.945 284.959L423.067 363.529L486.537 310.869L486.74 311.073L496.25 320.814L518.419 271.343L464.305 288.325Z",
    fill: "url(#paint165_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.038 272.181L531.369 264.001L517.505 271.622L464.306 288.324L465.309 289.328L518.038 272.181Z",
    fill: "url(#paint166_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.783 264.116L423.397 342.229L474.488 299.845L474.145 299.502L473.777 299.133L423.397 340.92L337.783 262.795L218.028 348.77L219.018 349.367L337.783 264.116Z",
    fill: "url(#paint167_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.39 430.121C416.942 430.121 427.117 425.378 427.117 419.528C427.117 413.678 416.942 408.935 404.39 408.935C391.838 408.935 381.663 413.678 381.663 419.528C381.663 425.378 391.838 430.121 404.39 430.121Z",
    fill: "url(#paint168_radial_1_2)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M389.649 428.737C389.903 428.876 389.687 434.935 389.395 441.006C389.103 447.077 388.748 453.186 388.748 453.44C388.735 453.974 388.418 454.469 387.833 454.812L384.634 456.603L383.91 457.01C383.885 457.022 380 459.181 379.987 459.181C379.543 459.435 379.009 459.562 378.451 459.575C378.425 459.575 378.4 459.575 378.374 459.575C377.879 459.575 377.397 459.461 377.041 459.245L375.695 458.381C375.213 458.102 374.934 457.657 374.934 457.175C374.934 456.641 375.264 456.133 375.835 455.803C375.835 455.79 381.752 451.357 381.777 451.345L382.196 451.04C382.653 450.773 383.225 450.634 383.809 450.634C383.961 450.634 384.304 448.322 384.685 445.185C384.913 443.305 385.18 441.133 385.434 438.974C385.789 435.913 386.145 432.864 386.424 430.68C386.665 428.711 386.869 427.454 386.945 427.505L389.649 428.737Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M389.179 430.121C389.433 430.261 389.23 436.027 388.951 441.806C388.684 447.585 388.329 453.39 388.316 453.644C388.291 454.152 387.999 454.634 387.44 454.952L384.355 456.679C384.342 456.679 383.656 457.073 383.656 457.073C383.618 457.086 379.898 459.143 379.847 459.143C379.416 459.372 378.895 459.499 378.362 459.512C378.336 459.512 378.311 459.512 378.286 459.512C377.803 459.512 377.346 459.385 377.003 459.194L375.708 458.356C375.251 458.089 374.972 457.67 374.972 457.2C374.972 456.692 375.277 456.209 375.822 455.879C375.81 455.854 381.447 451.624 381.485 451.599L381.879 451.307C382.31 451.053 382.869 450.913 383.415 450.913C383.567 450.913 383.923 448.69 384.291 445.718C384.52 443.927 384.786 441.857 385.04 439.799C385.408 436.891 385.777 433.995 386.043 431.937C386.285 430.07 386.488 428.889 386.564 428.94L389.179 430.121Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M388.71 431.506C388.964 431.658 388.773 437.12 388.519 442.606C388.265 448.093 387.91 453.606 387.885 453.86C387.846 454.342 387.58 454.8 387.047 455.104L384.063 456.768C384.05 456.781 383.403 457.137 383.39 457.149C383.326 457.175 379.771 459.131 379.708 459.118C379.289 459.334 378.794 459.448 378.273 459.461C378.248 459.461 378.222 459.461 378.197 459.461C377.74 459.461 377.283 459.334 376.953 459.143L375.696 458.343C375.251 458.089 374.997 457.683 374.985 457.238C374.972 456.743 375.264 456.286 375.785 455.981C375.772 455.943 381.117 451.916 381.181 451.878L381.562 451.599C381.968 451.358 382.514 451.218 383.034 451.218C383.174 451.218 383.542 449.097 383.91 446.277C384.126 444.575 384.418 442.606 384.672 440.65C385.041 437.894 385.421 435.151 385.688 433.208C385.929 431.442 386.132 430.337 386.209 430.375L388.71 431.506Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M388.24 432.89C388.494 433.042 388.329 438.212 388.075 443.407C387.834 448.601 387.491 453.822 387.453 454.063C387.402 454.52 387.161 454.952 386.653 455.244L383.783 456.844C383.771 456.857 383.149 457.2 383.123 457.213C383.034 457.251 379.644 459.093 379.555 459.08C379.149 459.283 378.667 459.385 378.171 459.397C378.146 459.397 378.121 459.397 378.108 459.397C377.676 459.397 377.219 459.27 376.914 459.093L375.708 458.318C375.289 458.076 375.035 457.695 375.023 457.264C375.01 456.794 375.289 456.362 375.772 456.07C375.746 456.006 380.812 452.196 380.888 452.145L381.244 451.878C381.625 451.65 382.158 451.51 382.653 451.51C382.793 451.51 383.161 449.478 383.517 446.823C383.733 445.197 384.025 443.343 384.291 441.489C384.659 438.885 385.066 436.307 385.32 434.478C385.548 432.814 385.764 431.772 385.84 431.81L388.24 432.89Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M387.77 434.287C388.024 434.439 387.872 439.316 387.643 444.219C387.415 449.122 387.072 454.037 387.034 454.291C386.97 454.723 386.754 455.13 386.272 455.396L383.504 456.933C383.491 456.946 382.895 457.276 382.869 457.276C382.755 457.327 379.543 459.067 379.428 459.041C379.035 459.232 378.578 459.321 378.108 459.321C378.083 459.321 378.07 459.321 378.044 459.321C377.638 459.321 377.194 459.181 376.902 459.016L375.734 458.279C375.327 458.051 375.099 457.682 375.086 457.276C375.073 456.831 375.327 456.425 375.784 456.133C375.759 456.057 380.52 452.45 380.635 452.386L380.977 452.132C381.346 451.916 381.853 451.776 382.311 451.776C382.438 451.776 382.831 449.846 383.174 447.331C383.39 445.794 383.694 444.041 383.961 442.301C384.342 439.837 384.748 437.424 385.002 435.709C385.231 434.147 385.447 433.182 385.51 433.22L387.77 434.287Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M387.3 435.671C387.554 435.824 387.415 440.409 387.199 445.019C386.983 449.63 386.653 454.253 386.602 454.494C386.538 454.901 386.335 455.282 385.891 455.536L383.225 457.009C383.199 457.022 382.641 457.34 382.615 457.34C382.488 457.39 379.428 459.029 379.301 459.003C378.933 459.181 378.476 459.257 378.032 459.257C378.006 459.257 377.994 459.257 377.968 459.257C377.587 459.257 377.143 459.118 376.876 458.965L375.759 458.254C375.378 458.038 375.15 457.695 375.137 457.314C375.124 456.895 375.353 456.501 375.784 456.235C375.746 456.146 380.228 452.742 380.355 452.666L380.673 452.424C381.015 452.234 381.511 452.081 381.942 452.081C382.057 452.081 382.463 450.24 382.793 447.89C382.996 446.442 383.314 444.791 383.593 443.152C383.974 440.841 384.405 438.58 384.647 436.992C384.875 435.519 385.091 434.63 385.155 434.668L387.3 435.671Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M386.831 437.056C387.085 437.208 386.97 441.501 386.767 445.82C386.564 450.138 386.234 454.469 386.183 454.711C386.107 455.092 385.929 455.447 385.51 455.688L382.958 457.098C382.933 457.111 382.4 457.403 382.374 457.416C382.222 457.479 379.34 459.004 379.175 458.978C378.819 459.143 378.387 459.207 377.956 459.207C377.943 459.207 377.918 459.207 377.892 459.207C377.537 459.207 377.092 459.067 376.838 458.915L375.759 458.241C375.391 458.038 375.188 457.708 375.162 457.352C375.137 456.959 375.353 456.59 375.747 456.324C375.708 456.222 379.898 453.009 380.051 452.932L380.355 452.716C380.673 452.539 381.155 452.399 381.549 452.399C381.663 452.399 382.069 450.659 382.4 448.461C382.603 447.09 382.92 445.553 383.199 444.016C383.58 441.857 384.025 439.748 384.266 438.275C384.482 436.903 384.71 436.09 384.774 436.129L386.831 437.056Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M386.373 438.453C386.627 438.606 386.526 442.606 386.335 446.62C386.145 450.646 385.866 454.685 385.764 454.914C385.751 455.27 385.523 455.6 385.129 455.828L382.679 457.175C382.653 457.187 382.158 457.467 382.12 457.48C381.942 457.556 379.225 458.978 379.047 458.94C378.705 459.093 378.286 459.143 377.879 459.143C377.867 459.143 377.841 459.143 377.829 459.143C377.498 459.143 377.067 458.991 376.826 458.864L375.784 458.216C375.442 458.013 375.238 457.708 375.213 457.378C375.188 457.01 375.391 456.654 375.746 456.413C375.695 456.298 379.606 453.288 379.784 453.199L380.063 452.996C380.355 452.831 380.812 452.691 381.193 452.691C381.295 452.691 381.726 451.04 382.044 449.008C382.247 447.725 382.577 446.29 382.856 444.867C383.25 442.86 383.707 440.917 383.936 439.545C384.151 438.275 384.38 437.539 384.431 437.564L386.373 438.453Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M385.904 439.837C386.158 439.99 386.081 443.699 385.904 447.42C385.726 451.154 385.459 454.901 385.345 455.13C385.332 455.46 385.117 455.765 384.748 455.981L382.412 457.263C382.374 457.276 381.917 457.543 381.879 457.556C381.688 457.632 379.124 458.953 378.933 458.915C378.603 459.054 378.21 459.092 377.816 459.08C377.803 459.08 377.778 459.08 377.765 459.08C377.46 459.08 377.029 458.927 376.813 458.8L375.823 458.178C375.505 457.987 375.302 457.708 375.289 457.39C375.264 457.048 375.442 456.717 375.772 456.489C375.721 456.362 379.34 453.555 379.53 453.453L379.797 453.263C380.063 453.11 380.508 452.97 380.863 452.97C380.952 452.97 381.396 451.421 381.701 449.541C381.892 448.347 382.247 447.014 382.526 445.693C382.933 443.838 383.39 442.047 383.618 440.803C383.834 439.634 384.063 438.961 384.113 438.986L385.904 439.837Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M385.434 441.222C385.688 441.374 385.624 444.791 385.459 448.22C385.294 451.662 385.04 455.117 384.913 455.333C384.901 455.638 384.698 455.93 384.355 456.12L382.12 457.34C382.082 457.365 381.65 457.594 381.612 457.619C381.396 457.708 379.009 458.927 378.781 458.876C378.464 458.991 378.095 459.029 377.727 459.016C377.714 459.016 377.702 459.016 377.676 459.016C377.397 459.016 376.965 458.864 376.775 458.749L375.823 458.165C375.518 457.987 375.34 457.721 375.315 457.428C375.289 457.098 375.442 456.793 375.746 456.577C375.683 456.438 379.022 453.834 379.238 453.707L379.479 453.529C379.733 453.389 380.152 453.25 380.47 453.25C380.558 453.25 381.003 451.789 381.308 450.074C381.498 448.957 381.854 447.737 382.146 446.518C382.552 444.816 383.034 443.178 383.25 442.047C383.453 440.98 383.695 440.383 383.745 440.409L385.434 441.222Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M384.964 442.619C385.218 442.771 385.167 445.896 385.028 449.033C384.875 452.183 384.634 455.345 384.494 455.561C384.469 455.841 384.291 456.108 383.974 456.285L381.853 457.441C381.815 457.467 381.409 457.682 381.371 457.708C381.13 457.81 378.908 458.915 378.666 458.864C378.362 458.965 378.006 458.991 377.663 458.978C377.651 458.978 377.638 458.978 377.625 458.978C377.371 458.978 376.952 458.826 376.762 458.711L375.861 458.152C375.581 457.987 375.403 457.746 375.378 457.467C375.34 457.162 375.492 456.882 375.759 456.679C375.695 456.527 378.743 454.126 378.971 453.986L379.2 453.821C379.428 453.694 379.835 453.555 380.127 453.555C380.203 453.555 380.673 452.196 380.952 450.633C381.142 449.605 381.511 448.474 381.803 447.382C382.209 445.832 382.704 444.359 382.92 443.343C383.123 442.378 383.364 441.844 383.415 441.869L384.964 442.619Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M384.494 444.003C384.748 444.156 384.723 446.988 384.583 449.833C384.456 452.691 384.215 455.549 384.063 455.765C384.037 456.019 383.872 456.26 383.58 456.425L381.561 457.517C381.523 457.543 381.155 457.746 381.104 457.771C380.838 457.873 378.781 458.876 378.527 458.826C378.235 458.914 377.905 458.927 377.575 458.914C377.562 458.914 377.549 458.914 377.537 458.914C377.308 458.914 376.889 458.749 376.724 458.66L375.861 458.14C375.594 457.987 375.442 457.759 375.404 457.517C375.365 457.238 375.492 456.984 375.734 456.793C375.657 456.616 378.425 454.431 378.679 454.279L378.882 454.126C379.086 454.012 379.479 453.872 379.733 453.872C379.809 453.872 380.279 452.602 380.558 451.205C380.749 450.252 381.117 449.236 381.422 448.245C381.841 446.848 382.336 445.527 382.552 444.626C382.755 443.762 382.996 443.305 383.034 443.33L384.494 444.003Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M384.024 445.388C384.278 445.54 384.266 448.081 384.151 450.633C384.037 453.186 383.809 455.765 383.644 455.981C383.618 456.209 383.466 456.425 383.212 456.578L381.295 457.606C381.244 457.632 380.914 457.822 380.863 457.835C380.584 457.949 378.692 458.851 378.4 458.788C378.12 458.864 377.803 458.864 377.498 458.838C377.486 458.838 377.473 458.838 377.46 458.838C377.257 458.838 376.838 458.673 376.698 458.584L375.886 458.089C375.645 457.949 375.492 457.746 375.454 457.518C375.416 457.263 375.518 457.022 375.733 456.844C375.657 456.654 378.133 454.672 378.412 454.507L378.603 454.368C378.781 454.266 379.162 454.139 379.39 454.139C379.454 454.139 379.949 452.97 380.215 451.726C380.393 450.862 380.787 449.948 381.079 449.058C381.498 447.801 382.018 446.658 382.221 445.87C382.412 445.108 382.666 444.727 382.704 444.74L384.024 445.388Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M383.555 446.785C383.809 446.938 383.821 449.186 383.707 451.447C383.606 453.707 383.39 455.994 383.212 456.21C383.187 456.413 383.047 456.603 382.818 456.743L381.015 457.708C380.965 457.734 380.66 457.899 380.609 457.924C380.304 458.051 378.578 458.839 378.273 458.775C378.006 458.839 377.714 458.826 377.422 458.801C377.41 458.801 377.397 458.801 377.397 458.801C377.219 458.801 376.813 458.636 376.686 458.559L375.911 458.102C375.696 457.975 375.556 457.785 375.518 457.581C375.48 457.353 375.556 457.137 375.746 456.972C375.657 456.768 377.841 454.99 378.146 454.812L378.324 454.685C378.489 454.597 378.844 454.47 379.047 454.47C379.098 454.47 379.619 453.39 379.86 452.31C380.038 451.523 380.431 450.723 380.736 449.948C381.168 448.843 381.688 447.865 381.892 447.179C382.082 446.519 382.336 446.201 382.374 446.226L383.555 446.785Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M383.085 448.169C383.339 448.321 383.364 450.277 383.275 452.246C383.187 454.215 382.983 456.209 382.793 456.412C382.768 456.59 382.641 456.755 382.437 456.882L380.736 457.784C380.685 457.809 380.406 457.962 380.343 457.987C380.012 458.127 378.463 458.813 378.133 458.736C377.879 458.787 377.6 458.762 377.346 458.736C377.333 458.736 377.333 458.736 377.321 458.736C377.168 458.736 376.762 458.559 376.648 458.495L375.911 458.063C375.708 457.949 375.581 457.784 375.543 457.593C375.505 457.39 375.569 457.187 375.721 457.034C375.632 456.819 377.524 455.244 377.854 455.053L378.006 454.951C378.146 454.875 378.489 454.748 378.654 454.748C378.705 454.748 379.238 453.77 379.466 452.843C379.644 452.144 380.051 451.446 380.355 450.773C380.787 449.82 381.206 448.956 381.523 448.423C381.599 447.839 381.968 447.623 381.993 447.636L383.085 448.169Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M382.615 449.554C382.869 449.707 382.907 451.37 382.831 453.047C382.755 454.723 382.564 456.425 382.349 456.629C382.323 456.781 382.209 456.921 382.031 457.022L380.444 457.861C380.381 457.899 380.139 458.026 380.076 458.051C379.733 458.191 378.336 458.775 377.981 458.699C377.74 458.737 377.486 458.699 377.245 458.674C377.232 458.674 377.232 458.674 377.219 458.674C377.092 458.674 376.686 458.496 376.597 458.445L375.911 458.051C375.734 457.95 375.607 457.797 375.569 457.632C375.518 457.454 375.569 457.276 375.696 457.137C375.594 456.908 377.206 455.536 377.549 455.333L377.689 455.244C377.803 455.181 378.121 455.054 378.273 455.054C378.311 455.054 378.87 454.165 379.073 453.403C379.251 452.78 379.657 452.196 379.974 451.624C380.419 450.824 380.838 450.113 381.155 449.707C381.219 449.211 381.6 449.071 381.625 449.084L382.615 449.554Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M382.145 450.938C382.399 451.09 382.463 452.462 382.399 453.847C382.336 455.231 382.158 456.628 381.93 456.831C381.904 456.958 381.803 457.085 381.65 457.162L380.165 457.936C380.101 457.974 379.898 458.089 379.822 458.114C379.454 458.267 378.222 458.737 377.854 458.66C377.625 458.686 377.397 458.635 377.168 458.597H377.156C377.054 458.597 376.66 458.419 376.584 458.368L375.937 458C375.772 457.911 375.67 457.784 375.619 457.632C375.568 457.479 375.594 457.314 375.683 457.2C375.581 456.958 376.902 455.79 377.27 455.574L377.384 455.498C377.473 455.447 377.778 455.32 377.892 455.32C377.917 455.32 378.616 454.558 378.692 453.923C378.959 453.415 379.289 452.907 379.606 452.449C380.05 451.802 380.482 451.243 380.8 450.951C380.85 450.557 381.257 450.493 381.269 450.506L382.145 450.938Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M381.676 452.335C381.929 452.488 382.006 453.567 381.955 454.66C381.904 455.752 381.739 456.857 381.498 457.06C381.46 457.162 381.384 457.263 381.257 457.327L379.873 458.038C379.809 458.076 379.631 458.165 379.555 458.203C379.162 458.368 378.108 458.737 377.714 458.648C377.498 458.66 377.282 458.597 377.079 458.559H377.067C376.99 458.559 376.597 458.368 376.546 458.343L375.949 458C375.81 457.924 375.708 457.809 375.67 457.695C375.619 457.555 375.632 457.428 375.683 457.314C375.581 457.06 376.61 456.095 376.99 455.866L377.092 455.803C377.156 455.765 377.448 455.638 377.536 455.638C377.562 455.638 378.273 454.964 378.324 454.494C378.59 454.075 378.92 453.669 379.25 453.313C379.695 452.818 380.139 452.411 380.457 452.246C380.495 451.954 380.914 451.967 380.926 451.967L381.676 452.335Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M381.206 453.72C381.473 453.872 381.561 454.659 381.523 455.46C381.485 456.26 381.32 457.073 381.079 457.263C381.041 457.339 380.977 457.416 380.876 457.466L379.606 458.114C379.543 458.152 379.39 458.228 379.314 458.267C378.895 458.432 378.006 458.698 377.587 458.61C377.384 458.597 377.181 458.559 377.003 458.495H376.991C376.94 458.495 376.546 458.305 376.508 458.279L375.95 457.974C375.835 457.911 375.746 457.809 375.696 457.72C375.645 457.606 375.632 457.505 375.658 457.403C375.543 457.136 376.292 456.374 376.699 456.133L376.775 456.082C376.826 456.057 377.092 455.93 377.156 455.93C377.168 455.93 377.905 455.358 377.943 455.041C378.21 454.71 378.552 454.405 378.87 454.151C379.314 453.808 379.771 453.554 380.089 453.504C380.114 453.313 380.546 453.389 380.546 453.402L381.206 453.72Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M380.736 455.104C381.003 455.256 381.104 455.752 381.079 456.26C381.054 456.768 380.876 457.25 380.647 457.479C380.609 457.53 380.558 457.581 380.482 457.619L379.314 458.203C379.238 458.241 379.124 458.305 379.047 458.343C378.616 458.521 377.892 458.673 377.448 458.584C377.257 458.559 377.079 458.521 376.914 458.444C376.889 458.444 376.508 458.254 376.483 458.241L375.975 457.962C375.873 457.898 375.797 457.835 375.746 457.758C375.683 457.67 375.657 457.581 375.657 457.492C375.543 457.2 376 456.653 376.432 456.399L376.495 456.361C376.521 456.349 376.775 456.234 376.8 456.234C376.813 456.234 377.562 455.752 377.587 455.599C377.867 455.358 378.197 455.155 378.527 455.002C378.984 454.812 379.441 454.71 379.758 454.786C379.771 454.685 380.216 454.85 380.216 454.85L380.736 455.104Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.863 458.368L376.013 457.924C375.454 457.593 375.518 457.035 376.165 456.654L377.219 456.133C377.866 455.752 378.857 455.714 379.415 456.044L380.266 456.488C380.825 456.819 380.761 457.377 380.114 457.759L379.06 458.279C378.412 458.66 377.422 458.698 376.863 458.368Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M407.501 435.989C407.767 436.142 407.628 442.797 407.412 449.478C407.196 456.159 406.904 462.865 406.904 463.132C406.891 463.703 406.548 464.237 405.926 464.605L402.498 466.523L401.724 466.955C401.698 466.968 397.521 469.292 397.508 469.279C397.039 469.546 396.455 469.698 395.858 469.711C395.832 469.711 395.794 469.711 395.769 469.711C395.236 469.711 394.728 469.584 394.334 469.355L392.9 468.428C392.379 468.123 392.087 467.653 392.074 467.133C392.074 466.561 392.43 466.015 393.039 465.659C393.026 465.647 399.527 460.782 399.553 460.769L399.857 460.541C400.34 460.261 400.962 460.096 401.584 460.096C401.762 460.096 402.105 457.442 402.473 453.86C402.676 451.853 402.917 449.541 403.146 447.255C403.476 443.877 403.819 440.511 404.073 438.11C404.301 435.964 404.492 434.592 404.58 434.643L407.501 435.989Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M407.018 437.513C407.285 437.666 407.158 444.003 406.955 450.354C406.752 456.705 406.46 463.093 406.447 463.36C406.421 463.906 406.104 464.414 405.507 464.757L402.194 466.612C402.181 466.612 401.444 467.031 401.444 467.031C401.394 467.056 397.407 469.266 397.356 469.253C396.899 469.508 396.328 469.635 395.756 469.647C395.731 469.647 395.706 469.647 395.667 469.647C395.16 469.647 394.652 469.52 394.283 469.304L392.887 468.402C392.392 468.11 392.1 467.666 392.1 467.158C392.087 466.612 392.43 466.091 393.014 465.748C393.001 465.723 399.172 461.087 399.222 461.048L399.515 460.833C399.972 460.566 400.581 460.401 401.165 460.401C401.33 460.401 401.686 457.848 402.041 454.457C402.244 452.539 402.498 450.341 402.727 448.157C403.07 444.943 403.425 441.755 403.679 439.482C403.908 437.437 404.098 436.141 404.187 436.192L407.018 437.513Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M406.536 439.037C406.802 439.19 406.688 445.198 406.498 451.231C406.307 457.264 406.015 463.322 405.99 463.589C405.952 464.11 405.66 464.592 405.088 464.923L401.889 466.701C401.876 466.713 401.178 467.094 401.165 467.107C401.089 467.133 397.28 469.228 397.204 469.216C396.759 469.457 396.213 469.571 395.667 469.584C395.642 469.584 395.617 469.584 395.591 469.584C395.109 469.584 394.613 469.444 394.258 469.241L392.912 468.377C392.442 468.098 392.163 467.666 392.15 467.196C392.138 466.675 392.455 466.18 393.014 465.85C392.988 465.799 398.854 461.392 398.918 461.354L399.197 461.15C399.641 460.896 400.225 460.744 400.771 460.744C400.924 460.744 401.305 458.305 401.647 455.092C401.851 453.263 402.117 451.18 402.358 449.11C402.714 446.061 403.082 443.038 403.336 440.905C403.565 438.974 403.768 437.755 403.844 437.805L406.536 439.037Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M406.053 440.561C406.32 440.714 406.231 446.404 406.041 452.119C405.863 457.835 405.571 463.563 405.533 463.83C405.482 464.325 405.215 464.782 404.682 465.087L401.597 466.802C401.584 466.815 400.911 467.183 400.898 467.196C400.81 467.234 397.166 469.215 397.077 469.202C396.645 469.418 396.124 469.533 395.591 469.533C395.566 469.533 395.54 469.533 395.515 469.533C395.058 469.533 394.563 469.393 394.233 469.202L392.938 468.377C392.48 468.11 392.214 467.704 392.214 467.246C392.201 466.751 392.493 466.281 393.014 465.964C392.988 465.9 398.537 461.709 398.626 461.658L398.892 461.455C399.311 461.213 399.87 461.061 400.403 461.061C400.556 461.061 400.936 458.737 401.279 455.701C401.482 453.961 401.749 451.992 402.003 450.036C402.358 447.153 402.752 444.308 402.993 442.301C403.209 440.472 403.425 439.342 403.501 439.393L406.053 440.561Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M405.571 442.085C405.85 442.238 405.761 447.611 405.584 452.996C405.406 458.381 405.126 463.792 405.088 464.059C405.025 464.516 404.784 464.96 404.276 465.253L401.305 466.904C401.279 466.916 400.645 467.272 400.632 467.272C400.518 467.323 397.051 469.19 396.937 469.165C396.518 469.368 396.023 469.469 395.515 469.469C395.49 469.469 395.464 469.469 395.439 469.469C395.007 469.469 394.525 469.33 394.207 469.152L392.95 468.352C392.519 468.098 392.265 467.717 392.252 467.285C392.239 466.815 392.506 466.37 393.001 466.065C392.963 465.989 398.194 462.026 398.308 461.963L398.562 461.772C398.956 461.544 399.502 461.391 399.997 461.391C400.137 461.391 400.543 459.169 400.873 456.324C401.076 454.672 401.356 452.818 401.609 450.976C401.978 448.258 402.384 445.591 402.625 443.699C402.841 441.984 403.057 440.93 403.133 440.968L405.571 442.085Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M405.088 443.597C405.368 443.749 405.291 448.792 405.126 453.859C404.961 458.927 404.669 464.008 404.631 464.274C404.555 464.706 404.339 465.125 403.869 465.392L401.013 466.967C400.987 466.98 400.391 467.31 400.365 467.323C400.225 467.386 396.95 469.139 396.797 469.114C396.391 469.304 395.909 469.393 395.426 469.393C395.401 469.393 395.388 469.393 395.363 469.393C394.956 469.393 394.474 469.241 394.182 469.075L392.976 468.313C392.569 468.072 392.328 467.704 392.303 467.297C392.277 466.853 392.531 466.421 392.988 466.141C392.95 466.053 397.864 462.306 398.004 462.23L398.245 462.052C398.613 461.836 399.134 461.683 399.603 461.683C399.73 461.683 400.149 459.575 400.479 456.908C400.67 455.358 400.975 453.605 401.229 451.878C401.609 449.325 402.028 446.836 402.27 445.07C402.485 443.457 402.701 442.492 402.778 442.53L405.088 443.597Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M404.593 445.121C404.872 445.274 404.809 449.999 404.656 454.736C404.504 459.474 404.212 464.237 404.161 464.491C404.085 464.897 403.882 465.278 403.437 465.545L400.695 467.056C400.67 467.069 400.098 467.387 400.073 467.399C399.908 467.463 396.81 469.114 396.645 469.076C396.251 469.254 395.794 469.317 395.337 469.317C395.312 469.317 395.299 469.317 395.274 469.317C394.893 469.317 394.423 469.165 394.144 469.012L392.988 468.288C392.595 468.06 392.366 467.717 392.353 467.336C392.328 466.917 392.569 466.51 392.988 466.244C392.937 466.142 397.546 462.624 397.699 462.522L397.914 462.357C398.257 462.166 398.765 462.014 399.197 462.014C399.324 462.014 399.755 460.02 400.073 457.518C400.263 456.057 400.581 454.419 400.847 452.793C401.228 450.405 401.673 448.081 401.901 446.455C402.117 444.956 402.346 444.067 402.409 444.105L404.593 445.121Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M404.111 446.646C404.39 446.798 404.339 451.205 404.2 455.625C404.06 460.045 403.819 464.491 403.704 464.732C403.692 465.113 403.438 465.469 403.019 465.71L400.391 467.145C400.365 467.158 399.832 467.463 399.794 467.476C399.603 467.552 396.683 469.089 396.493 469.038C396.124 469.203 395.68 469.254 395.236 469.254C395.223 469.254 395.198 469.254 395.172 469.254C394.817 469.254 394.347 469.101 394.093 468.949L392.976 468.25C392.607 468.035 392.392 467.717 392.366 467.349C392.341 466.955 392.557 466.574 392.938 466.32C392.887 466.193 397.166 462.903 397.356 462.802L397.559 462.649C397.877 462.471 398.372 462.319 398.765 462.319C398.88 462.319 399.324 460.426 399.641 458.115C399.832 456.743 400.162 455.219 400.429 453.708C400.822 451.497 401.279 449.338 401.508 447.84C401.711 446.455 401.952 445.642 402.016 445.668L404.111 446.646Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M403.628 448.169C403.908 448.334 403.869 452.399 403.742 456.501C403.615 460.604 403.374 464.719 403.26 464.96C403.247 465.316 403.006 465.646 402.625 465.875L400.111 467.247C400.073 467.272 399.578 467.539 399.54 467.564C399.324 467.653 396.582 469.063 396.378 469.025C396.023 469.164 395.604 469.215 395.185 469.203C395.172 469.203 395.147 469.203 395.134 469.203C394.817 469.203 394.347 469.037 394.106 468.91L393.039 468.25C392.696 468.047 392.493 467.742 392.468 467.412C392.442 467.043 392.633 466.688 392.988 466.434C392.925 466.294 396.899 463.22 397.102 463.106L397.293 462.966C397.585 462.801 398.054 462.649 398.435 462.649C398.537 462.649 399.007 460.871 399.311 458.737C399.502 457.454 399.845 456.044 400.111 454.647C400.518 452.602 400.987 450.621 401.216 449.249C401.419 447.966 401.66 447.242 401.724 447.268L403.628 448.169Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M403.146 449.694C403.425 449.859 403.4 453.606 403.285 457.378C403.158 461.15 402.943 464.948 402.803 465.189C402.79 465.519 402.574 465.824 402.206 466.027L399.807 467.336C399.768 467.361 399.299 467.615 399.261 467.628C399.032 467.729 396.467 469.025 396.226 468.974C395.883 469.101 395.477 469.139 395.083 469.127C395.071 469.127 395.045 469.127 395.033 469.127C394.741 469.127 394.271 468.961 394.055 468.834L393.039 468.199C392.722 468.009 392.519 467.729 392.493 467.412C392.468 467.069 392.633 466.739 392.963 466.497C392.9 466.345 396.543 463.5 396.785 463.36L396.962 463.233C397.229 463.081 397.686 462.928 398.029 462.928C398.118 462.928 398.613 461.264 398.905 459.308C399.095 458.115 399.438 456.819 399.73 455.536C400.149 453.656 400.632 451.853 400.848 450.608C401.051 449.44 401.305 448.779 401.356 448.817L403.146 449.694Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M402.663 451.205C402.942 451.37 402.93 454.799 402.828 458.254C402.714 461.709 402.498 465.176 402.346 465.418C402.32 465.722 402.13 466.002 401.787 466.192L399.501 467.424C399.463 467.45 399.032 467.691 398.981 467.704C398.727 467.805 396.34 468.999 396.073 468.948C395.743 469.063 395.362 469.088 394.994 469.063C394.981 469.063 394.969 469.063 394.943 469.063C394.677 469.063 394.22 468.898 394.017 468.783L393.039 468.186C392.734 468.009 392.556 467.755 392.518 467.462C392.48 467.145 392.633 466.84 392.925 466.611C392.848 466.446 396.188 463.817 396.442 463.677L396.607 463.563C396.848 463.423 397.292 463.284 397.597 463.284C397.686 463.284 398.181 461.721 398.473 459.956C398.651 458.851 399.019 457.67 399.311 456.489C399.73 454.774 400.238 453.148 400.454 452.03C400.657 450.964 400.911 450.392 400.949 450.417L402.663 451.205Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M402.168 452.729C402.447 452.894 402.46 456.006 402.358 459.13C402.257 462.268 402.041 465.417 401.876 465.646C401.85 465.926 401.673 466.18 401.368 466.357L399.197 467.526C399.146 467.551 398.752 467.767 398.702 467.793C398.422 467.907 396.213 468.987 395.934 468.923C395.616 469.025 395.261 469.025 394.905 469.012C394.893 469.012 394.88 469.012 394.867 469.012C394.626 469.012 394.169 468.834 393.991 468.733L393.064 468.174C392.785 468.009 392.607 467.767 392.582 467.501C392.544 467.208 392.671 466.916 392.937 466.713C392.861 466.523 395.883 464.135 396.162 463.97L396.302 463.868C396.518 463.741 396.937 463.601 397.216 463.601C397.292 463.601 397.813 462.153 398.092 460.566C398.27 459.55 398.651 458.47 398.943 457.416C399.375 455.866 399.895 454.418 400.111 453.415C400.314 452.462 400.568 451.967 400.606 451.992L402.168 452.729Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M401.685 454.253C401.965 454.418 401.99 457.2 401.901 460.007C401.812 462.814 401.609 465.646 401.431 465.875C401.406 466.116 401.241 466.358 400.962 466.51L398.905 467.615C398.854 467.64 398.498 467.844 398.435 467.869C398.13 467.996 396.099 468.961 395.794 468.898C395.489 468.987 395.159 468.974 394.829 468.961C394.816 468.961 394.804 468.961 394.791 468.961C394.575 468.961 394.131 468.783 393.966 468.695L393.09 468.161C392.836 468.009 392.671 467.793 392.633 467.551C392.594 467.285 392.696 467.018 392.925 466.827C392.836 466.624 395.54 464.452 395.845 464.274L395.972 464.186C396.162 464.071 396.569 463.932 396.81 463.932C396.873 463.932 397.419 462.598 397.686 461.175C397.864 460.248 398.257 459.283 398.549 458.343C398.994 456.959 399.527 455.688 399.73 454.812C399.933 453.974 400.187 453.555 400.225 453.58L401.685 454.253Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M401.203 455.777C401.482 455.943 401.52 458.407 401.444 460.896C401.368 463.385 401.165 465.888 400.974 466.116C400.949 466.332 400.797 466.535 400.543 466.688L398.6 467.717C398.549 467.755 398.219 467.932 398.156 467.958C397.826 468.098 395.972 468.936 395.642 468.872C395.35 468.936 395.045 468.923 394.728 468.898C394.715 468.898 394.702 468.898 394.69 468.898C394.499 468.898 394.055 468.72 393.915 468.631L393.077 468.136C392.836 467.996 392.696 467.793 392.645 467.577C392.607 467.336 392.696 467.094 392.887 466.916C392.798 466.7 395.185 464.757 395.515 464.567L395.629 464.478C395.794 464.376 396.175 464.249 396.404 464.249C396.467 464.249 397.026 463.017 397.28 461.785C397.457 460.947 397.864 460.096 398.168 459.27C398.613 458.051 399.172 456.959 399.375 456.209C399.578 455.485 399.844 455.142 399.87 455.155L401.203 455.777Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M400.721 457.301C401 457.466 401.051 459.613 400.975 461.772C400.911 463.931 400.708 466.116 400.505 466.345C400.479 466.535 400.34 466.713 400.124 466.84L398.296 467.805C398.232 467.843 397.94 467.996 397.877 468.021C397.521 468.161 395.858 468.898 395.502 468.834C395.223 468.885 394.931 468.859 394.652 468.834C394.639 468.834 394.639 468.834 394.626 468.834C394.461 468.834 394.03 468.644 393.915 468.58L393.128 468.123C392.912 467.996 392.773 467.818 392.735 467.627C392.684 467.411 392.76 467.196 392.925 467.03C392.823 466.802 394.906 465.074 395.248 464.871L395.35 464.795C395.502 464.706 395.858 464.579 396.048 464.579C396.099 464.579 396.683 463.461 396.924 462.407C397.102 461.658 397.508 460.921 397.826 460.21C398.283 459.156 398.727 458.19 399.057 457.619C399.121 456.971 399.527 456.742 399.553 456.755L400.721 457.301Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M400.238 458.813C400.517 458.978 400.581 460.794 400.517 462.636C400.454 464.478 400.276 466.332 400.048 466.548C400.022 466.713 399.895 466.866 399.705 466.98L397.991 467.882C397.927 467.92 397.673 468.059 397.597 468.085C397.216 468.237 395.731 468.86 395.35 468.783C395.096 468.822 394.817 468.783 394.55 468.745C394.537 468.745 394.537 468.745 394.525 468.745C394.385 468.745 393.953 468.555 393.864 468.504L393.128 468.072C392.938 467.958 392.811 467.805 392.76 467.628C392.709 467.437 392.76 467.247 392.887 467.094C392.785 466.853 394.537 465.341 394.918 465.126L395.007 465.062C395.134 464.986 395.477 464.859 395.629 464.859C395.667 464.859 396.277 463.843 396.505 462.979C396.683 462.319 397.102 461.696 397.419 461.087C397.889 460.197 398.334 459.41 398.664 458.965C398.715 458.432 399.134 458.28 399.159 458.292L400.238 458.813Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M399.756 460.337C400.035 460.502 400.111 462.001 400.06 463.525C400.01 465.05 399.832 466.574 399.603 466.79C399.565 466.929 399.464 467.056 399.311 467.145L397.711 467.971C397.648 468.009 397.419 468.136 397.343 468.161C396.95 468.326 395.629 468.834 395.236 468.746C394.994 468.771 394.74 468.707 394.499 468.682H394.487C394.385 468.682 393.953 468.492 393.877 468.441L393.179 468.047C393.014 467.945 392.887 467.806 392.849 467.666C392.798 467.501 392.823 467.336 392.925 467.196C392.811 466.929 394.258 465.659 394.652 465.431L394.715 465.38C394.817 465.329 395.134 465.189 395.261 465.189C395.299 465.189 396.074 464.313 396.137 463.602C396.416 463.068 396.747 462.522 397.077 462.027C397.546 461.315 398.016 460.693 398.346 460.375C398.384 459.944 398.829 459.88 398.841 459.88L399.756 460.337Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M399.26 461.861C399.54 462.026 399.629 463.207 399.591 464.401C399.553 465.595 399.375 466.815 399.134 467.018C399.095 467.132 399.007 467.234 398.88 467.31L397.394 468.072C397.318 468.11 397.127 468.212 397.051 468.25C396.632 468.428 395.49 468.821 395.071 468.733C394.842 468.745 394.613 468.669 394.385 468.644H394.372C394.296 468.644 393.864 468.44 393.814 468.415L393.166 468.059C393.014 467.97 392.912 467.856 392.861 467.729C392.811 467.589 392.811 467.45 392.874 467.323C392.76 467.043 393.89 465.989 394.296 465.748L394.347 465.71C394.423 465.672 394.728 465.545 394.817 465.545C394.842 465.545 395.642 464.782 395.693 464.249C395.972 463.804 396.315 463.373 396.645 462.992C397.127 462.445 397.597 461.988 397.94 461.81C397.978 461.493 398.423 461.493 398.435 461.506L399.26 461.861Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M398.778 463.385C399.057 463.55 399.159 464.414 399.133 465.278C399.108 466.154 398.943 467.043 398.676 467.246C398.638 467.323 398.562 467.412 398.46 467.462L397.089 468.161C397.013 468.199 396.861 468.288 396.772 468.313C396.327 468.491 395.375 468.783 394.918 468.682C394.702 468.669 394.486 468.631 394.296 468.555H394.283C394.232 468.555 393.813 468.351 393.775 468.326L393.179 467.996C393.052 467.92 392.963 467.831 392.899 467.716C392.836 467.602 392.823 467.475 392.861 467.373C392.734 467.081 393.547 466.256 393.991 466.002L394.029 465.976C394.08 465.951 394.372 465.824 394.423 465.824C394.436 465.824 395.261 465.176 395.299 464.82C395.578 464.465 395.921 464.147 396.264 463.881C396.746 463.5 397.229 463.22 397.572 463.157C397.597 462.941 398.054 463.03 398.067 463.042L398.778 463.385Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M398.296 464.91C398.575 465.075 398.702 465.608 398.676 466.167C398.664 466.726 398.461 467.247 398.219 467.488C398.169 467.539 398.118 467.59 398.054 467.64L396.797 468.263C396.721 468.314 396.594 468.364 396.505 468.402C396.036 468.593 395.261 468.758 394.791 468.669C394.588 468.644 394.398 468.593 394.22 468.517C394.194 468.517 393.776 468.314 393.763 468.301L393.217 468.009C393.115 467.945 393.026 467.869 392.976 467.793C392.912 467.704 392.887 467.602 392.887 467.513C392.76 467.209 393.255 466.599 393.712 466.332L393.737 466.319C393.763 466.307 394.029 466.18 394.068 466.18C394.08 466.18 394.931 465.634 394.944 465.456C395.236 465.202 395.578 464.986 395.934 464.821C396.429 464.605 396.924 464.491 397.267 464.567C397.28 464.465 397.762 464.63 397.762 464.63L398.296 464.91Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.144 468.44L393.23 467.97C392.62 467.628 392.696 467.018 393.395 466.611L394.537 466.053C395.236 465.646 396.29 465.608 396.899 465.951L397.813 466.421C398.423 466.764 398.346 467.374 397.648 467.78L396.505 468.339C395.807 468.745 394.753 468.796 394.144 468.44Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.521 375.989C398.41 376.484 389.294 388.906 388.113 391.814C386.932 394.723 387.77 408.478 387.77 408.478C387.77 408.478 387.554 407.945 388.849 408.504C391.338 409.571 390.766 410.485 390.766 410.485L394.575 395.802L404.25 386.772C404.25 386.759 404.631 375.493 401.521 375.989Z",
    fill: "url(#paint169_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.25 386.759C404.25 386.759 404.377 384.321 403.92 381.285C399.997 384.422 393.382 392.589 392.392 395.028C391.617 396.933 391.541 403.207 391.579 407.386L394.588 395.79L404.25 386.759Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.155 460.832C402.155 460.832 402.155 463.322 402.155 464.49C402.155 465.659 396.061 469.076 394.994 469.177C393.928 469.279 391.147 468.059 392.556 466.84C393.966 465.621 397.038 462.992 397.038 461.379C397.038 459.766 402.155 460.832 402.155 460.832Z",
    fill: "#4E0070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.165 460.668C401.165 461.468 401.228 462.649 401.228 463.284C401.228 464.453 395.947 467.997 394.88 468.098C394.258 468.149 392.747 467.412 392.595 466.803C392.582 466.815 392.557 466.828 392.544 466.841C391.135 468.06 393.915 469.279 394.982 469.178C396.048 469.076 402.143 465.672 402.143 464.491C402.143 463.322 402.143 460.833 402.143 460.833C402.143 460.833 401.749 460.757 401.165 460.668Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.796 449.605C383.796 449.605 384.672 452.755 385.142 453.911C385.599 455.066 380.558 457.899 378.743 458.686C376.94 459.474 373.829 457.848 375.175 456.883C376.521 455.905 379.39 453.504 379.162 451.79C378.933 450.062 383.796 449.605 383.796 449.605Z",
    fill: "#4E0070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.142 453.911C384.685 452.755 383.796 449.605 383.796 449.605C383.796 449.605 383.377 449.643 382.793 449.745C383.06 450.57 383.555 452.45 383.656 453.276C383.809 454.546 379.657 456.857 378.006 457.581C377.041 458 375.67 457.67 374.947 457.15C374.388 458.115 377.105 459.41 378.756 458.686C380.558 457.899 385.612 455.066 385.142 453.911Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.854 405.748C398.854 405.748 386.259 410.663 378.933 414.74C371.607 418.817 369.614 421.015 369.588 423.949C369.55 427.645 378.933 452.653 378.933 452.653C378.933 452.653 380.355 453.212 381.904 452.653C385.256 451.447 384.494 450.431 384.494 450.431L380.609 426.514L412.757 415.667L398.854 405.748Z",
    fill: "url(#paint170_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.31 411.781L405.736 410.65L379.987 424.393C378.832 425.003 378.222 426.298 378.463 427.581L383.174 452.094C385.015 451.142 384.482 450.418 384.482 450.418L380.596 426.501L405.977 417.941L407.31 411.781Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.901 408.745C405.901 408.745 395.858 425.752 394.639 428.952C393.166 432.826 396.569 461.963 396.569 461.963C396.569 461.963 397.623 462.941 399.883 463.017C402.13 463.106 402.803 462.268 402.803 462.268C402.803 462.268 404.949 434.732 405.228 433.157C405.507 431.582 415.918 425.803 418.813 423.275C424.197 418.55 420.197 405.76 420.197 405.76L405.901 408.745Z",
    fill: "url(#paint171_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.095 378.744C399.019 382.161 397.75 406.497 397.75 406.497C397.75 406.497 400.454 410.167 406.459 411.78C413.176 413.597 421.353 410.65 421.353 410.65C421.353 410.65 421.162 401.416 421.099 395.015C421.048 388.766 421.645 384.193 421.251 381.513C421.023 380.015 417.772 378.008 412.77 375.76C407.767 373.486 399.184 375.074 399.095 378.744Z",
    fill: "url(#paint172_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.093 378.897C415.093 381.564 408.263 384.371 408.263 384.371C408.263 384.371 404.873 381.615 404.873 378.897C404.873 377.271 407.158 375.963 409.977 375.963C412.808 375.95 415.093 377.271 415.093 378.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.113 407.157C388.113 407.157 387.034 409.38 386.665 410.142C386.31 410.904 386.373 414.448 387.44 415.235C388.506 416.023 390.754 413.152 390.754 413.152L391.185 408.186L388.113 407.157Z",
    fill: "#FFD4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.418 371.67C405.253 370.616 406.561 369.511 408.364 369.194C410.167 368.876 411.779 369.473 411.983 370.514L413.938 378.11C414.154 379.38 412.579 380.714 410.396 381.095C408.224 381.476 406.282 380.752 406.053 379.494L405.418 371.67Z",
    fill: "#FFD4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.284 374.337C411.602 373.182 411.741 371.429 411.513 369.778C410.878 369.219 409.672 368.965 408.364 369.193C406.561 369.511 405.241 370.616 405.418 371.67C405.418 371.67 406.053 379.494 406.066 379.494C406.117 379.774 406.256 380.015 406.46 380.243C408.783 379.24 410.726 376.357 411.284 374.337Z",
    fill: "#F1D5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.676 366.361C401.203 369.308 402.879 378.757 405.876 378.681C408.872 378.618 411.589 374.871 412.275 372.419C412.96 369.968 412.821 364.862 410.167 363.706C407.501 362.551 404.174 363.376 402.676 366.361Z",
    fill: "#FFD4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.959 408.872L416.465 411.578C416.465 420.888 413.709 421.84 407.793 426.4C403.146 429.969 402.498 431.061 402.498 436.561C402.498 441.044 401.94 457.086 401.724 462.84C402.511 462.611 402.79 462.281 402.79 462.281C402.79 462.281 404.936 434.745 405.215 433.17C405.495 431.595 415.906 425.816 418.801 423.288C422.508 420.024 421.784 412.975 420.959 408.872Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.073 365.878C399.527 367.872 401.089 369.765 404.631 369.485C408.173 369.219 409.735 368.393 409.735 368.393C409.735 368.393 409.875 371.251 410.281 371.327C410.687 371.391 410.967 369.219 411.843 369.562C412.732 369.905 412.021 373.016 412.77 373.55C413.519 374.096 413.811 372.28 413.811 370.095C413.811 367.911 414.293 362.36 409.456 362.017C404.644 361.687 400.53 364.227 400.073 365.878Z",
    fill: "url(#paint173_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.505 426.997L379.263 414.727C378.895 414.511 378.705 414.219 378.692 413.927V412.873C378.705 412.505 378.971 413.14 379.492 412.847L391.554 405.887C392.519 405.328 393.991 405.265 394.829 405.747L416.071 418.017C416.35 418.182 416.553 417.496 416.629 417.712C416.655 417.788 416.642 418.754 416.642 418.817C416.655 419.198 416.376 419.592 415.842 419.897L403.78 426.857C402.815 427.416 401.343 427.479 400.505 426.997Z",
    fill: "#2D3259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.504 425.955L379.263 413.686C378.425 413.203 378.526 412.352 379.504 411.793L391.566 404.833C392.531 404.274 394.004 404.21 394.842 404.693L416.083 416.963C416.921 417.445 416.82 418.296 415.842 418.855L403.78 425.815C402.815 426.387 401.342 426.438 400.504 425.955Z",
    fill: "#858FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.927 425.866C401.444 425.866 401.025 425.765 400.721 425.6L379.479 413.33C379.352 413.254 379.124 413.089 379.124 412.873C379.124 412.644 379.339 412.39 379.708 412.174L391.769 405.214C392.214 404.96 392.811 404.808 393.407 404.808C393.89 404.808 394.309 404.909 394.613 405.074L415.855 417.344C415.982 417.42 416.211 417.585 416.211 417.801C416.211 418.03 415.995 418.284 415.626 418.5L403.565 425.46C403.12 425.714 402.524 425.866 401.927 425.866Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.559 423.046L384.304 413.089C383.961 412.885 383.999 412.542 384.405 412.314L390.881 408.58C391.274 408.351 391.884 408.326 392.227 408.529L409.481 418.487C409.824 418.69 409.786 419.033 409.38 419.261L402.904 423.008C402.511 423.224 401.914 423.25 401.559 423.046Z",
    fill: "#858FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.262 409.291L392.366 409.926C392.506 410.002 392.734 410.002 392.874 409.926C393.014 409.85 393.014 409.71 392.874 409.634L391.769 408.999C391.63 408.923 391.401 408.923 391.262 408.999C391.122 409.075 391.122 409.215 391.262 409.291ZM393.153 410.383L393.674 410.688C393.814 410.764 394.042 410.764 394.182 410.688C394.321 410.612 394.321 410.472 394.182 410.396L393.661 410.091C393.522 410.015 393.293 410.015 393.153 410.091C393.014 410.18 393.014 410.307 393.153 410.383ZM394.461 411.145L394.982 411.45C395.121 411.526 395.35 411.526 395.49 411.45C395.629 411.374 395.629 411.234 395.49 411.158L394.969 410.853C394.829 410.777 394.601 410.777 394.461 410.853C394.321 410.929 394.321 411.056 394.461 411.145ZM395.782 411.895L396.302 412.199C396.442 412.276 396.67 412.276 396.81 412.199C396.95 412.123 396.95 411.984 396.81 411.907L396.289 411.603C396.15 411.526 395.921 411.526 395.782 411.603C395.642 411.691 395.642 411.818 395.782 411.895ZM397.089 412.657L397.61 412.962C397.75 413.038 397.978 413.038 398.118 412.962C398.257 412.885 398.257 412.746 398.118 412.669L397.597 412.365C397.458 412.288 397.229 412.288 397.089 412.365C396.95 412.441 396.95 412.581 397.089 412.657ZM398.397 413.419L398.918 413.724C399.057 413.8 399.286 413.8 399.426 413.724C399.565 413.647 399.565 413.508 399.426 413.432L398.905 413.127C398.765 413.05 398.537 413.05 398.397 413.127C398.257 413.203 398.257 413.33 398.397 413.419ZM399.705 414.168L400.225 414.473C400.365 414.549 400.594 414.549 400.733 414.473C400.873 414.397 400.873 414.257 400.733 414.181L400.213 413.876C400.073 413.8 399.845 413.8 399.705 413.876C399.565 413.965 399.565 414.092 399.705 414.168ZM401.025 414.93L401.546 415.235C401.686 415.311 401.914 415.311 402.054 415.235C402.193 415.159 402.193 415.019 402.054 414.943L401.533 414.638C401.394 414.562 401.165 414.562 401.025 414.638C400.886 414.714 400.886 414.854 401.025 414.93ZM402.333 415.692L402.854 415.997C402.993 416.073 403.222 416.073 403.361 415.997C403.501 415.921 403.501 415.781 403.361 415.705L402.841 415.4C402.701 415.324 402.473 415.324 402.333 415.4C402.193 415.476 402.193 415.603 402.333 415.692ZM403.641 416.442L404.161 416.747C404.301 416.823 404.53 416.823 404.669 416.747C404.809 416.67 404.809 416.531 404.669 416.454L404.149 416.15C404.009 416.073 403.78 416.073 403.641 416.15C403.501 416.226 403.501 416.366 403.641 416.442ZM404.949 417.204L405.469 417.509C405.609 417.585 405.837 417.585 405.977 417.509C406.117 417.432 406.117 417.293 405.977 417.216L405.456 416.912C405.317 416.835 405.088 416.835 404.949 416.912C404.809 416.988 404.809 417.115 404.949 417.204ZM406.269 417.953L406.79 418.258C406.929 418.334 407.158 418.334 407.297 418.258C407.437 418.182 407.437 418.042 407.297 417.966L406.777 417.661C406.637 417.585 406.409 417.585 406.269 417.661C406.129 417.75 406.129 417.877 406.269 417.953ZM407.602 418.728L408.123 419.033C408.262 419.109 408.491 419.109 408.631 419.033C408.77 418.957 408.77 418.817 408.631 418.741L408.11 418.436C407.97 418.36 407.742 418.36 407.602 418.436C407.463 418.512 407.463 418.652 407.602 418.728ZM390.081 410.015L390.538 410.282C390.703 410.371 390.957 410.371 391.109 410.282L391.554 410.028C391.719 409.939 391.706 409.786 391.554 409.697L391.097 409.431C390.931 409.342 390.678 409.342 390.525 409.431L390.081 409.685C389.928 409.774 389.928 409.926 390.081 410.015ZM392.43 411.031L392.874 410.777C393.039 410.688 393.026 410.536 392.874 410.447L392.417 410.18C392.252 410.091 391.998 410.091 391.846 410.18L391.401 410.434C391.236 410.523 391.249 410.675 391.401 410.764L391.858 411.031C392.011 411.133 392.265 411.133 392.43 411.031ZM392.709 411.526L393.166 411.793C393.331 411.882 393.585 411.882 393.737 411.793L394.182 411.539C394.347 411.45 394.334 411.298 394.182 411.209L393.725 410.942C393.56 410.853 393.306 410.853 393.153 410.942L392.709 411.196C392.544 411.285 392.544 411.437 392.709 411.526ZM394.017 412.288L394.474 412.555C394.639 412.644 394.893 412.644 395.045 412.555L395.49 412.301C395.655 412.212 395.642 412.06 395.49 411.971L395.032 411.704C394.867 411.615 394.613 411.615 394.461 411.704L394.017 411.958C393.852 412.047 393.852 412.2 394.017 412.288ZM396.81 412.708L396.353 412.441C396.188 412.352 395.934 412.352 395.782 412.441L395.337 412.695C395.172 412.784 395.185 412.936 395.337 413.025L395.794 413.292C395.959 413.381 396.213 413.381 396.366 413.292L396.81 413.038C396.962 412.949 396.962 412.809 396.81 412.708ZM398.118 413.47L397.661 413.203C397.496 413.114 397.242 413.114 397.089 413.203L396.645 413.457C396.48 413.546 396.493 413.698 396.645 413.787L397.102 414.054C397.267 414.143 397.521 414.143 397.673 414.054L398.118 413.8C398.283 413.711 398.283 413.559 398.118 413.47ZM399.426 414.232L398.968 413.965C398.803 413.876 398.549 413.876 398.397 413.965L397.953 414.219C397.788 414.308 397.8 414.46 397.953 414.549L398.41 414.816C398.575 414.905 398.829 414.905 398.981 414.816L399.426 414.562C399.591 414.473 399.591 414.321 399.426 414.232ZM400.746 414.981L400.289 414.714C400.124 414.625 399.87 414.625 399.718 414.714L399.273 414.968C399.108 415.057 399.121 415.21 399.273 415.299L399.73 415.565C399.895 415.654 400.149 415.654 400.302 415.565L400.746 415.311C400.898 415.222 400.898 415.083 400.746 414.981ZM402.054 415.743L401.597 415.476C401.432 415.388 401.178 415.388 401.025 415.476L400.581 415.73C400.416 415.819 400.429 415.972 400.581 416.061L401.038 416.327C401.203 416.416 401.457 416.416 401.609 416.327L402.054 416.073C402.206 415.984 402.206 415.832 402.054 415.743ZM403.361 416.493L402.904 416.226C402.739 416.137 402.485 416.137 402.333 416.226L401.889 416.48C401.724 416.569 401.736 416.721 401.889 416.81L402.346 417.077C402.511 417.166 402.765 417.166 402.917 417.077L403.361 416.823C403.527 416.734 403.527 416.594 403.361 416.493ZM403.196 417.585L403.654 417.852C403.819 417.94 404.073 417.94 404.225 417.852L404.669 417.598C404.834 417.509 404.822 417.356 404.669 417.267L404.212 417.001C404.047 416.912 403.793 416.912 403.641 417.001L403.196 417.255C403.031 417.343 403.031 417.496 403.196 417.585ZM405.99 418.017L405.533 417.75C405.368 417.661 405.114 417.661 404.961 417.75L404.517 418.004C404.352 418.093 404.365 418.245 404.517 418.334L404.974 418.601C405.139 418.69 405.393 418.69 405.545 418.601L405.99 418.347C406.142 418.258 406.142 418.106 405.99 418.017ZM407.907 419.122L406.866 418.525C406.701 418.436 406.447 418.436 406.294 418.525L405.85 418.779C405.685 418.868 405.698 419.02 405.85 419.109L406.891 419.706C407.056 419.795 407.31 419.795 407.463 419.706L407.907 419.452C408.059 419.363 408.059 419.211 407.907 419.122ZM388.875 410.713L389.916 411.31C390.081 411.399 390.335 411.399 390.487 411.31L390.931 411.056C391.097 410.967 391.084 410.815 390.931 410.726L389.89 410.129C389.725 410.04 389.471 410.04 389.319 410.129L388.875 410.383C388.71 410.472 388.71 410.625 388.875 410.713ZM390.766 411.806L391.223 412.072C391.389 412.161 391.642 412.161 391.795 412.072L392.239 411.818C392.404 411.73 392.392 411.577 392.239 411.488L391.782 411.221C391.617 411.133 391.363 411.133 391.211 411.221L390.766 411.476C390.601 411.564 390.601 411.717 390.766 411.806ZM392.531 412.835C392.696 412.923 392.95 412.923 393.103 412.835L393.547 412.581C393.712 412.492 393.699 412.339 393.547 412.25L393.09 411.984C392.925 411.895 392.671 411.895 392.519 411.984L392.074 412.238C391.909 412.327 391.922 412.479 392.074 412.568L392.531 412.835ZM393.839 413.584C394.004 413.673 394.258 413.673 394.41 413.584L394.855 413.33C395.02 413.241 395.007 413.089 394.855 413L394.398 412.733C394.233 412.644 393.979 412.644 393.826 412.733L393.382 412.987C393.217 413.076 393.23 413.228 393.382 413.317L393.839 413.584ZM395.147 413.482L394.702 413.736C394.537 413.825 394.55 413.978 394.702 414.067L395.159 414.333C395.325 414.422 395.578 414.422 395.731 414.333L396.175 414.079C396.34 413.99 396.328 413.838 396.175 413.749L395.718 413.482C395.566 413.393 395.299 413.393 395.147 413.482ZM396.48 414.232L395.972 414.524C395.832 414.613 395.832 414.74 395.972 414.829L396.48 415.121C396.62 415.21 396.861 415.21 397 415.121L397.508 414.829C397.648 414.74 397.648 414.613 397.508 414.524L397 414.232C396.861 414.143 396.632 414.143 396.48 414.232ZM397.788 414.981L397.28 415.273C397.14 415.362 397.14 415.489 397.28 415.578L397.788 415.87C397.927 415.959 398.169 415.959 398.308 415.87L398.816 415.578C398.956 415.489 398.956 415.362 398.816 415.273L398.308 414.981C398.169 414.905 397.94 414.905 397.788 414.981ZM399.108 415.743L398.6 416.035C398.461 416.124 398.461 416.251 398.6 416.34L399.108 416.632C399.248 416.721 399.489 416.721 399.629 416.632L400.137 416.34C400.276 416.251 400.276 416.124 400.137 416.035L399.629 415.743C399.476 415.654 399.248 415.654 399.108 415.743ZM400.416 416.505L399.908 416.797C399.768 416.886 399.768 417.013 399.908 417.102L400.416 417.394C400.556 417.483 400.797 417.483 400.936 417.394L401.444 417.102C401.584 417.013 401.584 416.886 401.444 416.797L400.936 416.505C400.797 416.416 400.556 416.416 400.416 416.505ZM401.724 417.255L401.216 417.547C401.076 417.636 401.076 417.763 401.216 417.852L401.724 418.144C401.863 418.233 402.105 418.233 402.244 418.144L402.752 417.852C402.892 417.763 402.892 417.636 402.752 417.547L402.244 417.255C402.105 417.178 401.876 417.178 401.724 417.255ZM403.565 418.906L404.073 418.614C404.212 418.525 404.212 418.398 404.073 418.309L403.565 418.017C403.425 417.928 403.184 417.928 403.044 418.017L402.536 418.309C402.397 418.398 402.397 418.525 402.536 418.614L403.044 418.906C403.184 418.982 403.425 418.982 403.565 418.906ZM404.872 419.655L405.38 419.363C405.52 419.274 405.52 419.147 405.38 419.058L404.872 418.766C404.733 418.677 404.492 418.677 404.352 418.766L403.844 419.058C403.704 419.147 403.704 419.274 403.844 419.363L404.352 419.655C404.492 419.744 404.733 419.744 404.872 419.655ZM406.713 419.833L406.206 419.541C406.066 419.452 405.825 419.452 405.685 419.541L405.177 419.833C405.037 419.922 405.037 420.049 405.177 420.138L405.685 420.43C405.825 420.519 406.066 420.519 406.206 420.43L406.713 420.138C406.866 420.062 406.866 419.922 406.713 419.833ZM387.63 411.399L389.268 412.352C389.408 412.441 389.649 412.441 389.789 412.352L390.297 412.06C390.436 411.971 390.436 411.844 390.297 411.755L388.659 410.802C388.519 410.713 388.278 410.713 388.138 410.802L387.63 411.094C387.478 411.183 387.478 411.323 387.63 411.399ZM390.068 412.809L390.576 413.101C390.716 413.19 390.957 413.19 391.097 413.101L391.604 412.809C391.744 412.72 391.744 412.593 391.604 412.504L391.097 412.212C390.957 412.123 390.716 412.123 390.576 412.212L390.068 412.504C389.928 412.593 389.928 412.733 390.068 412.809ZM391.389 413.571L391.896 413.863C392.036 413.952 392.277 413.952 392.417 413.863L392.925 413.571C393.065 413.482 393.065 413.355 392.925 413.266L392.417 412.974C392.277 412.885 392.036 412.885 391.896 412.974L391.389 413.266C391.236 413.355 391.236 413.482 391.389 413.571ZM392.696 414.333L393.204 414.625C393.344 414.714 393.585 414.714 393.725 414.625L394.233 414.333C394.372 414.244 394.372 414.117 394.233 414.028L393.725 413.736C393.585 413.647 393.344 413.647 393.204 413.736L392.696 414.028C392.544 414.105 392.557 414.244 392.696 414.333ZM395.032 415.375L395.54 415.083C395.68 414.994 395.68 414.867 395.54 414.778L395.032 414.486C394.893 414.397 394.652 414.397 394.512 414.486L394.004 414.778C393.864 414.867 393.864 414.994 394.004 415.083L394.512 415.375C394.664 415.464 394.893 415.464 395.032 415.375ZM396.353 416.137L396.861 415.845C397 415.756 397 415.629 396.861 415.54L396.353 415.248C396.213 415.159 395.972 415.159 395.832 415.248L395.325 415.54C395.185 415.629 395.185 415.756 395.325 415.845L395.832 416.137C395.972 416.226 396.201 416.226 396.353 416.137ZM397.661 416.899L398.169 416.607C398.308 416.518 398.308 416.391 398.169 416.302L397.661 416.01C397.521 415.921 397.28 415.921 397.14 416.01L396.632 416.302C396.493 416.391 396.493 416.518 396.632 416.607L397.14 416.899C397.28 416.975 397.521 416.975 397.661 416.899ZM398.968 417.648L399.476 417.356C399.616 417.267 399.616 417.14 399.476 417.051L398.968 416.759C398.829 416.67 398.588 416.67 398.448 416.759L397.94 417.051C397.8 417.14 397.8 417.267 397.94 417.356L398.448 417.648C398.588 417.737 398.829 417.737 398.968 417.648ZM400.276 418.41L400.784 418.118C400.924 418.029 400.924 417.902 400.784 417.813L400.276 417.521C400.137 417.432 399.895 417.432 399.756 417.521L399.248 417.813C399.108 417.902 399.108 418.029 399.248 418.118L399.756 418.41C399.908 418.487 400.137 418.487 400.276 418.41ZM401.597 419.16L402.105 418.868C402.244 418.779 402.244 418.652 402.105 418.563L401.597 418.271C401.457 418.182 401.216 418.182 401.076 418.271L400.568 418.563C400.429 418.652 400.429 418.779 400.568 418.868L401.076 419.16C401.216 419.249 401.444 419.249 401.597 419.16ZM401.876 419.63L402.384 419.922C402.524 420.011 402.765 420.011 402.904 419.922L403.412 419.63C403.552 419.541 403.552 419.414 403.412 419.325L402.904 419.033C402.765 418.944 402.524 418.944 402.384 419.033L401.876 419.325C401.724 419.414 401.724 419.541 401.876 419.63ZM405.507 420.544L404.212 419.795C404.073 419.706 403.831 419.706 403.692 419.795L403.184 420.087C403.044 420.176 403.044 420.303 403.184 420.392L404.479 421.141C404.618 421.23 404.86 421.23 404.999 421.141L405.507 420.849C405.647 420.76 405.647 420.62 405.507 420.544ZM386.424 412.136L388.76 413.482C388.925 413.571 389.192 413.571 389.344 413.482L389.789 413.228C389.954 413.139 389.954 412.987 389.789 412.885L387.453 411.539C387.288 411.45 387.021 411.45 386.869 411.539L386.424 411.793C386.259 411.895 386.259 412.047 386.424 412.136ZM389.624 413.99L390.068 414.244C390.233 414.333 390.5 414.333 390.652 414.244L391.097 413.99C391.262 413.901 391.262 413.749 391.097 413.647L390.652 413.393C390.487 413.305 390.22 413.305 390.068 413.393L389.624 413.647C389.459 413.736 389.459 413.889 389.624 413.99ZM390.931 414.74L391.376 414.994C391.541 415.083 391.808 415.083 391.96 414.994L392.404 414.74C392.569 414.651 392.569 414.498 392.404 414.397L391.96 414.143C391.795 414.054 391.528 414.054 391.376 414.143L390.931 414.397C390.766 414.498 390.766 414.651 390.931 414.74ZM392.239 415.502L392.684 415.756C392.849 415.845 393.115 415.845 393.268 415.756L393.712 415.502C393.877 415.413 393.877 415.26 393.712 415.159L393.268 414.905C393.103 414.816 392.836 414.816 392.684 414.905L392.239 415.159C392.074 415.26 392.074 415.413 392.239 415.502ZM393.56 416.264L394.004 416.518C394.169 416.607 394.436 416.607 394.588 416.518L395.032 416.264C395.198 416.175 395.198 416.023 395.032 415.921L394.588 415.667C394.423 415.578 394.156 415.578 394.004 415.667L393.56 415.921C393.395 416.01 393.395 416.162 393.56 416.264ZM394.867 417.013L395.312 417.267C395.477 417.356 395.743 417.356 395.896 417.267L396.34 417.013C396.505 416.924 396.505 416.772 396.34 416.67L395.896 416.416C395.731 416.327 395.464 416.327 395.312 416.416L394.867 416.67C394.702 416.772 394.702 416.924 394.867 417.013ZM396.175 417.775L396.62 418.029C396.785 418.118 397.051 418.118 397.204 418.029L397.648 417.775C397.813 417.686 397.813 417.534 397.648 417.432L397.204 417.178C397.039 417.089 396.772 417.089 396.62 417.178L396.175 417.432C396.01 417.521 396.01 417.674 396.175 417.775ZM397.483 418.525L397.927 418.779C398.092 418.868 398.359 418.868 398.511 418.779L398.956 418.525C399.121 418.436 399.121 418.283 398.956 418.182L398.511 417.928C398.346 417.839 398.08 417.839 397.927 417.928L397.483 418.182C397.318 418.283 397.318 418.436 397.483 418.525ZM398.803 419.287L399.248 419.541C399.413 419.63 399.679 419.63 399.832 419.541L400.276 419.287C400.441 419.198 400.441 419.045 400.276 418.944L399.832 418.69C399.667 418.601 399.4 418.601 399.248 418.69L398.803 418.944C398.638 419.045 398.638 419.198 398.803 419.287ZM400.111 420.049L400.556 420.303C400.721 420.392 400.987 420.392 401.14 420.303L401.584 420.049C401.749 419.96 401.749 419.808 401.584 419.706L401.14 419.452C400.975 419.363 400.708 419.363 400.556 419.452L400.111 419.706C399.946 419.795 399.946 419.947 400.111 420.049ZM401.419 420.798L401.863 421.052C402.028 421.141 402.295 421.141 402.447 421.052L402.892 420.798C403.057 420.709 403.057 420.557 402.892 420.455L402.447 420.201C402.282 420.112 402.016 420.112 401.863 420.201L401.419 420.455C401.254 420.557 401.254 420.709 401.419 420.798ZM404.225 421.243L403.78 420.989C403.615 420.9 403.349 420.9 403.196 420.989L402.752 421.243C402.587 421.332 402.587 421.484 402.752 421.586L403.196 421.84C403.361 421.929 403.628 421.929 403.78 421.84L404.225 421.586C404.39 421.484 404.39 421.332 404.225 421.243ZM387.249 412.835L386.221 412.238C386.056 412.149 385.789 412.149 385.637 412.238L385.193 412.492C385.027 412.581 385.027 412.733 385.193 412.835L386.221 413.432C386.386 413.52 386.653 413.52 386.805 413.432L387.249 413.178C387.414 413.089 387.414 412.936 387.249 412.835ZM388.57 413.597L388.125 413.343C387.96 413.254 387.694 413.254 387.541 413.343L387.097 413.597C386.932 413.686 386.932 413.838 387.097 413.94L387.541 414.194C387.707 414.283 387.973 414.283 388.125 414.194L388.57 413.94C388.735 413.838 388.735 413.686 388.57 413.597ZM389.878 414.359L389.433 414.105C389.268 414.016 389.002 414.016 388.849 414.105L388.405 414.359C388.24 414.448 388.24 414.6 388.405 414.702L388.849 414.956C389.014 415.045 389.281 415.045 389.433 414.956L389.878 414.702C390.043 414.6 390.043 414.448 389.878 414.359ZM399.057 419.655L390.754 414.854C390.589 414.765 390.322 414.765 390.17 414.854L389.725 415.108C389.56 415.197 389.56 415.349 389.725 415.451L398.029 420.252C398.194 420.341 398.461 420.341 398.613 420.252L399.057 419.998C399.222 419.896 399.21 419.744 399.057 419.655ZM400.365 420.405L399.921 420.15C399.756 420.062 399.489 420.062 399.337 420.15L398.892 420.405C398.727 420.493 398.727 420.646 398.892 420.747L399.337 421.001C399.502 421.09 399.768 421.09 399.921 421.001L400.365 420.747C400.53 420.659 400.53 420.506 400.365 420.405ZM401.673 421.167L401.228 420.913C401.063 420.824 400.797 420.824 400.644 420.913L400.2 421.167C400.035 421.255 400.035 421.408 400.2 421.51L400.644 421.764C400.809 421.852 401.076 421.852 401.228 421.764L401.673 421.51C401.838 421.408 401.838 421.255 401.673 421.167ZM403.006 421.941L402.562 421.687C402.397 421.598 402.13 421.598 401.978 421.687L401.533 421.941C401.368 422.03 401.368 422.183 401.533 422.284L401.978 422.538C402.143 422.627 402.409 422.627 402.562 422.538L403.006 422.284C403.171 422.183 403.171 422.03 403.006 421.941Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.67 425.917L379.67 413.889C378.857 413.419 378.083 412.149 377.943 411.032L375.823 394.164C375.683 393.059 376.229 392.526 377.041 392.996L398.042 405.024C398.854 405.494 399.629 406.764 399.769 407.882L401.889 424.749C402.029 425.854 401.483 426.387 400.67 425.917Z",
    fill: "#858FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.397 404.795L377.397 392.767C377.08 392.589 376.8 392.551 376.584 392.652C376.559 392.665 376.204 392.894 376.178 392.919C376.394 392.792 376.686 392.805 377.042 393.008L398.042 405.036C398.854 405.506 399.629 406.776 399.769 407.894L401.889 424.761C401.978 425.46 401.8 425.917 401.445 426.057C401.47 426.057 401.508 426.044 401.559 426.006C401.571 425.993 401.952 425.726 401.965 425.714C402.194 425.51 402.308 425.091 402.232 424.52L400.111 407.653C399.984 406.535 399.21 405.252 398.397 404.795Z",
    fill: "#2D3259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.234 412.924C411.234 412.924 410.51 413.394 409.456 413.559C408.39 413.724 407.844 413.33 406.371 413.698C404.86 414.079 403.108 416.518 404.377 417.534C405.266 418.233 406.815 417.382 408.059 417.204C408.605 417.128 409.685 417.267 410.231 417.242C412.046 417.179 413.659 414.943 413.659 414.943L411.234 412.924Z",
    fill: "#FFD4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.392 412.276C415.334 412.797 421.353 410.638 421.353 410.638C421.353 410.638 421.162 401.404 421.099 395.003C421.048 389.274 421.543 384.994 421.327 382.238L416.439 385.896C416.439 391.637 416.883 399.816 416.883 403.576C416.883 405.837 411.779 411.717 409.392 412.276Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.61 380.193C420.438 379.354 423.194 382.199 425.035 388.194C426.863 394.202 431.789 401.48 430.862 403.982C429.936 406.484 412.706 416.302 412.706 416.302C412.706 416.302 412.516 415.375 411.589 414.257C410.662 413.14 410.23 413.14 410.23 413.14L422.8 401.747C422.8 401.747 417.95 395.307 415.83 389.503C413.938 384.346 415.525 381.602 418.61 380.193Z",
    fill: "url(#paint174_linear_1_2)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 283.195,
    y1: 392.56,
    x2: 438.387,
    y2: 392.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5905,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7024,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 373.636,
    y1: 342.17,
    x2: 324.987,
    y2: 416.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 379.171,
    y1: 350.286,
    x2: 361.586,
    y2: 384.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#4D5A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2483,
    stopColor: "#6A75A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    stopColor: "#979FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4813,
    stopColor: "#BDC2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5972,
    stopColor: "#DADCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#EEF0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9343,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 94.6534,
    y1: 214.171,
    x2: 588.52,
    y2: 322.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2",
    x1: 270.545,
    y1: 131.337,
    x2: 472.702,
    y2: 435.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2",
    x1: 322.345,
    y1: 85.755,
    x2: 491.363,
    y2: 424.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2",
    x1: 322.275,
    y1: 85.8137,
    x2: 491.284,
    y2: 424.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B9BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#B3B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2",
    x1: 322.205,
    y1: 85.8733,
    x2: 491.204,
    y2: 424.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#B7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2",
    x1: 322.135,
    y1: 85.9319,
    x2: 491.124,
    y2: 424.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BCC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7BDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2",
    x1: 322.065,
    y1: 85.9907,
    x2: 491.044,
    y2: 424.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C1C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#BEC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2",
    x1: 321.995,
    y1: 86.0499,
    x2: 490.965,
    y2: 424.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BFC4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C2C8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#C2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_2",
    x1: 321.925,
    y1: 86.1086,
    x2: 490.885,
    y2: 424.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C4C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#C6CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_2",
    x1: 321.855,
    y1: 86.1676,
    x2: 490.805,
    y2: 424.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C2C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C6CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#CACEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#B6BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_2",
    x1: 321.785,
    y1: 86.2268,
    x2: 490.725,
    y2: 424.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C3C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#CDD2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6644,
    stopColor: "#B9C0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9836,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_2",
    x1: 321.715,
    y1: 86.2855,
    x2: 490.646,
    y2: 424.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C5CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#D0D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D1D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#BDC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9797,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_2",
    x1: 321.645,
    y1: 86.3441,
    x2: 490.566,
    y2: 424.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C8CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5228,
    stopColor: "#D3D7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D5D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6403,
    stopColor: "#C1C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9763,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_2",
    x1: 321.575,
    y1: 86.4037,
    x2: 490.486,
    y2: 424.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#D5D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D9DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6316,
    stopColor: "#C5CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9704,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_2",
    x1: 321.505,
    y1: 86.4622,
    x2: 490.406,
    y2: 424.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CACFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CED3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#D8DCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#DDE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#C9CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9679,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_2",
    x1: 321.435,
    y1: 86.5209,
    x2: 490.326,
    y2: 424.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D0D4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#DADEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E1E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6182,
    stopColor: "#CDD1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9656,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_2",
    x1: 321.365,
    y1: 86.58,
    x2: 490.247,
    y2: 424.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D1D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D2D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#DDE1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E4E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6142,
    stopColor: "#D0D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_2",
    x1: 321.295,
    y1: 86.6385,
    x2: 490.167,
    y2: 424.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CFD3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D5DAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4993,
    stopColor: "#E0E3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E8EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    stopColor: "#D4D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9597,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_2",
    x1: 321.225,
    y1: 86.6974,
    x2: 490.087,
    y2: 424.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#E2E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6051,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_2",
    x1: 321.154,
    y1: 86.7565,
    x2: 490.007,
    y2: 424.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D2D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D6DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#E5E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F0F1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6013,
    stopColor: "#DCDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9566,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_2",
    x1: 321.084,
    y1: 86.8149,
    x2: 489.928,
    y2: 424.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D8DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DCE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4882,
    stopColor: "#E7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#E0E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_2",
    x1: 321.014,
    y1: 86.8737,
    x2: 489.848,
    y2: 425.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4882,
    stopColor: "#EAEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5957,
    stopColor: "#E3E6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7185,
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9526,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_2",
    x1: 320.944,
    y1: 86.9324,
    x2: 489.768,
    y2: 425.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D6DBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#E1E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#ECEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#E7EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7101,
    stopColor: "#B5BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9514,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_2",
    x1: 320.874,
    y1: 86.9905,
    x2: 489.688,
    y2: 425.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5905,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7024,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_2",
    x1: 183.591,
    y1: 183.822,
    x2: 225.959,
    y2: 328.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2437,
    stopColor: "#D9EE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#A7F361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#84EA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    stopColor: "#4CDB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7424,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189.221 240.128) scale(47.4259 47.4429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_2",
    x1: 148.028,
    y1: 224.338,
    x2: 207.312,
    y2: 336.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2437,
    stopColor: "#D9EE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#A7F361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#84EA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    stopColor: "#4CDB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7424,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.121 273.428) scale(38.2137 38.2274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_2",
    x1: 112.199,
    y1: 231.106,
    x2: 179.952,
    y2: 351.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2437,
    stopColor: "#D9EE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#A7F361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#84EA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    stopColor: "#4CDB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7424,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.509 305.99) scale(29.452 29.4626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_2",
    x1: 143.517,
    y1: 353.239,
    x2: 130.632,
    y2: 375.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_2",
    x1: 86.2663,
    y1: 239.671,
    x2: 150.21,
    y2: 367.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2437,
    stopColor: "#D9EE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#A7F361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#84EA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    stopColor: "#4CDB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7424,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.177 340.14) scale(21.4934 21.5012)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.288 438.44) scale(63.9645 42.027)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4192,
    stopColor: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5543,
    stopColor: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6482,
    stopColor: "#E9EBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#DADDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7727,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8414,
    stopColor: "#D8DCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9589,
    stopColor: "#F4F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_2",
    x1: 258.048,
    y1: 407.348,
    x2: 125.453,
    y2: 407.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2475,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9464,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.838 411.005) scale(65.8741 65.8978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B0FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.838 411.005) scale(65.8741 65.8978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6034,
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7613,
    stopColor: "#E0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    stopColor: "#BEE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4DDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_2",
    x1: 162.699,
    y1: 306.933,
    x2: 205.685,
    y2: 466.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9546,
    stopColor: "#F5F4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_2",
    x1: 160.705,
    y1: 443.152,
    x2: 162.293,
    y2: 400.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1_2",
    x1: 239.138,
    y1: 422.103,
    x2: 208.656,
    y2: 449.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#836DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_2",
    x1: 224.715,
    y1: 403.665,
    x2: 237.736,
    y2: 421.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2335,
    stopColor: "#0FC8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#38CAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66CCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_2",
    x1: 228.63,
    y1: 402.945,
    x2: 166.099,
    y2: 398.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1902,
    stopColor: "#3AEB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4903,
    stopColor: "#63EF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9023,
    stopColor: "#A4F562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4F759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_2",
    x1: 193.434,
    y1: 409.054,
    x2: 217.878,
    y2: 418.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#836DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1_2",
    x1: 214.269,
    y1: 431.959,
    x2: 178.719,
    y2: 431.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_2",
    x1: 173.485,
    y1: 410.667,
    x2: 177.614,
    y2: 430.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1902,
    stopColor: "#3AEB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4903,
    stopColor: "#63EF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9023,
    stopColor: "#A4F562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4F759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_2",
    x1: 180.49,
    y1: 414.714,
    x2: 187.026,
    y2: 403.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2335,
    stopColor: "#0FC8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#38CAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66CCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_2",
    x1: 124.509,
    y1: 447.145,
    x2: 262.54,
    y2: 447.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1717,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9464,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.443 398.426) scale(46.4223 46.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.134 452.956) scale(51 51.0183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1_2",
    x1: 244.962,
    y1: 456.079,
    x2: 238.305,
    y2: 467.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1717,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9464,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1_2",
    x1: 257.948,
    y1: 466.238,
    x2: 236.679,
    y2: 461.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.415 462.165) rotate(180) scale(4.05722 4.05868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0152,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3727,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1_2",
    x1: 283.376,
    y1: 473.998,
    x2: 271.617,
    y2: 493.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1433,
    stopColor: "#564BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#6152E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#4528C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4832,
    stopColor: "#4221A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5739,
    stopColor: "#401B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6263,
    stopColor: "#3F1982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8687,
    stopColor: "#5E239E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491C8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1_2",
    x1: 305.253,
    y1: 498.55,
    x2: 320.157,
    y2: 507.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0808,
    stopColor: "#3F1982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E239E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.358 498.292) rotate(180) scale(7.30274 7.30537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0152,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3727,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.019 410.598) rotate(167.474) scale(36.0929 22.017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.955 419.466) scale(64.9532 64.9766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(440.869 470.46) scale(30.6579 14.2917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(473.631 451.794) scale(30.6579 14.2917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(410 445.565) scale(30.6579 14.2917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1_2",
    x1: 446.76,
    y1: 453.575,
    x2: 492.712,
    y2: 453.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1_2",
    x1: 446.76,
    y1: 456.236,
    x2: 492.712,
    y2: 456.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1_2",
    x1: 493.22,
    y1: 449.197,
    x2: 493.228,
    y2: 449.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1_2",
    x1: 513.019,
    y1: 400.054,
    x2: 467.337,
    y2: 446.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.849 453.483) scale(29.3433 29.3539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1_2",
    x1: 488.643,
    y1: 424.594,
    x2: 454.494,
    y2: 458.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.099 432.341) scale(12.9078 12.9124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1_2",
    x1: 494.926,
    y1: 417.151,
    x2: 462.7,
    y2: 449.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.542 435.087) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1_2",
    x1: 446.76,
    y1: 445.755,
    x2: 492.712,
    y2: 445.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1_2",
    x1: 446.76,
    y1: 448.415,
    x2: 492.712,
    y2: 448.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1_2",
    x1: 493.22,
    y1: 441.376,
    x2: 493.228,
    y2: 441.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1_2",
    x1: 513.019,
    y1: 392.234,
    x2: 467.337,
    y2: 438.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.849 445.662) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1_2",
    x1: 488.643,
    y1: 416.773,
    x2: 454.494,
    y2: 451.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.099 424.521) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1_2",
    x1: 494.926,
    y1: 409.331,
    x2: 462.7,
    y2: 441.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.542 427.267) rotate(-71.221) scale(4.97132 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1_2",
    x1: 446.76,
    y1: 437.934,
    x2: 492.712,
    y2: 437.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1_2",
    x1: 446.76,
    y1: 440.595,
    x2: 492.712,
    y2: 440.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1_2",
    x1: 493.22,
    y1: 433.556,
    x2: 493.228,
    y2: 433.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1_2",
    x1: 513.019,
    y1: 384.413,
    x2: 467.337,
    y2: 430.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.849 437.842) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1_2",
    x1: 488.643,
    y1: 408.953,
    x2: 454.494,
    y2: 443.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.099 416.7) scale(12.9078 12.9124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1_2",
    x1: 494.926,
    y1: 401.51,
    x2: 462.7,
    y2: 433.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.542 419.446) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1_2",
    x1: 446.76,
    y1: 430.084,
    x2: 492.712,
    y2: 430.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1_2",
    x1: 446.76,
    y1: 432.745,
    x2: 492.712,
    y2: 432.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1_2",
    x1: 493.22,
    y1: 425.706,
    x2: 493.228,
    y2: 425.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1_2",
    x1: 513.019,
    y1: 376.563,
    x2: 467.337,
    y2: 422.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.849 429.991) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1_2",
    x1: 488.643,
    y1: 401.102,
    x2: 454.494,
    y2: 435.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.099 408.85) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1_2",
    x1: 494.926,
    y1: 393.66,
    x2: 462.7,
    y2: 426.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.542 411.596) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1_2",
    x1: 446.76,
    y1: 422.581,
    x2: 492.712,
    y2: 422.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1_2",
    x1: 446.76,
    y1: 425.242,
    x2: 492.712,
    y2: 425.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1_2",
    x1: 493.22,
    y1: 418.203,
    x2: 493.228,
    y2: 418.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1_2",
    x1: 513.019,
    y1: 369.061,
    x2: 467.337,
    y2: 415.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.849 422.489) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1_2",
    x1: 488.643,
    y1: 393.601,
    x2: 454.494,
    y2: 427.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.099 401.348) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1_2",
    x1: 494.926,
    y1: 386.158,
    x2: 462.7,
    y2: 418.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.542 404.094) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1_2",
    x1: 446.76,
    y1: 415.149,
    x2: 492.712,
    y2: 415.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1_2",
    x1: 446.76,
    y1: 417.81,
    x2: 492.712,
    y2: 417.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1_2",
    x1: 493.22,
    y1: 410.771,
    x2: 493.228,
    y2: 410.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1_2",
    x1: 513.019,
    y1: 361.628,
    x2: 467.337,
    y2: 407.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.849 415.057) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1_2",
    x1: 488.643,
    y1: 386.168,
    x2: 454.494,
    y2: 420.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.099 393.916) scale(12.9077 12.9123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1_2",
    x1: 494.926,
    y1: 378.726,
    x2: 462.7,
    y2: 411.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.542 396.661) rotate(-71.221) scale(4.97132 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1_2",
    x1: 446.76,
    y1: 407.613,
    x2: 492.712,
    y2: 407.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1_2",
    x1: 446.76,
    y1: 410.274,
    x2: 492.712,
    y2: 410.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1_2",
    x1: 493.22,
    y1: 403.235,
    x2: 493.228,
    y2: 403.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1_2",
    x1: 513.019,
    y1: 354.092,
    x2: 467.337,
    y2: 400.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.849 407.52) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1_2",
    x1: 488.643,
    y1: 378.632,
    x2: 454.494,
    y2: 412.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.099 386.379) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1_2",
    x1: 494.926,
    y1: 371.189,
    x2: 462.7,
    y2: 403.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.542 389.125) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1_2",
    x1: 383.128,
    y1: 447.345,
    x2: 429.08,
    y2: 447.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1_2",
    x1: 383.128,
    y1: 450.006,
    x2: 429.08,
    y2: 450.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1_2",
    x1: 429.589,
    y1: 442.967,
    x2: 429.597,
    y2: 442.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1_2",
    x1: 449.387,
    y1: 393.824,
    x2: 403.706,
    y2: 439.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(396.217 447.253) scale(29.3434 29.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1_2",
    x1: 425.011,
    y1: 418.364,
    x2: 390.863,
    y2: 452.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(414.468 426.111) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1_2",
    x1: 431.294,
    y1: 410.921,
    x2: 399.068,
    y2: 443.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(416.911 428.857) rotate(-71.221) scale(4.97134 10.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1_2",
    x1: 383.128,
    y1: 439.525,
    x2: 429.08,
    y2: 439.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1_2",
    x1: 383.128,
    y1: 442.186,
    x2: 429.08,
    y2: 442.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1_2",
    x1: 429.589,
    y1: 435.147,
    x2: 429.597,
    y2: 435.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1_2",
    x1: 449.387,
    y1: 386.004,
    x2: 403.706,
    y2: 431.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(396.217 439.432) scale(29.3434 29.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1_2",
    x1: 425.011,
    y1: 410.544,
    x2: 390.863,
    y2: 444.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(414.468 418.292) scale(12.9078 12.9124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1_2",
    x1: 431.294,
    y1: 403.101,
    x2: 399.068,
    y2: 435.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(416.911 421.037) rotate(-71.221) scale(4.97134 10.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1_2",
    x1: 383.128,
    y1: 431.705,
    x2: 429.08,
    y2: 431.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1_2",
    x1: 383.128,
    y1: 434.366,
    x2: 429.08,
    y2: 434.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1_2",
    x1: 429.589,
    y1: 427.327,
    x2: 429.597,
    y2: 427.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1_2",
    x1: 449.387,
    y1: 378.183,
    x2: 403.706,
    y2: 424.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(396.217 431.612) scale(29.3434 29.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1_2",
    x1: 425.011,
    y1: 402.724,
    x2: 390.863,
    y2: 437.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(414.468 410.471) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1_2",
    x1: 431.294,
    y1: 395.281,
    x2: 399.068,
    y2: 427.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(416.911 413.217) rotate(-71.221) scale(4.97134 10.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1_2",
    x1: 413.998,
    y1: 472.241,
    x2: 459.95,
    y2: 472.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1_2",
    x1: 413.775,
    y1: 467.863,
    x2: 413.783,
    y2: 467.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1_2",
    x1: 413.998,
    y1: 474.902,
    x2: 459.95,
    y2: 474.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1_2",
    x1: 460.459,
    y1: 467.863,
    x2: 460.466,
    y2: 467.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1_2",
    x1: 480.257,
    y1: 418.72,
    x2: 434.575,
    y2: 464.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(427.087 472.148) scale(29.3434 29.3539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1_2",
    x1: 455.881,
    y1: 443.26,
    x2: 421.733,
    y2: 477.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(445.338 451.007) scale(12.9078 12.9124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_1_2",
    x1: 462.164,
    y1: 435.817,
    x2: 429.938,
    y2: 468.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(447.781 453.753) rotate(-71.221) scale(4.97134 10.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(460.699 413.722) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1_2",
    x1: 458.584,
    y1: 368.66,
    x2: 293.728,
    y2: 204.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#84EFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#80F0AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4933,
    stopColor: "#51F8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#34FDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9242,
    stopColor: "#29FFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1_2",
    x1: 517.194,
    y1: 265.29,
    x2: 221.433,
    y2: 368.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#90ED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#35D5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4444,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5976,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7374,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7801,
    stopColor: "#5B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8495,
    stopColor: "#7374F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    stopColor: "#9A70F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(515.287 242.969) scale(54.2456 54.2651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.884 323.652) scale(95.6961 95.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(404.383 419.527) scale(22.7303 10.5961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_1_2",
    x1: 404.148,
    y1: 371.812,
    x2: 386.593,
    y2: 410.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#62BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7134,
    stopColor: "#5993FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_1_2",
    x1: 378.305,
    y1: 453.243,
    x2: 397.17,
    y2: 403.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_1_2",
    x1: 394.253,
    y1: 460.107,
    x2: 413.7,
    y2: 408.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_1_2",
    x1: 416.724,
    y1: 377.882,
    x2: 401.303,
    y2: 417.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#62BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7134,
    stopColor: "#5993FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_1_2",
    x1: 409.066,
    y1: 375.416,
    x2: 405.783,
    y2: 362.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7071,
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_1_2",
    x1: 427.629,
    y1: 382.154,
    x2: 412.209,
    y2: 421.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#62BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7134,
    stopColor: "#5993FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 435,
    height: 400,
    fill: "white",
    transform: "translate(97 114)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 435.013,
    height: 400,
    fill: "white",
    transform: "translate(97.1433 114)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesImage1);
export default __webpack_public_path__ + "static/media/circlesImage1.255ecd9436d1b310262e8bc113a741d0.svg";
export { ForwardRef as ReactComponent };